// Tiffany & Co. AI Lab mock pack — the demo's scripted questions and their
// full typed-block responses (block kinds → pages/Lab/blocks/index.js).
// Same authoring law as mock/lab/starbucks.js: readout first and VERDICT
// ONLY (the readout's `body` paragraph was dropped everywhere 2026-09-08,
// user call — don't author one back), CMO
// cultural-capital vocabulary (never engine internals), NAMED concepts,
// digit-free modelView, provenance observed / projected / measured. Pure
// data, no imports (scripts/dump-lab-fixture.js evaluates the file).
//
// What matters for Tiffany (user brief 2026-09-06): CELEBRITIES and
// COLLABORATIONS and the pieces they carry — the way the menu is Starbucks'
// engine — with Gen Z as the main crowd and "fandom by demographics": who is
// into what (diamonds, chains, the Lock). The three scripted questions are
// the archive returns (archive lab — "Which archival products should
// Tiffany bring back?" since 2026-10-06, user call, re-read from the
// Tiffany Silver Lab's analysis; it REPLACED "How to win GenZ through
// archive?", which had replaced the collab scout on 2026-09-07 — both
// former titles stay aliases), the content lab (2026-09-07 — it REPLACED the
// talent scout "Which celebrity should front our next campaign?", user
// call: which content resonates with Gen Z — the state of the house's
// content, the field's, how content carried cultural capital and how it
// carried with Gen Z, then the recommendation) and the experience lab
// (same day — it REPLACED the piece × generation audience lab, user call:
// where in culture the house should show up — sport, music, fashion,
// entertainment, design, the street — and what it should do there:
// intimate or public, New York or Paris, its own store or someone else's
// stage) — and, since 2026-10-06, a FOURTH: the fan lab "Who are
// Tiffany's biggest fans, per market?" (user call: "do the same for this
// question", on the Starbucks pack's `fans` type and `community` item
// type). Later the same day the user took the content and experience
// questions OFF the recommended chips (`featured: false` — the entries
// stay, reachable by a typed question, an alias or a briefing deep link),
// so the Lab opened on TWO chips: the archive lab and the fan lab — and,
// the same evening, a FIFTH question: the collab scout "Who should Tiffany
// collaborate with next?" (user call: "like we had collab questions for
// other brands, add for Tiffany but show Tiffany relevant data", on the
// UGG / Starbucks packs' `collab` type and item type), the THIRD chip —
// and, on 2026-10-07, a SIXTH: the market lab "How does Tiffany's reach,
// relevance and resonance differ per market?" (user call: "like we added
// other questions and answers for Tiffany add this one too … investigate
// first in detail then add response with insights", on the Estée pack's
// `geo` type), the FOURTH chip — and, on 2026-10-08, a SEVENTH: the silver
// question "Should we bring back silver and how?" (user call: "add one more
// mock question and response … the answer should be all charts and insights
// from the Silver Lab, mapped to our UI, all info and data the same"), on
// its OWN `revival` type ("Revival lab", THINK_STAGES.revival, a sterling
// grey in TYPE_ART) and the archive_reissue item type, the FIFTH chip — the
// pack carried `chips: 5` because Starters.FEATURED stays four for the
// other packs. On 2026-10-12 (user calls: "show just 3 questions in ai lab
// in ui, so comment out others, but keep code" and "put should we bring
// back silver question at the top") the silver question moved to the HEAD
// of the pack (chips follow pack order) and the archive lab and the market
// lab went OFF the chips with `featured: false` like the content and
// experience labs before them — `chips: 3`, every entry still in the pack.
//
// The silver question's basis (2026-10-08): the Tiffany Silver Lab artifact
// (v17, the standalone ~/Desktop/tiffany-silver-lab.html — its plan in
// docs/lab/tiffany-silver-lab-plan.md), carried section by section into
// THIRTY-FIVE blocks, every number the artifact's: the answer's three tiles;
// silver by generation (`cohorts` Gen Z 88 fast / Millennials 79 slow /
// Gen X 66 / Gen Alpha 58 / Boomers 41, the clock meaning on each row's
// drivers), the 2020 US silver purchases as one `stacks` row (51 / 26 / 13
// / 9 / 1), the market tiles (53%, 31%, +58%, −60M); the price `shift`
// (ten US silver prices before Oct 2025 → Oct → Jan 2026, the whole year's
// rise as the delta), the resale tiles (+30 / +27 / +21 / +30), the shelf
// words as `cohorts` (score = the count of the 93 plays naming the word;
// silver 4 with the four plays as drivers; Peretti / Return to Tiffany /
// Paloma / Knot one zero row), the lanes as pair-mode `pairs` (graded ×
// received, warmth the tail, the lane score against Pandora's in the
// note), the archive ranking `cohorts` of FOURTEEN houses (the archive
// lab shows ten of the same values), the landed returns as pair-mode
// `pairs` (reception × warmth, your Parrot watch in place), the CIQ by run
// as an interactive `trendCompare`; the eight customer themes as a `shift`
// (the direction as the value), the theme × generation `matrix` (the
// artifact's VOICE rows, cell notes authored inside its facts), the
// category × generation `matrix` (= the archive lab's), the product forms
// as `cohorts` (score = index points carried: 7.64 / 4.77 / 2.37 / 1.93);
// the audiences as four tiles (38% / 58% + the awareness and new-customer
// facts folding the artifact's audience table), search by quarter as an
// interactive `trendCompare` (21 quarters, 2021-Q3 → 2026-Q3); the ladder
// `stacks` (customers 34/41/21/4, sales 12/30/33/25 — the rung definitions
// in the customers row's note), rungs within each generation as a `matrix`
// (rows = 100; cell notes carry the generation's read), who each rung is
// made of as `stacks` (the artifact's own rounding: 4/20/33/23/20,
// 1/20/40/24/14 = 99, 0/12/43/32/13, 0/8/36/37/19), the silver-first
// split `pairs` (55 / 62 / 48 / 30), the 2026-08-10 community assessment
// as ONE `cohorts` of fourteen dimensions with the side as the role
// (crowd 100/100/100/90/80/80/80, brand 50/40/20×5), the five strategies
// as pair-mode `pairs` (yours × the board's, your play count the tail,
// fandom first: 65 / 43.2 on four plays); the candidate `quadrant` (= the
// archive lab's points with the Silver Lab's axis wording and the
// candidates' heat / fit / price / who in the notes), the candidates as
// pair-mode `pairs` (heat × fit, index points the tail, the charms inked
// low), the category order as a `shift` (1st–4th), the five rules as
// tiles ($500 / 1 a year / Heavier / Free / ≤ 25%); the lane math as
// pair-mode `pairs` (lane today × after one play, the points the tail:
// objects 21.9 → 44.0 +1.57, community 60 → 72 +1.03, collab +0.63,
// experience +0.39, content +0.28, archive +0.08), the cultural plan as
// FIVE `plays` on five item types (merch +1.6, community +1.0, collab
// +0.6, experience +0.4, content +0.3 — the artifact's own lane prices,
// `similar` rows the pack's measured precedents), the finance table, the
// three roads and the metric map as three `shift` blocks (revenue, the
// scenario's revenue, and fast / slow clock as the values), impact +3.9
// (the plan's sum — the artifact's "about +3 to +4"), and a digit-free
// modelView carrying the artifact's CALL (audience, categories, pieces,
// what to manage). NOT blocks: the artifact's SOURCES list (no renderer
// for an explainer list since 2026-09-16), which lives in the entry's own
// comment, and its collapsible "View the data" tables, whose rows are in
// the charts they explained. ADVISOR LEFT
// UNTOUCHED (see mock/advisor/tiffany.js): the plan's +1.6 is the archive
// slate's three editions (0.5 + 0.4 + 0.3) priced as one lane, and the
// +1.0 registry is the fan lab's three moves (0.4 + 0.4 + 0.3) as one —
// lane totals of picks already on the slate, not new picks.
//
// The market lab's basis (analysis 2026-10-07, the dev DB's regional
// record on the 2026-08-24 run — items carry a `region` NA / APAC / EMEA /
// GLOBAL and their pulses follow it; brand_metrics are GLOBAL only, so no
// market has a search or press series; scoring runs carry no region). The
// three units are the Culture Index's — reach, relevance, resonance — read
// on the record as: reach = the share of a market's plays with any read
// (plus the observed footprint), relevance = whether what you ran there is
// what that market answers (the houses' READ plays by shape per region),
// resonance = the net warmth of a read (the pulse's praise against its
// criticism). MEASURED, since April: Tiffany NA 18 plays, 16 pulsed, 6
// read (38%), peak when read 62.5, warmth 56.5 with NO criticism; APAC 17
// / 14 / 7 (50%), 57.1, warmth 43.0 — the summer's one criticism the two
// ION Orchard plays (café 45 / +7, reopening 40 / +7, criticism 40 and
// 33: "dazzles, but the food and the prices"); EMEA 2 / 2 / 0; GLOBAL 56
// episodic plays, 53 pulsed, 34 read (64%), 48.5, warmth 38.3. The eleven
// houses + Pandora: NA 131 plays read 75% / 59.8 / warmth 41.9, APAC 144
// / 60% / 58.8 / 45.9, EMEA 336 / 67% / 60.3 / 47.2, GLOBAL 403 / 61% /
// 57.8 / 42.8 — the `pairs` rows (Tiffany 38 / 50 / 0 / 64 against 75 /
// 60 / 67 / 61). What each region ANSWERED (the houses' read plays by
// shape, the `stacks` rows): NA stage 33 / room 24 / collab 17 / drop 16
// / content 10; APAC room 44 / drop 17 / content 17 / stage 16 / collab 5
// / archive 1; EMEA room 38 / stage 30 / collab 10 / content 10 / drop 10
// / archive 2; GLOBAL drop 42 / content 31 / collab 15 / archive 11 /
// stage 1. Warmth bands (the `arena`): the houses' read plays' net
// valence, median → upper quartile, NA 47 → 60, APAC 53 → 60, EMEA 53 →
// 60; the warmest house play per city as the ring (Gucci at the Met Gala
// +93, Chanel's Signes & Symboles Hong Kong +60, Dior Paradise Singapore
// +67, Dior Gold House Bangkok +73, Hermès' Skills Academy Japan +67,
// Hermès' Mystery at the Grooms Seoul +73, Saint Laurent's No. 223
// Beijing +67, Hermès' Horsescape +80); Tiffany's own reads as dots (NA:
// CFDA +73, the Knicks' night +73, the Garden Series 53 / 53, Origami 47,
// the Landmark 40; HK: Lee Gardens +80, Lee Gardens Three +60; Singapore:
// Sixteen Stone +53, ION +7 / +7; Bangkok: the Legacy evening +47, the
// wrap +47; Japan / Seoul / the mainland / Europe: nothing read). Strategy
// reception by region (the houses + Tiffany, avg peak of read plays
// carrying the tag): NA fandom 66.8 the best, scarcity and opacity 64.5;
// Tiffany tags fandom on 11% of its home plays, the houses 24%. OBSERVED
// (the fan lab's basis): sales Americas 44 / APAC 28 / Japan 15 / Europe
// 11, 72% of site visitors US, Jimin and ROSÉ the faces, the Sanlitun and
// Ginza flagships opened August 2026. PROJECTED: the three-unit `matrix`
// (US 86 / 46 / 78, Hong Kong + Singapore 64 / 72 / 60, Korea 40 / 74 /
// 72, Japan 70 / 38 / 50, mainland 52 / 42 / 42, Europe 28 / 22 / 30 —
// measured where there are reads, modelled on the market's facts where
// there are none), the `cohorts` index folding them with the Culture
// Index's weights (relevance ~72, reach ~17, resonance ~10: Hong Kong +
// Singapore 69, Korea 68, US 56, Japan 45, mainland 44, Europe 24), and
// the three moves — the faces on the Met steps +0.4 (relevance at home),
// the Blue Box Café at Old Bond Street +0.3 (reach in Europe), the café
// menu by the faces across the Asian rooms +0.3 (resonance in Asia) — all
// at or under the advisor's smallest archive pick, slate untouched. Field
// precedents in `similar` rows are measured effective pts from the run.
//
// The collab scout's basis (analysis 2026-10-06, the dev DB's 2026-08-24
// run + the Silver Lab's one collaboration rule). MEASURED: thirteen
// collabs on the shelf (nine with a brand, four with a person; one — the
// SAVA × Tiffany Soesanto capsule — a name confusion with an Indonesian
// influencer, kept in the count the artifact also uses), ten pulsed, six
// noticed (60%), average peak when noticed 56.7, over the pulsed ten 34.0
// (the artifact's lane row: 13 plays, grade 32.3, peak 34.0, read 60%).
// The reads: the CFDA designer award 75/+73 (NA), Netflix's Frankenstein
// narrative jewels 40 then 70/+67, Pharrell's Titan 0 on seven reads then
// 70/+67, Arsham's Eroded Penny Vessel 45 once, the League of Legends
// Crystal Rose leak 45 once, the Patek Nautilus 5990 35 and 25; the Disney
// Cruise necklace (nine reads), the Tiffany Blue Nautilus (four), RIMOWA
// (two) and the Supreme pearl necklace (one) read nothing; Beyoncé's
// RENAISSANCE Round Tag, the Steiff bear and SAVA are unpulsed. Grades:
// Arsham 42.7 the highest (creative involvement 80, execution 80 — the
// only person collab graded above 20 for the partner's hand), Beyoncé 39.7
// (tier 100, authenticity 100, involvement 20, execution 20), Frankenstein
// 39.4. Rubric averages, Tiffany / the eleven luxury houses / the board:
// creative involvement 35 / 64 / 50 (person collabs carry it), execution
// 34 / 55 / 34, collectible 15 / 32 / 27, subculture 19 / 32 / 33, limited
// 14 / 28 / 23, pulls new audience 6 / 18 / 17, unexpectedness 26 / 35 /
// 31, authenticity 43 / 43 / 37, dual-brand association 69 / 65 / 64 —
// the `pairs` rows. The houses' hit rates (the first `quadrant`; x = share
// of pulsed collabs with any read, y = average peak among those): Tiffany
// 60/57 (13), Pandora 64/53 (11), Louis Vuitton 89/66 (19), Hermès 91/62
// (12, all person), Dior 88/54 (11), Jacquemus 75/69 (12), Bottega 100/67
// (4), Prada 60/70 (5), Saint Laurent 67/55 (5), Valentino 67/46 (6),
// Armani 57/48 (14), Gucci 50/48 (9), Chanel 50/85 (4); the houses
// together 75%, the board 64% / 60. The seven `arena` shapes are the 545
// collabs classed by rubric and title (maker = person with involvement
// ≥60; face = person ≤40; fandom = brand with subculture ≥60 and
// collectible ≥40; cross-world = brand with high-low tension ≥60;
// heritage = brand with authenticity ≥60 and tension ≤20; story / patron
// by title), bands = median and upper-quartile base, `best` = the
// shape's top effective pts, `received` = its best presence (maker 100 —
// Ferrari's Luce by Jony Ive and Marc Newson; face 90; fandom 90; object
// 90; story 85; heritage 80; patron 75 = Tiffany's own CFDA read).
// Strategy tags on collabs: Tiffany 7 tags on 5 of 13 (aesthetic 43 /
// identity 43 / scarcity 14, fandom NONE), Pandora 9 on 8 of 11 (identity
// 67), the houses 161 (40 / 32 / 19 / fandom 9), the board 746 on 545 (42
// / 33 / 16 / 8); fandom-tagged collabs are the best received on the
// board (peak 64.2 when noticed; scarcity 63.4, aesthetic 61.2, identity
// 60.7). Pandora's shelf: ten of eleven a licence on a charm (Disney ×4,
// Star Wars, Marvel, Bridgerton, Toy Story), received 60–70, formulaic
// 67, effective 7–37. OBSERVED, not measured: Arsham a Tiffany partner
// since 2022; ROSÉ and Jimin the house's faces; the Larry O'Brien and
// Lombardi trophies made at the Rhode Island workshop; ring night at the
// Garden 2026-10-20; the 2023 Nike Air Force 1; Frieze New York in May.
// PROJECTED: the nine-partner ranking and the candidate map, and the three
// drops — Arsham's eroded Bone Cuff in silver +0.6 (= the artifact's own
// collab move, "one collaboration built on a Peretti form, with no logo
// tag", its collab lane room 0.63), ROSÉ's Lock in silver as her numbered
// edition +0.4 (the fan lab's Seoul registry opens on it), the Knicks'
// trophy pendant on ring night +0.3 (the experience lab's night) — the
// second and third smaller because the lane fills. The artifact prices
// ONE collab; the two behind it are this lab's enrichment, never a
// contradiction. The advisor slate is untouched: the lead ties its
// fourth-to-sixth picks (0.6) and is not listed. Field precedents in
// `similar` rows are measured effective pts (Vuitton × Singer Porsche
// 73.3, Nike × BTS 65.9, Jacquemus × Nike × FFF 67.1 …).
//
// The fan lab's basis (analysis 2026-10-06, the Tiffany Silver Lab
// artifact + the dev DB, same 2026-08-24 run; the rule from the user: the
// answer may ENRICH the artifact's data and never contradict it).
// OBSERVED: the last own filing's sales by region (Americas 44%,
// Asia-Pacific 28%, Japan 15%, Europe 11%), tiffany.com's visitors (71.8%
// US, 64.6% women, 25–34 the largest age group), the artifact's audience
// facts (the jewelry-brand rank by generation — Gen X and Millennials 1st,
// Gen Z 2nd behind Cartier, Boomers 4th; Gen X the most loyal generation;
// the brand women are most likely to buy for themselves), Jimin and ROSÉ as
// the house's faces. MEASURED (the dev DB's regional pulses, episodic
// types only): 85 of the 93 plays have a read — 53 tagged GLOBAL, 16 NA,
// 14 APAC, 2 EMEA, none in Korea; per city the average best read of the
// plays run there (`max(actuality)` per item, averaged — the archive
// ranking's metric): New York 23 (sixteen plays, six read: Knicks 80, CFDA
// 75, Garden Series 60/60, Origami 55, Landmark 45), Hong Kong 52 (Lee
// Gardens flagship + café 85/+80 — the best read outside the US — Lee
// Gardens Three 70, Hidden Garden unveiling 0), Singapore 38 (Sixteen
// Stone 65, ION café 45, reopening 40, Garden in Bloom 0), Bangkok 32
// (private evening 50, HardWear wrap 45, exhibition 0), Tokyo 0 (Ginza
// anniversary 0, Wonder 0; the Ginza opening unpulsed), the mainland 0
// (Sanlitun unpulsed), Milan 0 (the Devil Wears Prada window, "Lose
// Yourself in Love"); the Jimin campaign at 75/+80 is the WARMEST content
// (the Blue Book's summer pages also read 75, at +67 — never call it "the
// one" received piece); the 2026-08-10 community assessment (owned spaces
// 20, membership programme 20, resale depth 80–100, cross-community
// citation 100). The artifact called the Knicks play the best-received of
// the summer at 80/+73 until 2026-10-07, when it was softened to "among the
// best-received" because the DB's Timer and Lee Gardens both read 85; Lee
// Gardens is stated here as the best OUTSIDE the United States, the Knicks'
// night as the best AT HOME, so the pages never conflict. PROJECTED
// (modelled on the artifact's US ladder, which is copied as is): the
// market ladders (US 34/41/21/4 = the artifact's LAD; Japan 28/36/29/7,
// Hong Kong + Singapore 36/40/18/6, Korea 36/52/10/2, China 40/46/12/2,
// Europe 50/36/12/2), the fans-by-generation matrix (the US row derived
// from the artifact's GSH × rung shares: 1/17/41/27/14), the silver-first
// shares (US 56% = the artifact's ENTRY shares weighted by rung), the
// fan-depth index on the cohorts, and the three moves (+0.4 / +0.4 /
// +0.3 — the first steps of the artifact's +1.0 community lane: registry,
// hallmark dating, a house resale desk). Field precedents in `similar`
// rows are measured effective pts from the brands' runs (POP MART Molly
// 58.5, Miss Dior at South Coast Plaza 42.0, Uniqlo MoMA 37.4 …).
//
// Numbers + references are calibrated to the LIVE dev DB (2026-08-24 run):
// Tiffany CIQ 74.6, rank #10 of 32, +3.1 on the window — the biggest climb
// in the top ten. Cited precedents are REAL measured items on Tiffany's
// shelf: the Beyoncé RENAISSANCE Round Tag Necklace (strongest collab, 39.7
// pts), the "This is Tiffany" campaign with Jimin, Zoë Kravitz and Gal Gadot
// (the window's most-shared content, 30.0), Natalie Portman's HardWear
// films, the Bird on a Rock creations (the strongest plays on the shelf,
// 57.6), the HardWear building wrap in Thailand; merch is the weakest lane
// (product score 21.9).
//
// The archive lab's basis (analysis 2026-10-05/06, the Tiffany Silver Lab
// artifact, over the same 2026-08-24 run): archive re-issue is Tiffany's
// STRONGEST lane by volume — twelve plays since May, every one a Jean
// Schlumberger high-jewelry motif, a watch or a clock (Bird on a Rock ×5,
// Sixteen Stone ×2, the Paillonné enamel watch, Botanica, the 1893
// Astronomical Clock, the Union Square watch), the highest average launch
// grade of any brand on the board (49.5; the next luxury houses 27–38) and
// the lower half on reception: average peak presence 32.5 (per pulsed
// return, its best `actuality` read, averaged), 21st of the 32 brands with
// returns — the artifact said 23rd until 2026-10-07, when it was corrected to
// the dev DB re-check of 2026-10-06: 21st, tied with Red Bull (Gap 72.5, Valentino 55.8, Hermès 50.0, Uniqlo
// 45.6, Armani 45.0, Nike 40.8 … Prada 27.0, Chanel 10.0 — the `cohorts`
// rows, every value reproduced from the DB), the best read the Paradise
// Bird Parrot watch at 70. The 93 plays are the episodic types in the
// window (101 rows with the eight persistent assessments); silver is on
// four of them; Peretti / Return to Tiffany only inside the assessments. The returns that
// landed elsewhere are wearable pieces from the seventies to the
// two-thousands people owned or wanted (Gap's 1990s fragrances 90, the
// Vendetta franchise 90, Saint Laurent's Mombasa 80, Armani's Archivio
// 80, Air Jordan 11 80, Uniqlo's Pokémon 80, the Rockstud 75, Prada
// Re-Nylon 65, Hermès So Kelly 65). Silver is on 4 of the 93 plays read
// (Disney Cruise, Supreme and Beyoncé collabs carrying a tag, the Treasures
// exhibition); Elsa Peretti and Return to Tiffany on none. MEASURED: the
// stats and the brand ranking. OBSERVED, not measured: the resale record
// (the Bone Cuff +30% in a year, Bean pendants +27%, charm bracelets +21%,
// vintage searches up nearly 30%, Tiffany silver averages at a record), the
// three US silver price rises in twelve months, the heart tag toggle never
// discontinued ($800 / $1,150 today), the Peretti licence to 2032, the
// 2002–07 entry-line episode. PROJECTED (the artifact's modelled layer):
// the silver category × generation matrix, the eleven candidates' index
// points (Bone Cuff 1.2, Mesh 0.6, Gehry 0.5, Bottle 0.4, tag 0.4 as ONE
// numbered edition, Scorpion 0.3, Graffiti 0.3, Forge 0.2, Bean 0.1,
// Somerset/Atlas 0.1, charms 0.1 — the trap) drawn on the quadrant as an
// index with demand heat (resale, searches, what customers miss) and dot
// size the silver price, and the three priced plays (+1.2 / +0.6 / +0.5;
// the artifact's whole cultural plan is +3 to +4 with a collectors'
// registry, a collab and a workshop behind the objects). Field precedents
// in `similar` rows are other brands' measured reissues from the run
// (Ferrari 250 GTO 71.4, Nike Brazil 1998 kit 39.3, Prada Re-Nylon 37.9…).
// The content lab's old-vs-new play still rides "the heart tag's return" in
// November — here the tag's one numbered edition sits in the Bone Cuff's
// holiday window, so the two labs agree.
//
// The experience lab's basis (analysis 2026-09-07, same run): Tiffany's
// event lane reads 90.7 and its experience lane 80.7 on VOLUME —
// twenty-seven experience + event plays since April 21, sixteen of them in
// the house's own rooms (flagship and café openings in Hong Kong,
// Singapore, Tokyo, Beijing and Costa Mesa; the Landmark's bespoke
// experience; the Blue Book galas and the Schlumberger Summer Garden
// cocktails) — every rationale grades brand fit high and draw low ("no
// named attendees", "no queue"), seven of twenty-seven read when analysed
// (by the 2026-10-07 re-read twenty-four were pulsed and thirteen read),
// presence 30–85 with the Lee Gardens flagship and café the best-received
// at 85 and the Lee Gardens Three café at 70. The year's two
// public sport stages were played from the store: the Knicks' first title
// in fifty-three years, lifted with the Tiffany-made Larry O'Brien, became
// a lit building and a sixth-floor display (base 28.4, effective 7.0 by
// the run); the fourth consecutive US Open pop-up graded 34.1 as "a
// pleasant, branded stop" (fandom fit 0.3). Heritage exhibitions cool
// fastest (Tiffany Wonder Tokyo 30.7 → 5.4); entertainment tie-ins were
// windows (22–23). The field's experiences that carry are public crowds
// on someone else's stage — Red Bull Cliff Diving Mostar (base 46,
// presence 90, effective 71.4), Nike at Fanatics Fest 41.8, Uniqlo's MoMA
// Friday nights (presence 85, ΔCIQ 0.97), Coca-Cola's soda fountain at
// The Battery (presence 80) — while hospitality is the one stage where
// the house's own grades beat the field (Lee Gardens Three café 55.9
// against a hospitality ceiling of 31; LV's Gaggan 68.6 is the class
// max). The arena's bands are the field's typical (median) and ceiling
// (upper quartile) of graded strength per stage, its rings the class
// maxima, its dots Tiffany's own bases. Observed, not measured: NBA
// opening night 2026-10-20 at the Garden (the Knicks' ring and banner
// ceremony, LeBron's Sixers debut, national TV); the USTA renewal for
// 2026; Ginza's café; Paris couture week as the house's only Paris stage
// (Bird on a Rock: Love Birds); Place Vendôme as the rivals' street. The
// matrix and the city map are modeled indexes on that record. Field
// precedents in `similar` rows are measured effective pts from the run.
//
// The content lab's basis (analysis 2026-09-07, same run): Tiffany's
// content lane reads 92.9 — its second-strongest — on VOLUME: twenty-four
// pieces since April 22 (sixteen campaigns, six films, one editorial, one
// music video), median base 26.3, and no piece above 30 effective; the
// field's other content lanes of that size top out at 45–88. Seven of the
// twenty-four were pulsed when analysed, median presence 25 (the lowest of
// Tiffany's lanes); by the 2026-10-07 re-read fourteen carried a read (the
// Blue Book pages 65 and 75, Mikey Madison 65, Rosie 60 — the prose was
// re-pinned to those), and "This is Tiffany" with Jimin, Zoë Kravitz and
// Gal Gadot (base 33.3, presence 75, +80, reception 1.24, the only piece
// coded identity_signal 0.6) stays the WARMEST read and the only content
// with fandom faces — never "the only piece received".
// Natalie Portman fronts five pieces (bases 23–28, presence 25–50); the
// two highest bases are entertainment tie-ins (The Devil Wears Prada 2
// campaign 37.3 → 11.7 effective, the Frankenstein Cannes Gold Lion 36.0
// → 22.0). Strategy coding: aesthetic_innovation on eleven pieces at
// 0.4–0.6, identity_signal on two, fandom on NONE, and twelve pieces
// carry no strategy at all. The field's carrying content (effective pts
// on the run): Apple "Shot on iPhone" 88.4 (fandom 1.0 + aesthetic 1.0,
// presence 80), Bottega Veneta's RM (BTS) covers 77.3 (identity 0.8),
// Saint Laurent's FW26 campaign 68.3 (presence 80), Gucci × Ningning
// (aespa) 68.0, Dior's hand-drawn "The Story of A Miss" 50.1 (presence
// 90), Chanel × Gracie Abrams 48.9 (presence 80), Dior's Jimin
// #diorsummer27 posts 36.8 (identity 0.8, fandom 0.4); the largest content
// ΔCIQ this window are Hermès × Sarah Martinon's illustrated pages 2.38,
// Duolingo's "RIP Duo" 1.84, Aesop's Queer Library 1.75, Sephora's Olive
// Young edit 1.65, Pandora Wonders (Harry Lambert) 1.57; Pandora's twelve
// content pieces are unpulsed, max 38.7. The arena's bands are per-format
// typical (median) and ceiling (upper quartile) of graded strength across
// the board's 641 content items, hand-grouped by format; the radar's
// "your content" and "field" series are measured strategy fit, its "what
// Gen Z shares" series and the quadrant's Gen Z pull are modeled on the
// crowd-carried pieces above. Observed, not measured: Gen Z's 2026 feed
// (lo-fi and behind-the-scenes over polish, the hand-made as the
// counter-signal to machine images, creator-first discovery, "if it feels
// like an ad it is ignored"), TikTok's "new vs old Return to Tiffany" and
// charm-bracelet comeback discourse, Pandora's 2024 revival starting from
// a creator's clip, the Lock campaign with ROSÉ, Jimin, Nancy Ajram and
// Florence Pugh.

export const TIFFANY_LAB = {
  brand: "tiffany",
  name: "Tiffany & Co.",
  // the demo persona greeted on the Lab — every mock pack carries one
  person: "Alex",
  // THE WEEKLY ONE (2026-10-21, pages/Leaderboard/WeeklyOne): the week's
  // one priority, the silver lab under the entry's own words and type,
  // with a PREVIEW drawn from the answer's own blocks — the trend is the
  // Bone Cuff's resale price (+30% in a year, the first stats block; the
  // series the rise), the ring silver's share of the pieces US jewelers
  // sell (31%, the second), the bars "Silver by generation" (the modelled
  // response, 0–100). The overline's count is the pack's.
  weekly: {
    sources: 1874215,
    cards: [
      {
        entry: "silver-return",
        measured: "2026-10-14",
        preview: {
          trend: {
            value: "+30%",
            label: "Bone Cuff resale",
            series: [0, 6, 4, 10, 14, 12, 18, 22, 21, 27, 30],
          },
          ring: { value: 31, label: "Silver, share of pieces" },
          bars: {
            title: "Silver by generation",
            rows: [
              { label: "Gen Z", value: 88 },
              { label: "Millennials", value: 79 },
              { label: "Gen X", value: 66 },
            ],
          },
        },
      },
    ],
  },
  // THREE chips since 2026-10-12 (user call: "show just 3 questions in ai
  // lab in ui" — the archive and market labs went OFF the chips with
  // `featured: false`, their code and deep links kept; FIVE from 2026-10-08
  // to then). A pack-level count so Starbucks' four and UGG's three stand.
  chips: 3,
  entries: [
    {
      id: "silver-return",
      // the SEVENTH question (user call 2026-10-08: "add one more mock
      // question and response — Should we bring back silver and how? — the
      // answer all the charts and insights of the Silver Lab, mapped to our
      // UI, all info and data the same"): the Tiffany Silver Lab artifact
      // carried block by block, section by section, on its OWN question type
      // `revival` (TYPE_TAGS "Revival lab", THINK_STAGES.revival) and the
      // archive_reissue item type — the FIFTH chip when it joined, FIRST in
      // the pack and on the chips since 2026-10-12 (user call: "put should
      // we bring back silver question at the top"; chips follow pack order).
      // Every number is the artifact's; nothing here contradicts the archive
      // lab, the fan lab, the collab scout or the market lab, which read the
      // same artifact. Provenance per block: MEASURED = the dev DB's
      // 2026-08-24 run (the shelf words, the lanes, the archive ranking, the
      // landed returns, the CIQ by run, the product forms, the community
      // assessment of 2026-08-10, the strategies, the search series);
      // OBSERVED = public facts in the artifact's sources (your filings, the
      // owner's results, trade and resale reports, price trackers, consumer
      // surveys, reviews, traffic data); PROJECTED = the artifact's modelled
      // layer (the generation scores, the customer-theme and category
      // matrices, the audiences, the ladder and its generations, the
      // candidates' index points, the lane math, the plan, the finance).
      // The artifact's SOURCES section is not a block — the UI has no
      // renderer for an explainer list since 2026-09-16 — so it lives here:
      // the Cultural IQ engine over the 24 August 2026 window; Gemini on
      // Vertex AI with Search grounding (discovery and the fortnightly
      // reads); GDELT DOC 2.0 (Volume and Tone); Google Trends via SerpApi
      // (search interest); Yahoo Finance (market data); SEC EDGAR 10-Ks
      // fiscal 2004–2019 (silver's share of sales, average prices, Peretti's
      // share, sales by region); LVMH investor relations (watches and
      // jewelry revenue 2024 to H1 2026); the Tiffany press room (the trophy
      // workshop, the silver history); JCK (the owner's January 2026
      // remarks, AlixPartners' brand rank by generation, State of Fashion);
      // National Jeweler (LVMH results, the Bone Cuff anniversary, resale
      // highlights); Rapaport (the brand women most buy for themselves); The
      // RealReal Resale Report (record silver prices, price changes by piece,
      // vintage search growth); PurseBop (US silver prices before and after
      // each increase); The Fashion Law (the Peretti licence); Similarweb
      // (tiffany.com visitors by sex, age, country, August 2026); Statista
      // (awareness, ownership, loyalty among US jewelry owners); AlixPartners
      // (top jewelry brands by generation, October 2025); Bain and BCG (the
      // luxury customer base, the aspirational share, luxury by generation);
      // The Silver Institute (silver purchases by generation, the US jeweler
      // survey, fabrication); Trustpilot (quality, price, aftercare themes);
      // Reuters, Fortune, WWD, the WSJ, Kitco, Glossy and YPulse for dated
      // facts the companies do not report themselves. In the answer the
      // figures read as our own analysis ("on resale", "customer reviews"),
      // never by source name — the artifact's own rule.
      itemType: "archive_reissue",
      type: "revival",
      question: "Should we bring back silver and how?",
      aliases: [
        "should we bring back silver and how",
        "should tiffany bring back silver and how",
        "should we bring back silver",
        "should tiffany bring back silver",
        "should we bring silver back",
        "should tiffany bring silver back",
        "should we bring silver back and how",
        "how should we bring back silver",
        "how should tiffany bring back silver",
        "how do we bring back silver",
        "do we bring back silver",
        "bring back silver",
        "should we return to silver",
        "is it time to bring back silver",
      ],
      askedOn: "2026-10-08",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          // this readout was the first whose head LED with the question
          // (bold h1, the verdict as the light line under it — user call
          // 2026-10-09, from a reference crop, a `lead: "question"` opt-in);
          // every answer's head has that form since 2026-10-15
          verdict:
            "Yes, as design, not as the entry line: the Bone Cuff in front, Peretti's forms from $1,000, numbered editions behind them.",
        },
        {
          kind: "stats",
          insight:
            "Silver was about a third of your sales, four in five of the pieces you sold and the door most of your customers came in through; you have cut it by more than a third and pushed gold and high jewelry — which worked on price and closed that door. The demand did not leave, it moved to resale. The return that works is silver as design — Elsa Peretti's forms at $1,000 to $3,000 with numbered archive editions behind them — for Gen Z and Millennial women buying for themselves, with Gen X admirers paying full price first.",
          provenance: "projected",
          items: [
            {
              label: "Silver, share of sales",
              value: "<20%",
              hint: "from about 30% at acquisition, cut on purpose since 2021",
            },
            {
              label: "Bone Cuff resale",
              value: "+30%",
              hint: "resale price in a year, with your silver at a record",
            },
            {
              label: "By 2028, projected",
              value: "~$260M",
              hint: "net new revenue a year from an elevated return",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "The two generations that want silver most are the two a luxury house most needs to recruit: Gen Z wants it most and Millennials buy the most of it, while Gen X brings the money to pay full price on day one. Boomers are aware of you and are not the audience for this return.",
          title: "Silver by generation",
          provenance: "projected",
          note: "Each bar is a modelled score, 0 to 100, for how strongly a generation responds to silver jewelry — how much it wants it, looks for it and talks about it — not who buys the most today, which the next block shows. Almost no public source splits metal preference by generation, so the scores are modelled around the facts listed on each row. Fast clock: the response shows within weeks, in searches, resale and posts. Slow clock: over years, in repeat purchase and full-price sales. Tap a row for the evidence.",
          rows: [
            {
              id: "gen-z",
              label: "Gen Z",
              context: "finds it on resale",
              score: 88,
              role: "Wants it most",
              horizon: "short",
              drivers: [
                "Finds you through resale and vintage: 45% of Gen Z use resale to reach higher-end brands, and half of resale buyers are Gen Z and Millennials.",
                "Ranks you second among jewelry brands, behind Cartier.",
                "35% of 18 to 29 year olds name necklaces as the piece they most like to buy for themselves — rings lead for every other age group. More than a third cap their spend under $500.",
                "24% of Gen Z men bought jewelry for themselves in the past year, the highest of any generation of men.",
                "Chrome Hearts sells silver at $8,000 and above, never discounts, and is their proof that silver can be luxury.",
                "Fast clock: the response shows within weeks, in searches, resale and posts, and fades as quickly.",
              ],
            },
            {
              id: "millennials",
              label: "Millennials",
              context: "their first Tiffany was silver",
              score: 79,
              role: "Largest buyers today",
              horizon: "long",
              drivers: [
                "51% of US silver jewelry purchases — the largest share of any generation by a wide margin.",
                "The largest age group on tiffany.com is 25 to 34, and familiarity with you is highest among Millennials, at 72%.",
                "86% of 30 to 44 year olds have bought fine jewelry for themselves, the highest of any group; nearly one in five would spend $2,500 to $5,000 on themselves.",
                "Nostalgic for the heart tag, and turning resentful on price.",
                "Slow clock: the response shows over years, in repeat purchase and full-price sales, and it lasts.",
              ],
            },
            {
              id: "gen-x",
              label: "Gen X",
              context: "the Peretti admirers",
              score: 66,
              role: "First full-price buyers",
              horizon: "long",
              drivers: [
                "You are the top-ranked jewelry brand for Gen X, and Gen X is your most loyal generation.",
                "The second-largest buyers of silver jewelry, at 26% of purchases.",
                "Holds about a quarter of US household wealth — Peretti admirers with the money to pay full price. They buy gold as well.",
                "Slow clock: the response shows over years, in repeat purchase and full-price sales, and it lasts.",
              ],
            },
            {
              id: "gen-alpha",
              label: "Gen Alpha",
              context: "receives, does not buy",
              score: 58,
              role: "The gift recipient",
              horizon: "short",
              drivers: [
                "No public data exists on this generation's metal preference, spend or brands — this score is modelled.",
                "Receives jewelry more than buys it: charms, tags and first-jewelry gifts.",
                "Gen Z made a first luxury purchase at about 15, and this generation is expected to follow. Not a luxury buyer before 2030.",
                "Fast clock: the response shows within weeks, in searches, resale and posts, and fades as quickly.",
              ],
            },
            {
              id: "boomers",
              label: "Boomers",
              context: "aware, drifting",
              score: 41,
              role: "Highest awareness, lowest loyalty",
              horizon: "long",
              drivers: [
                "9% of US silver jewelry purchases.",
                "Ranks you fourth among jewelry brands, behind Kay and Zales.",
                "Holds about half of US household wealth, and more than a third cap what they spend on themselves under $500.",
                "Slow clock: the response shows over years, in repeat purchase and full-price sales, and it lasts.",
              ],
            },
          ],
        },
        {
          kind: "stacks",
          insight:
            "Half of all silver jewelry in the United States is bought by Millennials — the same generation that is your largest group of customers and the one that says most often it has been priced out. US jewelers add that the best opportunity in silver is women buying for themselves, aged 20 to 40.",
          title: "Who buys silver jewelry in the US",
          provenance: "observed",
          note: "Share of US silver jewelry purchases by generation. The data is from 2020 and is the only generational split of silver that exists; Gen Z has aged into spending since. Tap the row.",
          legend: [
            { key: "z", label: "Gen Z", color: "#8b7bff" },
            { key: "mill", label: "Millennials", color: "#4FC3F7" },
            { key: "x", label: "Gen X", color: "#94A3B8" },
            { key: "boom", label: "Boomers", color: "#FDE047" },
            { key: "older", label: "Older", color: "#A1A1AA" },
          ],
          rows: [
            {
              id: "us-silver-2020",
              label: "Silver purchases",
              sub: "United States, 2020",
              parts: [
                { key: "z", v: 13 },
                { key: "mill", v: 51 },
                { key: "x", v: 26 },
                { key: "boom", v: 9 },
                { key: "older", v: 1 },
              ],
              note: "Millennials 51, Gen X 26, Gen Z 13, Boomers 9, older buyers 1 — the only generational split of silver purchases that exists, measured in 2020. Gen Z has aged into spending since, so its share today is larger than this row shows.",
            },
          ],
        },
        {
          kind: "stats",
          insight:
            "Silver peaked as a trend call in 2024, and the call for 2026 is that jewelry gets chunkier, bolder and golder. The case for silver here rests on structure instead: record resale prices for your silver, a rising share of pieces at US jewelers, women buying for themselves, and the 60 million customers luxury has priced out.",
          provenance: "observed",
          items: [
            {
              label: "US jewelers, 2024",
              value: "53%",
              hint: "saw silver sales rise, by 20% on average",
            },
            {
              label: "Silver, share of pieces",
              value: "31%",
              hint: "of pieces sold at US jewelers, from 28% in 2022",
            },
            {
              label: "Bought for oneself",
              value: "+58%",
              hint: "jewelry self-purchase since 2021",
            },
            {
              label: "Luxury customers",
              value: "−60M",
              hint: "about 400M in 2022 to 340M in 2025: the aspirational buyer, priced out",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "Three increases on silver in about twelve months, on the pieces that were already the price complaint. The medium Bone Cuff in gold is $30,000, about thirteen times the silver cuff — and the heart tag toggle people ask you to bring back is still sold, at $800 for the bracelet and $1,150 for the necklace.",
          title: "Three price rises in a year",
          provenance: "observed",
          note: "United States prices, silver, before October 2025, in October 2025 and in January 2026; the move is the whole year's.",
          rows: [
            {
              label: "Bone Cuff, small",
              context:
                "$1,800 · $1,950 · $2,000 — before Oct 2025, Oct, Jan 2026",
              value: "$2,000",
              delta: 11.1,
              unit: "%",
              spark: [1800, 1950, 2000],
            },
            {
              label: "Bone Cuff, medium",
              context: "$2,100 · $2,250 · $2,300",
              value: "$2,300",
              delta: 9.5,
              unit: "%",
              spark: [2100, 2250, 2300],
            },
            {
              label: "Bone Cuff, large",
              context: "$2,800 · $2,950 · $3,000",
              value: "$3,000",
              delta: 7.1,
              unit: "%",
              spark: [2800, 2950, 3000],
            },
            {
              label: "Return to Tiffany heart tag bead bracelet",
              context: "$295 · $295 · $300",
              value: "$300",
              delta: 1.7,
              unit: "%",
              spark: [295, 295, 300],
            },
            {
              label: "Return to Tiffany full heart bracelet",
              context: "$400 · $440 · $475",
              value: "$475",
              delta: 18.8,
              unit: "%",
              spark: [400, 440, 475],
            },
            {
              label: "Return to Tiffany heart tag bracelet",
              context: "$625 · $675 · $700",
              value: "$700",
              delta: 12.0,
              unit: "%",
              spark: [625, 675, 700],
            },
            {
              label: "Return to Tiffany heart tag toggle bracelet",
              context: "$725 · $775 · $800",
              value: "$800",
              delta: 10.3,
              unit: "%",
              spark: [725, 775, 800],
            },
            {
              label: "Return to Tiffany heart tag toggle necklace",
              context: "$1,025 · $1,125 · $1,150",
              value: "$1,150",
              delta: 12.2,
              unit: "%",
              spark: [1025, 1125, 1150],
            },
            {
              label: "HardWear micro link bracelet",
              context: "$750 · $775 · $850",
              value: "$850",
              delta: 13.3,
              unit: "%",
              spark: [750, 775, 850],
            },
            {
              label: "HardWear small link bracelet",
              context: "$1,150 · $1,250 · $1,350",
              value: "$1,350",
              delta: 17.4,
              unit: "%",
              spark: [1150, 1250, 1350],
            },
          ],
        },
        {
          kind: "stats",
          insight:
            "The demand that left your store did not disappear; it moved to resale, where your silver trades at a record and the designs people pay the most for are the ones you have moved away from — a Peretti cuff, a Bean, a charm bracelet.",
          provenance: "observed",
          items: [
            {
              label: "Bone Cuff",
              value: "+30%",
              hint: "resale price, year on year",
            },
            {
              label: "Peretti Bean pendants",
              value: "+27%",
              hint: "resale price",
            },
            {
              label: "Charm bracelets",
              value: "+21%",
              hint: "resale price",
            },
            {
              label: "Vintage searches",
              value: "+30%",
              hint: "nearly, for your vintage silver — resale prices 'the highest they've ever been'",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "What you put into culture this summer was high jewelry, Schlumberger, diamonds and watches. Silver appears four times, and all three silver products are collaborations that carry a tag — Disney, Supreme, Beyoncé; nowhere in the plays we read is there a silver design story of your own, and Elsa Peretti and Return to Tiffany are never named.",
          title: "What your 93 plays are about",
          provenance: "measured",
          open: "silver",
          note: "A play is one thing you put into culture — a launch, a campaign, a collaboration, an event. We read 93 of yours between 21 April and 24 August 2026; each bar counts how many mention the word in their title, summary or attributes, so a play can count more than once. This describes the shelf we measured, and you did more than we read. Tap a row.",
          rows: [
            {
              id: "high-jewelry",
              label: "High jewelry, Blue Book",
              context: "the top of the house",
              score: 24,
              drivers: [
                "24 of the 93 plays read this summer name high jewelry or the Blue Book — the galas, the pages, the creations.",
              ],
            },
            {
              id: "schlumberger",
              label: "Schlumberger, Bird on a Rock",
              context: "the archive year's motif",
              score: 23,
              drivers: [
                "23 plays — Bird on a Rock alone came back five times; every archive return of the year is a Schlumberger motif, a watch or a clock.",
              ],
            },
            {
              id: "diamond",
              label: "Diamond",
              context: "the stone",
              score: 18,
              drivers: [
                "18 plays name a diamond — the Blue Book, Sixteen Stone, the engagement story.",
              ],
            },
            {
              id: "watch",
              label: "Watch, clock, timepiece",
              context: "the Parrot watch, the 1893 clock",
              score: 17,
              drivers: [
                "17 plays — the Paradise Bird Parrot watch is your best-read archive return at 70; the 1893 Astronomical Clock and the Union Square watch are in this count too.",
              ],
            },
            {
              id: "hardwear",
              label: "HardWear",
              context: "the chain line",
              score: 10,
              drivers: [
                "10 plays — the Bangkok building wrap, the Natalie Portman films, the campaign stills.",
              ],
            },
            {
              id: "gold",
              label: "Gold",
              context: "the metal you are pushing",
              score: 6,
              drivers: [
                "6 plays name gold — and the medium Bone Cuff in 18k is $30,000, about thirteen times the silver one.",
              ],
            },
            {
              id: "silver",
              label: "Silver",
              context: "three tagged collabs, one show",
              score: 4,
              role: "the metal in question",
              drivers: [
                "The Disney Cruise Line silver necklace — a collaboration, 23 April, graded 34.1 at launch, sold only on two cruise ships.",
                "The Supreme pearl necklace with a silver tag — a collaboration, 11 August, graded 26.7.",
                "Beyoncé's RENAISSANCE Round Tag Necklace in silver — a collaboration, 21 August, graded 39.7; too new to have a read, and already the second-largest contributor on the shelf at +0.82 index points.",
                "The Treasures of Tiffany museum exhibition — an event, 15 August — lists silver among historic works.",
                "Not one of the four is a silver design story of your own.",
              ],
            },
            {
              id: "platinum",
              label: "Platinum",
              context: "the engagement metal",
              score: 3,
              drivers: ["3 plays."],
            },
            {
              id: "lock",
              label: "Lock",
              context: "the faces' piece",
              score: 1,
              drivers: [
                "1 play — the Lock, in gold, is what Jimin and ROSÉ carry.",
              ],
            },
            {
              id: "titan",
              label: "Titan",
              context: "Pharrell's line",
              score: 1,
              drivers: [
                "1 play — Pharrell's Titan, read at 0 seven times before it read 70.",
              ],
            },
            {
              id: "unnamed",
              label: "Peretti, Paloma, the Knot",
              context: "Return to Tiffany too — never named",
              score: 0,
              drivers: [
                "No play this summer names Elsa Peretti, Return to Tiffany, Paloma Picasso or the Knot — the names live only in the persistent assessments of your brand codes, never in a play of their own.",
              ],
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Places are received best and objects are barely played: experiences lead on attention, and the objects lane holds three plays. Two lanes are your weak points on the index — objects at 21.9 of 100, and community at 60, the only lane where Pandora leads you (26th of 36 to your 10th) — and both are lanes a silver return fills naturally.",
          title: "How each kind of play was received",
          provenance: "measured",
          mode: "pair",
          a: { label: "Graded at launch", color: "#94A3B8" },
          b: { label: "Received after", color: "#4ADE80" },
          note: "A lane is a kind of play. Grade is how strong a play looked on the day it launched, 0 to 100; reception is how much it was noticed afterwards, 0 to 100 — the average of each play's best read. The tail is warmth, from −100 to +100. Under each lane: its plays and the share read above zero. Tap a row for the lane's score on the index against Pandora's.",
          rows: [
            {
              id: "experience",
              label: "Experience",
              sub: "8 plays · 86% read above zero",
              a: 39.8,
              b: 48.6,
              tail: "warmth +40",
              note: "Your best-received lane: average reception 48.6, and 86% of its plays were read above zero — the rooms, the cafés, the Landmark. Lane score on the index 80.7, against Pandora's 38.0.",
            },
            {
              id: "collab",
              label: "Collab",
              sub: "13 plays · 60% read",
              a: 32.3,
              b: 34.0,
              tail: "warmth +40",
              note: "Thirteen collaborations, six noticed, received at 34 on average — and all three silver products on your shelf sit here, each carrying a tag. Lane score 84.2, Pandora 74.1.",
            },
            {
              id: "archive",
              label: "Archive re-issue",
              sub: "12 plays · 67% read",
              a: 49.5,
              b: 32.5,
              tail: "warmth +45",
              note: "Graded highest of any lane at 49.5 and received at 32.5: twelve returns, every one high jewelry, a watch or a clock. Lane score 97.1 — full; Pandora has no archive play on its shelf.",
            },
            {
              id: "content",
              label: "Content",
              sub: "24 plays · 61% read",
              a: 26.3,
              b: 28.5,
              tail: "warmth +35",
              note: "Your biggest lane by count — twenty-four pieces — read at 28.5 on average, with the Jimin campaign the warmest thing on the shelf. Lane score 92.9, Pandora 68.7.",
            },
            {
              id: "capsule",
              label: "Capsule",
              sub: "14 plays · 50% read",
              a: 27.3,
              b: 27.9,
              tail: "warmth +46",
              note: "Fourteen capsules, half of them read, the warmest lane but one; the Timer at 85 is in here. Lane score 80.5, Pandora 73.7.",
            },
            {
              id: "event",
              label: "Event",
              sub: "19 plays · 31% read",
              a: 25.9,
              b: 18.1,
              tail: "warmth +55",
              note: "Nineteen events and fewer than a third read — the galas and exhibitions in your own rooms — but the warmest lane when they were: +55. Lane score 90.7, Pandora 53.4.",
            },
            {
              id: "objects",
              label: "Objects",
              sub: "3 plays · 33% read",
              a: 25.7,
              b: 6.7,
              tail: "warmth 0",
              tailLow: true,
              note: "Three plays, received at 6.7 and warm at zero — your emptiest lane on the index at 21.9, where Pandora sits at 52.6. An object people keep is exactly what a silver edition is.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Your returns are the strongest on paper and land in the lower half — 21st of the 32 brands with archive re-issues. Every one of the twelve is a piece almost nobody can own, such as the Paradise Bird Parrot Watch or a restored astronomical clock, and half the citations come from specialist media. The archive is being played to collectors of the unreachable.",
          title: "Archive returns, house by house",
          provenance: "measured",
          open: "tiffany",
          note: "Average peak reception of each brand's archive re-issues this year, 0 to 100 — how much a return was noticed after it landed, the best read per play averaged. Fourteen of the 32 brands with returns; your twelve had the highest average launch grade of any brand on the board, 49.5, where the next luxury houses sit at 27 to 38. Tap a row for what came back.",
          rows: [
            {
              id: "gap",
              label: "Gap",
              context: "1990s fragrances, the summer revival",
              score: 72.5,
              drivers: [
                "Two returns read at 90 and 80: the fragrances of the nineties and the clothes people wore with them — things a whole generation owned, back as they were.",
              ],
            },
            {
              id: "valentino",
              label: "Valentino",
              context: "Vendetta, the Rockstud",
              score: 55.8,
              drivers: [
                "The Vendetta franchise read at 90 and the Rockstud at 75 — a scent and a shoe people wanted back, not a museum piece.",
              ],
            },
            {
              id: "hermes",
              label: "Hermès",
              context: "the So Kelly re-edition",
              score: 50.0,
              drivers: [
                "A bag re-edited rather than re-shown, read at 65 — the house's illustrated pages carried the largest content lift on the board around it.",
              ],
            },
            {
              id: "uniqlo",
              label: "Uniqlo",
              context: "retro Pokémon returns",
              score: 45.6,
              drivers: [
                "A crowd's childhood on a T-shirt, read at 80 — the return that costs the least and lands with the most people.",
              ],
            },
            {
              id: "armani",
              label: "Giorgio Armani",
              context: "Archivio, the second re-edition",
              score: 45.0,
              drivers: [
                "A numbered archive capsule in its second season, read at 80 and warm — the edition as a rhythm rather than an anniversary.",
              ],
            },
            {
              id: "louis-vuitton",
              label: "Louis Vuitton",
              context: "the Murakami re-edition",
              score: 40.8,
              drivers: [
                "The Takashi Murakami twentieth-anniversary re-edition among its returns — a crowd's own decade brought back, read at 40.8 on average.",
              ],
            },
            {
              id: "nike",
              label: "Nike",
              context: "Jordan 11, the 2001 Air Force 1",
              score: 40.8,
              drivers: [
                "Two shoes brought back in their original molds, read at 80 and 75 — the faithfulness is the campaign.",
              ],
            },
            {
              id: "tiffany",
              label: "Tiffany & Co.",
              context: "Bird on a Rock ×5, watches, a clock",
              score: 32.5,
              own: true,
              role: "you",
              drivers: [
                "Twelve returns graded higher at launch than anyone's, received by a single trade write-up each and cooling within the month; the best read was the Paradise Bird Parrot watch at 70. The archive is being played to collectors of the unreachable.",
              ],
            },
            {
              id: "bottega-veneta",
              label: "Bottega Veneta",
              context: "the Lauren 1979 bag",
              score: 30.0,
              drivers: [
                "The Lauren 1979 bag as an archival reissue — a wearable icon, read at 30 on average.",
              ],
            },
            {
              id: "saint-laurent",
              label: "Saint Laurent",
              context: "the Mombasa bag returns",
              score: 30.0,
              drivers: [
                "One bag from the Tom Ford years, read at 80 and the warmest return on the board — the shape a generation of women remembers wanting.",
              ],
            },
            {
              id: "prada",
              label: "Prada",
              context: "the Re-Nylon backpack relaunch",
              score: 27.0,
              drivers: [
                "The 1984 backpack back in recycled nylon, read at 65 — a wearable icon re-made, with what changed said out loud.",
              ],
            },
            {
              id: "gucci",
              label: "Gucci",
              context: "the Horsebit 1955, as heritage",
              score: 24.0,
              drivers: [
                "The Horsebit 1955 bag highlighted as heritage design — read at 24 on average, the lower half of the board.",
              ],
            },
            {
              id: "dior",
              label: "Dior",
              context: "the lower half",
              score: 24.0,
              drivers: [
                "Returns read at 24 on average — level with Gucci, in the lower half of the board.",
              ],
            },
            {
              id: "chanel",
              label: "Chanel",
              context: "the Première Édition watch",
              score: 10.0,
              drivers: [
                "A faithful watch reissue, barely read — faithfulness alone is not reception when the piece was never a crowd's.",
              ],
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "The returns that land are wearable pieces from the 1970s to the 2000s that people owned or wanted — a bag, a sneaker, a fragrance. Your equivalents are your silver icons, and none of them is on the shelf we read.",
          title: "The returns that landed elsewhere",
          provenance: "measured",
          mode: "pair",
          a: { label: "Peak reception", color: "#60A5FA" },
          b: { label: "Warmth", color: "#FF9F43" },
          note: "The archive re-issues with the highest reception among the fashion, beauty and jewelry brands we track, with your best for comparison: how much each was noticed, 0 to 100, and how warm the reaction was, 0 to 100 here (none of these ran negative). Tap a row.",
          rows: [
            {
              id: "gap-fragrances",
              label: "1990s fragrances reissued",
              sub: "Gap",
              a: 90,
              b: 47,
              note: "Two fragrances of the nineties, read at 90 — a whole generation owned them, and they came back as they were.",
            },
            {
              id: "valentino-vendetta",
              label: "Vendetta fragrance franchise",
              sub: "Valentino",
              a: 90,
              b: 53,
            },
            {
              id: "saint-laurent-mombasa",
              label: "Mombasa bag returns",
              sub: "Saint Laurent",
              a: 80,
              b: 80,
              note: "The warmest return on the board — the Tom Ford-era shape a generation of women remembers wanting.",
            },
            {
              id: "armani-archivio",
              label: "Archivio second re-edition",
              sub: "Giorgio Armani",
              a: 80,
              b: 73,
            },
            {
              id: "nike-jordan-11",
              label: "Air Jordan 11 Space Jam",
              sub: "Nike",
              a: 80,
              b: 73,
            },
            {
              id: "gap-summer",
              label: "1990s summer clothing revival",
              sub: "Gap",
              a: 80,
              b: 73,
            },
            {
              id: "uniqlo-pokemon",
              label: "Retro Pokémon returns",
              sub: "Uniqlo",
              a: 80,
              b: 60,
            },
            {
              id: "valentino-rockstud",
              label: "Rockstud returns",
              sub: "Valentino",
              a: 75,
              b: 67,
            },
            {
              id: "nike-af1",
              label: "Air Force 1, 2001 mold",
              sub: "Nike",
              a: 75,
              b: 73,
            },
            {
              id: "tiffany-parrot",
              label: "Paradise Bird Parrot Watch",
              sub: "Tiffany & Co. — your best",
              a: 70,
              b: 60,
              note: "Your best-received return of the year, read at 70 and warm at +60 — a high-jewelry watch almost nobody can own, received by the trade. Every return that beat it is something a crowd once wore.",
            },
            {
              id: "prada-renylon",
              label: "Re-Nylon backpack relaunch",
              sub: "Prada",
              a: 65,
              b: 67,
            },
            {
              id: "hermes-so-kelly",
              label: "So Kelly re-edition",
              sub: "Hermès",
              a: 65,
              b: 33,
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "You are not in trouble: you gained 19 points over the summer, rank 10th of 36, and the tone of your mentions has been positive every month since May 2025, with capital — the slower layer of the index — up from 55.6 to 62.3 over the same runs. You have no reputation problem. You have a reach problem among people who are not high-jewelry clients, and silver is how those people used to reach you.",
          title: "Your Cultural IQ, run by run",
          provenance: "measured",
          interactive: true,
          note: "Cultural IQ is our 0 to 100 index of how much a brand matters in culture right now, at each fortnightly run from May to August 2026. Scrub the line for a run's value.",
          series: [
            {
              key: "ciq",
              label: "Cultural IQ",
              color: "#4ADE80",
              points: [
                { d: "2026-05-04", v: 55.56 },
                { d: "2026-05-18", v: 59.75 },
                { d: "2026-06-01", v: 64.47 },
                { d: "2026-06-15", v: 68.2 },
                { d: "2026-06-29", v: 68.54 },
                { d: "2026-07-13", v: 70.53 },
                { d: "2026-07-27", v: 70.83 },
                { d: "2026-08-10", v: 71.48 },
                { d: "2026-08-24", v: 74.6 },
              ],
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "They love the designs and resent the price, the quality and the care. One fact worth stating plainly: the heart tag toggle was never discontinued — 'bring it back' is a complaint about price and visibility. This is a partial reading of the conversation, from reviews, posts, resale data and trade coverage; we could not read every forum and video thread in full.",
          title: "What customers are saying",
          provenance: "observed",
          note: "Eight themes from 2024 to 2026, each with its evidence and the direction of the feeling.",
          rows: [
            {
              label: '"Tiffany is discontinuing silver"',
              context:
                "social posts within days of the January 2026 remarks; searches asking whether silver is being discontinued · resentful, grieving",
              value: "Grieving",
            },
            {
              label: "Return to Tiffany nostalgia",
              context:
                "fashion press saying 'everyone's searching for it again'; Ariana Grande in the chain-link necklace · a memory for Millennials, a vintage find for Gen Z",
              value: "Warm",
            },
            {
              label: "Demand moved to resale",
              context:
                "record silver prices and rising vintage searches on resale · positive toward the designs, away from the boutique",
              value: "Positive",
            },
            {
              label: "Price",
              context:
                "three US increases on silver in about twelve months; a review average of 1.6 of 5 from 860 reviews",
              value: "Resentful",
            },
            {
              label: "Quality",
              context:
                "reviews, 2025–26: a $300 pendant 'snapped in half'; bracelets tarnishing and not restoring",
              value: "Negative",
            },
            {
              label: "Aftercare",
              context:
                "a $125 minimum repair fee; silver polishing is charged while gold cleaning is free · reads as second-class treatment",
              value: "Second-class",
            },
            {
              label: "Elsa Peretti",
              context:
                "the Bone Cuff on Rosie Huntington-Whiteley, Zoë Kravitz and Alexa Chung; features on high-street lookalikes · the exception to all of the above",
              value: "Admired",
            },
            {
              label: "What people miss",
              context:
                "charms and charm bracelets, Gehry, Somerset mesh, the original Atlas, mini Open Heart sizes",
              value: "Wistful",
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "The complaints are about how you treat silver — its price, its weight, its care; the affection is for the designs. Peretti is the one subject every paying generation agrees on, which is why the return should lead with her forms and fix the care — and why a cheaper tag would answer the wrong complaint.",
          title: "Who says what, by generation",
          provenance: "projected",
          note: "How strongly each generation voices each theme, 0 to 100 — synthesised from the themes above and from who each source reaches. Tap a cell for the read.",
          cols: ["Gen Alpha", "Gen Z", "Millennials", "Gen X", "Boomers"],
          rows: [
            {
              label: "Nostalgia for the heart tag",
              cells: [
                {
                  v: 10,
                  note: "Too young to remember the tag — it reaches them as a gift.",
                },
                {
                  v: 62,
                  note: "Gen Z meets the tag as a Y2K vintage find — warm, and second-hand.",
                },
                {
                  v: 92,
                  note: "Loudest among Millennials, for whom the tag was the first piece of real jewelry. The feeling is warm, and it is aimed at a piece you still sell.",
                },
                {
                  v: 55,
                  note: "A piece they gave as a gift as often as they wore it.",
                },
                { v: 30, note: "Quiet — the tag was never theirs." },
              ],
            },
            {
              label: "Resentment on price",
              cells: [
                { v: 5, note: "Not a buyer yet." },
                {
                  v: 58,
                  note: "Sees the rises and buys the design second-hand instead.",
                },
                {
                  v: 84,
                  note: "Millennials remember the bracelet at $175 and see it at $700. This is the generation that names 'unjustified price increases' most often, and the one a silver return has to win back first.",
                },
                {
                  v: 52,
                  note: "Can pay, and says so less; the complaint is the third rise in a year.",
                },
                {
                  v: 40,
                  note: "More than a third cap what they spend on themselves under $500.",
                },
              ],
            },
            {
              label: "Quality and aftercare",
              cells: [
                { v: 5, note: "No piece old enough to tarnish." },
                {
                  v: 40,
                  note: "Fewer pieces owned, so fewer to complain about — the 'thin' review is theirs.",
                },
                {
                  v: 70,
                  note: "Voiced by the people who own the most silver and have owned it longest. Paid polishing against free gold cleaning is the detail they quote.",
                },
                {
                  v: 62,
                  note: "The long-held pieces: tarnish that will not restore, a $125 minimum repair.",
                },
                {
                  v: 55,
                  note: "The longest-held pieces, and the care they expected from a house.",
                },
              ],
            },
            {
              label: "Pull toward resale and vintage",
              cells: [
                { v: 8, note: "Not yet buying anywhere." },
                {
                  v: 90,
                  note: "Gen Z's way in. They are positive about the designs and buy them outside the boutique — the love is there and the sale is not.",
                },
                {
                  v: 74,
                  note: "Vintage searches up nearly 30% — the tag they owned once, found again second-hand.",
                },
                {
                  v: 48,
                  note: "Sells on resale more than it buys there — the pieces leaving their drawers are the supply.",
                },
                { v: 20, note: "Rarely." },
              ],
            },
            {
              label: "Admiration for Peretti",
              cells: [
                { v: 5, note: "Unknown to them." },
                {
                  v: 76,
                  note: "The Bone Cuff on Zoë Kravitz and Alexa Chung; searches for it more than doubled in a year.",
                },
                {
                  v: 72,
                  note: "The self-purchase piece at $2,000 to $3,000 — the step up from the Bean they own.",
                },
                {
                  v: 86,
                  note: "Gen X leads it: the admirers who knew the cuff the first time and pay full price. The one theme strong in three generations and negative in none — the reason the Bone Cuff carries the return.",
                },
                { v: 50, note: "Admired more than bought." },
              ],
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Cuffs and pendants are strong with Gen Z, Millennials and Gen X at the same time, and no other category is — that is why the Bone Cuff leads and pendants follow. Rings are Gen Z's own category. Charms score well only with the youngest, at the lowest price, and are the category most likely to cheapen your house.",
          title: "Silver categories by generation",
          provenance: "projected",
          note: "Rows are silver jewelry categories, columns generations. Each cell is a modelled score, 0 to 100, for how strongly that generation responds to that category in silver — from what each age group buys for itself, searches on resale and wore the first time. Tap a cell for the read.",
          cols: ["Gen Alpha", "Gen Z", "Millennials", "Gen X", "Boomers"],
          rows: [
            {
              label: "Cuffs and bangles",
              cells: [
                {
                  v: 20,
                  note: "Too large and too costly for a gift to a child.",
                },
                {
                  v: 84,
                  note: "The Bone Cuff is the resale piece of the moment — searches more than doubled in 2024, the price up 30% in 2025. Strong, a step behind necklaces and rings for this group.",
                },
                {
                  v: 78,
                  note: "The self-purchase piece at $2,000 to $3,000 — inside the range one in five of this generation says it would spend on itself.",
                },
                {
                  v: 74,
                  note: "The Peretti admirers: they knew the cuff the first time and can pay full price on day one.",
                },
                { v: 46, note: "Admired more than bought." },
              ],
            },
            {
              label: "Chain and link bracelets",
              cells: [
                {
                  v: 45,
                  note: "A first-bracelet gift, at the edge of what you should sell here.",
                },
                {
                  v: 80,
                  note: "HardWear and the toggle chain, worn stacked — carried by men as well.",
                },
                {
                  v: 76,
                  note: "The heart tag bracelet they owned once, wanted back heavier.",
                },
                { v: 58, note: "Moderate — worn, seldom sought." },
                { v: 38, note: "Low." },
              ],
            },
            {
              label: "Pendants and necklaces",
              cells: [
                { v: 62, note: "The classic first-jewelry gift." },
                {
                  v: 82,
                  note: "Necklaces are this generation's first choice of piece to buy for itself — the only age group where they beat rings.",
                },
                {
                  v: 80,
                  note: "Bean, Open Heart and the toggle necklace — your most-owned silver.",
                },
                {
                  v: 66,
                  note: "Steady — the gift they give as often as the piece they wear.",
                },
                {
                  v: 52,
                  note: "The strongest silver category for this generation, and still modest.",
                },
              ],
            },
            {
              label: "Rings — stacking, signet",
              cells: [
                { v: 30, note: "Sizes change too fast." },
                {
                  v: 86,
                  note: "The highest cell on the grid: stacked and signet rings, for women and men, under $500.",
                },
                { v: 68, note: "Solid, behind bracelets and pendants." },
                { v: 50, note: "Gold is the ring metal for this group." },
                { v: 30, note: "Low." },
              ],
            },
            {
              label: "Earrings",
              cells: [
                { v: 40, note: "Studs as a gift after a first piercing." },
                { v: 70, note: "Good, undistinctive — bought everywhere." },
                { v: 66, note: "Good, undistinctive." },
                { v: 60, note: "Mesh and Bean earrings hold up here." },
                { v: 44, note: "Moderate." },
              ],
            },
            {
              label: "Charms and tags",
              cells: [
                {
                  v: 78,
                  note: "The highest score for this generation, and the reason charms are a trap — the youngest buyer at the lowest price.",
                },
                {
                  v: 72,
                  note: "Charm bracelets are up 21% on resale — wanted as vintage, which is different from wanting them new.",
                },
                {
                  v: 70,
                  note: "Nostalgia for the charm bracelet of the two-thousands.",
                },
                { v: 40, note: "Low." },
                { v: 28, note: "Low." },
              ],
            },
            {
              label: "Sculptural — mesh, bottle, belt",
              cells: [
                { v: 8, note: "No fit." },
                {
                  v: 62,
                  note: "Growing through resale — the Mesh scarf necklace is tipped next.",
                },
                { v: 64, note: "The step up from the pendant." },
                {
                  v: 72,
                  note: "Their category — the only one where Gen X leads every other generation.",
                },
                {
                  v: 48,
                  note: "Admired by those who remember the seventies originals.",
                },
              ],
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "The pieces people can wear do the most work: core jewelry icons look the least impressive at launch and carry the most of your standing in culture — more than high jewelry and watches together. Silver icons would join the group that already earns its place.",
          title: "What your plays were about, by form",
          provenance: "measured",
          note: "The 93 plays sorted by the product at their centre — by keyword, so this is a classification. The bar is the index points each group carried on 24 August: how much of your Cultural IQ it held. Under each form: its plays and their average launch grade. Tap a row for how each was received.",
          rows: [
            {
              id: "core-icons",
              label: "Core jewelry icons",
              context: "32 plays · graded 27",
              score: 7.64,
              role: "carries the most",
              drivers: [
                "HardWear, Lock, Titan, Sixteen Stone, the tags, the necklaces — thirty-two plays graded 27.2 on average at launch, the lowest of the four groups.",
                "Received at 28.4 on average and warm at +40 — and they carried 7.64 index points on 24 August, more than high jewelry and watches together.",
              ],
            },
            {
              id: "high-jewelry-form",
              label: "High jewelry",
              context: "29 plays · graded 34",
              score: 4.77,
              drivers: [
                "Twenty-nine plays graded 34.1 at launch, received at 28.3, warm at +41 — the Blue Book's crowd answers, and it is a small crowd.",
                "4.77 index points carried.",
              ],
            },
            {
              id: "watches-form",
              label: "Watches and clocks",
              context: "17 plays · graded 36",
              score: 2.37,
              drivers: [
                "Seventeen plays with the highest launch grade of any group, 36.1, received at 26.5 and warm at +44.",
                "2.37 index points carried — the strongest on paper, the second-least on the index.",
              ],
            },
            {
              id: "no-product",
              label: "No product",
              context: "a place, a face, your name",
              score: 1.93,
              drivers: [
                "Fifteen plays with nothing to buy at their centre — a room, a face, the house's name — graded 29.5, received at 31.8, warm at +38.",
                "1.93 index points carried.",
              ],
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "These are the same people at two points in time: a Millennial woman who bought a silver piece at 25 is the brand fan who buys gold at 40. If you stop recruiting the first, you cannot keep producing the second. The audience for a silver return is Gen Z and Millennial women buying for themselves, with Gen X Peretti admirers as the first full-price buyers and men a smaller fourth group.",
          title: "The four audiences",
          provenance: "projected",
          open: "biggest",
          note: "Four readings of who you reach, each a share of 100 — of customers, of sales, of US jewelry owners, of new US customers — so the bars are shares, not one scale. Tap a row for the evidence behind it. The artifact's four tiles, carried as one list so the facts under each stay readable on a phone (2026-10-09).",
          rows: [
            {
              id: "biggest",
              label: "Biggest audience",
              context: "38% of customers — Millennial women, US",
              score: 38,
              role: "Buying for themselves, or bought for",
              drivers: [
                "Millennial women in the US are 38% of your customers, buying for themselves or being bought for.",
                "25 to 34 is the largest age group on tiffany.com; 65% of visitors are women, 72% are in the US.",
                "72% of Millennials are familiar with you, the highest of any generation.",
                "You are the brand women are most likely to buy for themselves.",
              ],
            },
            {
              id: "most-valuable",
              label: "Most valuable audience",
              context: "58% of sales from a quarter of customers",
              score: 58,
              role: "Gen X and older Millennial brand fans",
              drivers: [
                "A quarter of your customers — Gen X and older Millennial brand fans and superfans — bring 58% of sales.",
                "Gen X ranks you first among jewelry brands and is your most loyal generation.",
                "Engagement jewelry is about a quarter of sales; across luxury, 2% of customers make about 40% of spend.",
                "Your high jewelry tripled in four years.",
              ],
            },
            {
              id: "awareness",
              label: "Awareness",
              context: "85% of US jewelry owners",
              score: 85,
              role: "Known by nearly all, owned by three in ten",
              drivers: [
                "85% of US jewelry owners know you; 46% like you, 29% own a piece, 24% would buy again.",
                "35% of women would buy a piece of yours for themselves.",
                "Familiarity is 61% overall and 72% among Millennials.",
              ],
            },
            {
              id: "new-under-40",
              label: "New customers under 40",
              context: "62% of new US customers, 2021–22",
              score: 62,
              role: "The door that is closing",
              drivers: [
                "62% of your new US customers in 2021–22 were under 40.",
                "Jewelry-brand rank by generation: Gen X and Millennials 1st, Gen Z 2nd, Boomers 4th.",
                "16.8M Instagram followers at 1.72% engagement.",
              ],
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "Fewer people are looking for you than at any time in five years, even after this summer's recovery — about half as many as in 2021. Sales per customer rose while the number of people curious about your house fell by about half; your biggest audience is drifting out of reach, and it is the one that feeds the most valuable.",
          title: "Search interest in you, by quarter",
          provenance: "measured",
          interactive: true,
          note: "How much people searched for you each quarter since mid-2021, on a 0 to 100 scale. Scrub the line for a quarter's value.",
          series: [
            {
              key: "search",
              label: "Search interest",
              color: "#60A5FA",
              points: [
                { d: "2021-07-01", v: 64.8 },
                { d: "2021-10-01", v: 63.8 },
                { d: "2022-01-01", v: 45.7 },
                { d: "2022-04-01", v: 42.6 },
                { d: "2022-07-01", v: 42.8 },
                { d: "2022-10-01", v: 53.4 },
                { d: "2023-01-01", v: 54.2 },
                { d: "2023-04-01", v: 48.2 },
                { d: "2023-07-01", v: 45.0 },
                { d: "2023-10-01", v: 70.4 },
                { d: "2024-01-01", v: 60.8 },
                { d: "2024-04-01", v: 57.2 },
                { d: "2024-07-01", v: 55.1 },
                { d: "2024-10-01", v: 55.5 },
                { d: "2025-01-01", v: 41.9 },
                { d: "2025-04-01", v: 44.0 },
                { d: "2025-07-01", v: 38.5 },
                { d: "2025-10-01", v: 33.4 },
                { d: "2026-01-01", v: 21.5 },
                { d: "2026-04-01", v: 27.8 },
                { d: "2026-07-01", v: 39.3 },
              ],
            },
          ],
        },
        {
          kind: "stacks",
          insight:
            "A quarter of your customers bring more than half of the sales, and the other three quarters are where that quarter comes from. Product fans are the largest rung at 41 in 100 — someone who loves one piece — and for most of your history that piece was silver.",
          title: "The fan ladder",
          provenance: "projected",
          note: "Every 100 of your US customers who bought in the last three years sorted onto four rungs, then the share of sales each rung brings. Basis: 29% of US jewelry owners own a piece of yours and 24% would buy again; engagement jewelry is about a quarter of sales; across luxury 2% of customers make about 40% of spend, softened here because your base is broader than a pure luxury house. Tap a row.",
          legend: [
            { key: "occ", label: "Occasion buyers", color: "#94A3B8" },
            { key: "prod", label: "Product fans", color: "#60A5FA" },
            { key: "brand", label: "Brand fans", color: "#4ADE80" },
            { key: "coll", label: "Superfans", color: "#FF9F43" },
          ],
          rows: [
            {
              id: "customers",
              label: "Customers",
              sub: "every 100 of the last three years",
              parts: [
                { key: "occ", v: 34 },
                { key: "prod", v: 41 },
                { key: "brand", v: 21 },
                { key: "coll", v: 4 },
              ],
              note: "Thirty-four occasion buyers bought once, for a gift or a milestone — the blue box was the point, and there was no return visit. Forty-one product fans love one design — the heart tag, the Bone Cuff, a T bracelet, their own ring — buy again inside that line and know the piece better than your house. Twenty-one brand fans own pieces from several collections, visit your stores, follow the house and know the designers by name. Four superfans are high-jewelry clients and collectors who hunt vintage, know the hallmarks and bring other people in.",
            },
            {
              id: "sales",
              label: "Sales",
              sub: "the share each rung brings",
              parts: [
                { key: "occ", v: 12 },
                { key: "prod", v: 30 },
                { key: "brand", v: 33 },
                { key: "coll", v: 25 },
              ],
              note: "The quarter at the top — brand fans and superfans — brings 58% of the sales; the four superfans in a hundred bring a quarter on their own. The product fan's 30% is the second-largest share, and it is where silver did its work.",
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Depth comes with age: the share of brand fans and superfans rises with every generation up to Gen X — 16% of Gen Z, 28% of Millennials, 32% of Gen X. Gen Z is the most product-fan-heavy generation, which is the stage where a single silver piece does its work.",
          title: "Rungs within each generation",
          provenance: "projected",
          note: "Five generations down the side with their share of all your customers, four rungs across. Each cell is the share of that generation on that rung, and each row adds to 100. Tap a cell for the generation's read.",
          cols: ["Occasion buyers", "Product fans", "Brand fans", "Superfans"],
          rows: [
            {
              label: "Gen Alpha (2%)",
              cells: [
                {
                  v: 70,
                  note: "Gift recipients: their Tiffany is a tag or a pendant someone gave them. Almost none are brand fans yet, which is normal at this age.",
                },
                {
                  v: 26,
                  note: "A quarter already love the one piece they were given — the first rung a gift can reach.",
                },
                {
                  v: 4,
                  note: "Almost none are brand fans yet, which is normal at this age.",
                },
                { v: 0, note: "None — not a luxury buyer before 2030." },
              ],
            },
            {
              label: "Gen Z (18%)",
              cells: [
                {
                  v: 38,
                  note: "Bought once, often as a gift — the supply for the rungs above.",
                },
                {
                  v: 46,
                  note: "The most product-fan-heavy generation: nearly half love one piece, often found second-hand. They are the supply for the rungs above.",
                },
                {
                  v: 14,
                  note: "Few have had the years or the money to become brand fans — 16% are brand fans or superfans.",
                },
                {
                  v: 2,
                  note: "The rare young collector, hunting vintage silver.",
                },
              ],
            },
            {
              label: "Millennials (38%)",
              cells: [
                {
                  v: 29,
                  note: "The gift and the milestone — the engagement ring's generation.",
                },
                {
                  v: 43,
                  note: "The largest group, and the one where the ladder works as designed: a first silver piece in their twenties, a second collection in their thirties.",
                },
                {
                  v: 24,
                  note: "One in four is now a brand fan — the heart-tag buyer of twenty-five who came back for gold at forty.",
                },
                {
                  v: 4,
                  note: "The collectors of the generation — 28% of Millennials are brand fans or superfans.",
                },
              ],
            },
            {
              label: "Gen X (26%)",
              cells: [
                {
                  v: 30,
                  note: "Bought once — a gift given as often as a piece worn.",
                },
                {
                  v: 38,
                  note: "Product fans of the Peretti pieces they knew the first time.",
                },
                {
                  v: 26,
                  note: "The deepest generation: a third are brand fans or superfans, the highest share of any, and they hold the Peretti pieces.",
                },
                {
                  v: 6,
                  note: "The highest superfan share of any generation — 32% of Gen X are brand fans or superfans.",
                },
              ],
            },
            {
              label: "Boomers (16%)",
              cells: [
                {
                  v: 42,
                  note: "Mostly occasion buyers — the gift, the anniversary.",
                },
                { v: 36, note: "Product fans of one long-owned piece." },
                {
                  v: 17,
                  note: "Brand fans of long standing, fewer than in Gen X.",
                },
                {
                  v: 5,
                  note: "The superfans here are established high-jewelry clients.",
                },
              ],
            },
          ],
        },
        {
          kind: "stacks",
          insight:
            "Millennials are the largest group on every rung. Brand fans and superfans are mostly Millennials and Gen X, and Gen Z is concentrated among product fans — the people at the top of the ladder today were the young silver buyers of the 1990s and 2000s.",
          title: "Who each rung is made of",
          provenance: "projected",
          note: "The same numbers turned around: each rung as a bar, coloured by the generations in it. Rounded shares, so a row may miss a point. Tap a row.",
          legend: [
            { key: "alpha", label: "Gen Alpha", color: "#FF7A52" },
            { key: "z", label: "Gen Z", color: "#8b7bff" },
            { key: "mill", label: "Millennials", color: "#4FC3F7" },
            { key: "x", label: "Gen X", color: "#94A3B8" },
            { key: "boom", label: "Boomers", color: "#FDE047" },
          ],
          rows: [
            {
              id: "occasion",
              label: "Occasion buyers",
              sub: "34 in 100 customers",
              parts: [
                { key: "alpha", v: 4 },
                { key: "z", v: 20 },
                { key: "mill", v: 33 },
                { key: "x", v: 23 },
                { key: "boom", v: 20 },
              ],
              note: "The one rung where Boomers hold a fifth — the gift and the anniversary — and the only rung where Gen Alpha registers at all.",
            },
            {
              id: "product-fans",
              label: "Product fans",
              sub: "41 in 100 customers",
              parts: [
                { key: "alpha", v: 1 },
                { key: "z", v: 20 },
                { key: "mill", v: 40 },
                { key: "x", v: 24 },
                { key: "boom", v: 14 },
              ],
              note: "Two in five are Millennials and one in five Gen Z — the rung a single silver piece makes, and the supply for everything above it.",
            },
            {
              id: "brand-fans",
              label: "Brand fans",
              sub: "21 in 100 customers",
              parts: [
                { key: "alpha", v: 0 },
                { key: "z", v: 12 },
                { key: "mill", v: 43 },
                { key: "x", v: 32 },
                { key: "boom", v: 13 },
              ],
              note: "Three quarters Millennials and Gen X — the young silver buyers of the 1990s and 2000s, a decade or two on. Gen Z is an eighth of this rung, and will be more once it has had the years.",
            },
            {
              id: "superfans",
              label: "Superfans",
              sub: "4 in 100 customers",
              parts: [
                { key: "alpha", v: 0 },
                { key: "z", v: 8 },
                { key: "mill", v: 36 },
                { key: "x", v: 37 },
                { key: "boom", v: 19 },
              ],
              note: "Gen X and Millennials in equal measure, then the Boomer high-jewelry clients. Nearly a third of this rung started with a silver piece.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "About half of today's brand fans and nearly a third of the superfans started with a silver piece. Cutting silver cuts the supply of future brand fans, and the effect shows five to ten years later, when those customers would have come back for gold — the 2007 warning about later milestones, seen from the other end.",
          title: "The metal each rung came in through",
          provenance: "projected",
          mode: "split",
          a: { label: "Silver first", color: "#9AA6B2" },
          b: { label: "Gold or diamonds first", color: "#D4A72C" },
          note: "Share of each rung whose first piece from you was silver, against the share that came in through gold or diamonds. Tap a row.",
          rows: [
            {
              id: "occasion-entry",
              label: "Occasion buyers",
              sub: "bought once",
              a: 55,
              b: 45,
              note: "More than half came in through a silver gift — the blue box with a tag or a pendant in it — and most never came back.",
            },
            {
              id: "product-entry",
              label: "Product fans",
              sub: "love one piece",
              a: 62,
              b: 38,
              note: "The most silver of any rung: nearly two in three product fans started with a silver piece, and for many of them that piece is still the one they love.",
            },
            {
              id: "brand-entry",
              label: "Brand fans",
              sub: "love the house",
              a: 48,
              b: 52,
              note: "About half of today's brand fans started with a silver piece — the heart-tag buyer of twenty-five who came back for gold. Stop making the first and you stop making the second.",
            },
            {
              id: "superfan-entry",
              label: "Superfans",
              sub: "collect, bring others in",
              a: 30,
              b: 70,
              note: "Nearly a third of the collectors and high-jewelry clients at the top of the ladder came in through silver — and the collectors among them hunt vintage silver still.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "The collectors exist and you give them nowhere to stand: our assessment describes a multi-generational collector base discussing vintage silver authentication on forums you do not own. Everything the crowd supplies scores 80 or more, averaging 90; everything you would have to build scores 20 to 50, averaging 27. The fans are already organised around old silver.",
          title: "What the fandom is built on",
          provenance: "measured",
          note: "Our community assessment of 10 August 2026 scores you from 0 to 100 on each dimension — split here into what the crowd supplies on its own and what only you can build. Where the assessment gave a range, the bar shows the middle. Tap a row for what the dimension measures.",
          rows: [
            {
              id: "citation",
              label: "Cross-community citation",
              context: "the crowd's side",
              score: 100,
              role: "The crowd supplies it",
              drivers: [
                "How often your pieces come up in conversations that are not about you — fashion, weddings, vintage, sport.",
              ],
            },
            {
              id: "inbound",
              label: "Collaborator inbound pull",
              context: "the crowd's side",
              score: 100,
              role: "The crowd supplies it",
              drivers: [
                "How much other brands and artists want to work with you, without being asked.",
              ],
            },
            {
              id: "signaling",
              label: "Membership signaling",
              context: "the crowd's side",
              score: 100,
              role: "The crowd supplies it",
              drivers: [
                "How clearly owning a piece of yours tells other people something about the wearer.",
              ],
            },
            {
              id: "resale-depth",
              label: "Resale market depth",
              context: "the crowd's side",
              score: 90,
              role: "The crowd supplies it",
              drivers: [
                "How large and active the second-hand market for your pieces is — scored eighty to a hundred; the bar shows the middle.",
              ],
            },
            {
              id: "advocacy",
              label: "Organic advocacy",
              context: "the crowd's side",
              score: 80,
              role: "The crowd supplies it",
              drivers: [
                "How often customers recommend you without being prompted or paid.",
              ],
            },
            {
              id: "posts",
              label: "Unsolicited post volume",
              context: "the crowd's side",
              score: 80,
              role: "The crowd supplies it",
              drivers: [
                "How much people post about you on their own, with no campaign behind it.",
              ],
            },
            {
              id: "retention",
              label: "Member retention",
              context: "the crowd's side",
              score: 80,
              role: "The crowd supplies it",
              drivers: [
                "How long customers stay with you once they have bought.",
              ],
            },
            {
              id: "rituals",
              label: "Community rituals",
              context: "your side",
              score: 50,
              role: "Only you can build it",
              drivers: [
                "Recurring moments your customers share — a date, an event, a tradition the house hosts. Scored forty to sixty; the bar shows the middle.",
              ],
            },
            {
              id: "owned-engagement",
              label: "Owned channel engagement",
              context: "your side",
              score: 40,
              role: "Only you can build it",
              drivers: [
                "How much your customers interact on channels you run yourself, beyond following.",
              ],
            },
            {
              id: "owned-spaces",
              label: "Owned community spaces",
              context: "your side",
              score: 20,
              role: "Only you can build it",
              drivers: [
                "Places, online or physical, where your customers can gather and that you own.",
              ],
            },
            {
              id: "programme",
              label: "Membership programme",
              context: "your side",
              score: 20,
              role: "Only you can build it",
              drivers: [
                "Whether there is a programme a customer can belong to, and how much it gives them.",
              ],
            },
            {
              id: "progression",
              label: "Status progression",
              context: "your side",
              score: 20,
              role: "Only you can build it",
              drivers: [
                "Whether a customer can visibly rise within your world over time — tiers, access, recognition.",
              ],
            },
            {
              id: "barrier",
              label: "Barrier to entry",
              context: "your side",
              score: 20,
              role: "Only you can build it",
              drivers: [
                "How much a newcomer has to know, do or own before they count as one of yours.",
              ],
            },
            {
              id: "exclusivity",
              label: "Community exclusivity",
              context: "your side",
              score: 20,
              role: "Only you can build it",
              drivers: [
                "How much being inside your community feels different from being outside it.",
              ],
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Fandom is the strategy you use least and the one that is received best, at about twice the attention of anything else you do. A product fan's love for one piece is a fandom, and you have not yet made a play for it; a silver return aimed at the people who already love the Bone Cuff or the heart tag would be the first.",
          title: "The five strategies behind the plays",
          provenance: "measured",
          mode: "pair",
          a: { label: "Your reception", color: "#60A5FA" },
          b: { label: "The board's", color: "#B388FF" },
          note: "Every play is tagged with the strategy it uses. Aesthetic innovation is a new look; identity signal is something worn to say who you are; scarcity is a limited run; opacity is mystery and closed doors; fandom is a play made for people who already love something — a team, a city, a ritual. Reception is the average peak read of your plays carrying the tag against the whole board's; the tail is how many of your plays carry it. Tap a row for the warmth.",
          rows: [
            {
              id: "fandom",
              label: "Fandom",
              sub: "for people who already love something",
              a: 65.0,
              b: 43.2,
              tail: "4 plays",
              note: "The least-used strategy and the best received by a wide margin — reception 65 against the board's 43, warmth +47 against +23. The four plays: the Knicks' title night lighting the flagship (80, +73), the two Blue Box Café flagships in Hong Kong and Singapore, and the US Open pop-up. None of them is a product.",
            },
            {
              id: "identity",
              label: "Identity signal",
              sub: "worn to say who you are",
              a: 37.6,
              b: 39.0,
              tail: "21 plays",
              note: "Close to the board on attention and warmer — +30 against +25. HardWear and the tags live here; a silver return adds to this strategy naturally.",
            },
            {
              id: "aesthetic",
              label: "Aesthetic innovation",
              sub: "a new look",
              a: 31.3,
              b: 40.2,
              tail: "47 plays",
              note: "Half of everything on your shelf. Received below the board's average for the same strategy — 31 against 40, warmth +25 against +23 — because most of it is high jewelry seen by few.",
            },
            {
              id: "scarcity",
              label: "Scarcity",
              sub: "limited runs",
              a: 28.2,
              b: 39.4,
              tail: "14 plays",
              note: "Your scarcity is one-of-a-kind high jewelry, received at 28 against the board's 39 and warm at +22. The numbered archive editions in this plan are scarcity at a price people can reach.",
            },
            {
              id: "opacity",
              label: "Opacity",
              sub: "mystery, closed doors",
              a: 13.3,
              b: 40.5,
              tail: "9 plays",
              note: "The lowest reception of the five in our reads — 13, a third of the board's level, warm at +12. Your private client events are built to stay private.",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "The top right corner belongs to Elsa Peretti: the Bone Cuff is the only piece that is both wanted now and worth real index — about +1.2 of the plan's +4 — because the objects, content, collaboration and workshop moves can all be built on this one form, and it is already in your stores. The heart tag has the most demand and scores only as one numbered edition; charms are wanted, cheap and worth almost nothing on the index — the way you got into trouble in 2002.",
          title: "Eleven silver candidates",
          provenance: "projected",
          open: "bone-cuff",
          wLabel: "price index",
          x: {
            label: "Index points it adds",
            low: "few",
            high: "many",
            hint: "its share of the plan's +4 at landing — the lanes it opens and the strategy it carries",
          },
          y: {
            label: "Demand heat",
            low: "quiet",
            high: "wanted now",
            hint: "resale prices, searches and what customers say they miss",
          },
          quadrants: {
            tr: "Bring it back",
            tl: "Wanted — not a line",
            br: "For the collectors",
            bl: "Leave it",
          },
          note: "Dot size is the silver price. Haloed dots are the four returns that lead the plan; hollow ones are on the counter today; the rest are recommended behind them, and the charms are the trap. The scores are our judgement from the evidence in the sources. Tap a dot for the read.",
          points: [
            {
              id: "bone-cuff",
              label: "Elsa Peretti Bone Cuff · 1970",
              short: "Bone Cuff",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 94,
              y: 92,
              w: 61,
              status: "recommended",
              note: "The lead — about +1.2 index points, a third of the plan on its own, because the objects, content, collaboration and workshop moves can all be built on this one form; demand heat 92, elevation fit 95, silver $2,000 to $3,000, carried by Gen Z, Millennials and Gen X. Already sold; what is missing is a silver-first campaign and new expressions — the 2020 and 2024 anniversary pushes led with colour, pavé and gold.",
            },
            {
              id: "mesh",
              label: "Elsa Peretti Mesh · 1975",
              short: "Mesh",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 70,
              y: 78,
              w: 64,
              status: "recommended",
              note: "Second, at +0.6 — the anchor of the collector registry and the second object in the content lane; heat 78, fit 92, silver $1,500 to $4,000, carried by Gen X and Millennials. The scarf necklace and the earrings, tipped as the next Peretti piece to rise on resale.",
            },
            {
              id: "gehry",
              label: "Frank Gehry Torque and Fish · 2006",
              short: "Gehry",
              era: "The Gehry years",
              color: "#60A5FA",
              x: 64,
              y: 70,
              w: 53,
              status: "recommended",
              note: "The first numbered return, +0.5 — it opens the objects lane, your emptiest, as the first edition with scarcity people can reach; heat 70, fit 88, silver $1,200 to $2,500, carried by Millennials and Gen X. Discontinued and traded on resale; the rights sit with the Gehry side.",
            },
            {
              id: "heart-tag",
              label: "Return to Tiffany heart tag toggle · the 1997 edition",
              short: "Heart tag",
              era: "The Y2K years",
              color: "#4FC3F7",
              x: 56,
              y: 95,
              w: 40,
              status: "recommended",
              note: "The most demand on the list — heat 95 — and the most fandom; +0.4 as ONE numbered edition in a heavy gauge, hallmarked with the year, in the holiday window, and nothing as a volume line. Fit 45, silver $900 to $1,200, carried by Millennials and Gen Z. The toggle was never discontinued; 'bring it back' is a complaint about price.",
            },
            {
              id: "bottle",
              label: "Elsa Peretti Bottle pendant · 1969",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 54,
              y: 64,
              w: 42,
              note: "+0.4 — the pendant door at an elevated price, for the generation that buys necklaces first, and the object the youngest buyer keeps; heat 64, fit 86, silver $900 to $1,400, carried by Gen Z and Millennials. It brings Gen Z into the community lane.",
            },
            {
              id: "scorpion",
              label: "Elsa Peretti Scorpion and Snake · 1970s",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 46,
              y: 60,
              w: 80,
              note: "+0.3 — statement pieces, numbered: scarcity for collectors in the objects lane; heat 60, fit 90, silver $2,500 to $6,000, carried by Gen Z and the collectors.",
            },
            {
              id: "graffiti",
              label: "Paloma Picasso Graffiti · 1983",
              era: "The Picasso era",
              color: "#F472B6",
              x: 45,
              y: 54,
              w: 39,
              note: "+0.3 — the third numbered edition in the objects lane, after Gehry and the tag; heat 54, fit 72, silver $500 to $1,500, carried by Millennials and Gen Z.",
            },
            {
              id: "forge",
              label: "Tiffany Forge and Makers · 2023",
              era: "In line today",
              color: "#94A3B8",
              x: 36,
              y: 50,
              w: 61,
              status: "current",
              note: "+0.2 — a new audience in the community lane: men buying for themselves, the 35% of your site's visitors who are men, and the generation of men that buys jewelry for itself most; heat 50, fit 74, silver $1,000 to $4,000. Not a return — on the counter already.",
            },
            {
              id: "bean",
              label: "Elsa Peretti Bean and Open Heart · 1970s",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 22,
              y: 84,
              w: 27,
              status: "current",
              note: "+0.1 — the trust repair: hold the price, raise the weight and the finish. It moves reviews and trust, not the index, and is recommended for that reason; heat 84, fit 60, silver $300 to $700, carried by all generations.",
            },
            {
              id: "somerset",
              label: "Somerset mesh and the original Atlas · 1990s",
              era: "The house lines",
              color: "#2DD4BF",
              x: 20,
              y: 48,
              w: 31,
              note: "+0.1 — the bench: little on the index on its own; heat 48, fit 58, silver $400 to $900, carried by Millennials and Gen X.",
            },
            {
              id: "charms",
              label: "Charms and charm bracelets · 2000s",
              era: "The Y2K years",
              color: "#4FC3F7",
              x: 14,
              y: 80,
              w: 20,
              note: "The trap, +0.1 at most: high demand (heat 80) at the lowest price (silver $150 to $400, fit 22) for the youngest buyer — Gen Alpha and Gen Z. An entry line is read as an entry line: the index credits objects people keep and an identity signal, and the crowding costs you in the community lane. This is the 2002 problem again, when you raised silver prices on purpose because the entry line was crowding your stores.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Ranked by what each piece does for your Cultural IQ first and for revenue second: Peretti's forms carry most of the index, the tag earns one numbered edition, Bean and Open Heart move trust rather than the index, and charms — high demand at the lowest price for the youngest buyer — are the 2002 problem again, when you raised silver prices on purpose because the entry line was crowding your stores.",
          title: "Each candidate, scored",
          provenance: "projected",
          mode: "pair",
          a: { label: "Demand heat", color: "#FF9F43" },
          b: { label: "Elevation fit", color: "#60A5FA" },
          note: "Demand heat, 0 to 100, is how much people want the piece now — from resale prices, searches and what customers say they miss. Elevation fit, 0 to 100, is how well it holds a price above $500 and reads as design; it sets the price rule for each piece. The tail is the index points the piece adds at landing — its share of the plan's +4. Tap a row.",
          rows: [
            {
              id: "cand-cuff",
              label: "Elsa Peretti Bone Cuff",
              sub: "1970 · silver $2,000–3,000",
              a: 92,
              b: 95,
              tail: "+1.2 pts",
              note: "The lead. Already sold; what is missing is a silver-first campaign and new expressions — the 2020 and 2024 anniversary pushes led with colour, pavé and gold. Carried by Gen Z, Millennials and Gen X; it carries the objects, content, collaboration and workshop moves in one form, on the strategy you are received best for: fandom.",
            },
            {
              id: "cand-mesh",
              label: "Elsa Peretti Mesh",
              sub: "1975 · silver $1,500–4,000",
              a: 78,
              b: 92,
              tail: "+0.6 pts",
              note: "Second. The scarf necklace and the earrings, tipped as the next Peretti piece to rise on resale — the anchor of the collector registry and the second object in the content lane. Carried by Gen X and Millennials.",
            },
            {
              id: "cand-gehry",
              label: "Frank Gehry Torque and Fish",
              sub: "2006 · silver $1,200–2,500",
              a: 70,
              b: 88,
              tail: "+0.5 pts",
              note: "The first archive edition — discontinued and traded on resale; it opens the objects lane, your emptiest, as the first numbered edition with scarcity people can reach. The rights sit with the Gehry side. Carried by Millennials and Gen X.",
            },
            {
              id: "cand-bottle",
              label: "Elsa Peretti Bottle pendant",
              sub: "1969 · silver $900–1,400",
              a: 64,
              b: 86,
              tail: "+0.4 pts",
              note: "The pendant door at an elevated price, for the generation that buys necklaces first — the object the youngest buyer keeps, bringing Gen Z into the community lane. Carried by Gen Z and Millennials.",
            },
            {
              id: "cand-tag",
              label: "Heart tag toggle, 1997 edition",
              sub: "1969 / 1997 · silver $900–1,200",
              a: 95,
              b: 45,
              tail: "+0.4 pts",
              note: "One numbered edition in a heavy gauge, hallmarked with the year — the highest demand on the list, kept to an edition so it does not become a volume line. As one edition it scores in the objects lane; as a volume line it would score nowhere. Carried by Millennials and Gen Z.",
            },
            {
              id: "cand-scorpion",
              label: "Elsa Peretti Scorpion and Snake",
              sub: "1970s · silver $2,500–6,000",
              a: 60,
              b: 90,
              tail: "+0.3 pts",
              note: "Statement pieces, numbered — scarcity for collectors in the objects lane. Carried by Gen Z and the collectors.",
            },
            {
              id: "cand-graffiti",
              label: "Paloma Picasso Graffiti",
              sub: "1983 · silver $500–1,500",
              a: 54,
              b: 72,
              tail: "+0.3 pts",
              note: "The third numbered edition in the objects lane. Carried by Millennials and Gen Z.",
            },
            {
              id: "cand-forge",
              label: "Tiffany Forge and Makers, men's",
              sub: "2023 · silver $1,000–4,000",
              a: 50,
              b: 74,
              tail: "+0.2 pts",
              note: "A new audience in the community lane — the 35% of your site's visitors who are men, and the generation of men that buys jewelry for itself most. Carried by Gen Z and Millennial men.",
            },
            {
              id: "cand-bean",
              label: "Elsa Peretti Bean and Open Heart",
              sub: "1970s · silver $300–700",
              a: 84,
              b: 60,
              tail: "+0.1 pts",
              note: "The trust repair: hold the price, raise the weight and the finish. It moves reviews and trust, not the index — recommended for that reason. Carried by all generations.",
            },
            {
              id: "cand-somerset",
              label: "Somerset mesh and the original Atlas",
              sub: "1990s · silver $400–900",
              a: 48,
              b: 58,
              tail: "+0.1 pts",
              note: "The bench — little on the index on its own. Carried by Millennials and Gen X.",
            },
            {
              id: "cand-charms",
              label: "Charms and charm bracelets",
              sub: "2000s · silver $150–400",
              a: 80,
              b: 22,
              tail: "+0.1 pts",
              tailLow: true,
              note: "The trap: high demand at the lowest price for the youngest buyer — Gen Alpha and Gen Z. An entry line is read as an entry line; the index credits objects people keep and an identity signal, and the crowding costs you in the community lane. This is the 2002 problem again: you raised silver prices on purpose that year because the entry line was crowding your stores.",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "Cuffs lead because they are the only silver three generations want at once; pendants follow because a necklace is the first piece Gen Z buys for itself and the step up for a Millennial who owns one. Chain bracelets carry the tag's one numbered edition with HardWear continuing; rings come last and for Gen Z alone, at the new price floor. No new charms.",
          title: "The categories, in order",
          provenance: "projected",
          note: "The silver categories to bring back, ranked by how many generations respond to them at once and by what each adds to the index.",
          rows: [
            {
              label: "Cuffs and bangles",
              context:
                "strong with Gen Z, Millennials and Gen X at once — the Bone Cuff leads",
              value: "1st",
            },
            {
              label: "Pendants and sculptural necklaces",
              context:
                "Gen Z's first choice of piece, and the step up for Millennials — Bottle, Mesh, Bean",
              value: "2nd",
            },
            {
              label: "Chain bracelets",
              context:
                "the heart tag toggle as a numbered edition; HardWear continues",
              value: "3rd",
            },
            {
              label: "Rings",
              context:
                "Gen Z's highest category — stacking and signet rings at the new price floor, for women and men",
              value: "4th",
            },
          ],
        },
        {
          kind: "stats",
          insight:
            "Elevated is a set of rules, not an adjective: a floor under the price, design ahead of the logo, weight and finish you can feel, care for life, and a cap on volume — so silver never again crowds the stores the way it did from 2002 to 2007.",
          provenance: "projected",
          items: [
            {
              label: "A price floor",
              value: "$500",
              hint: "new silver starts here, the lead pieces at $1,000 to $3,000; nothing new under $300",
            },
            {
              label: "Design first, logo second",
              value: "1 a year",
              hint: "the tag as one numbered edition a year, behind Peretti's forms",
            },
            {
              label: "Weight and finish",
              value: "Heavier",
              hint: "gauge, hand finishing and named makers: the answer to the 'thin' reviews",
            },
            {
              label: "Care for life",
              value: "Free",
              hint: "polishing for silver, as for gold: a complaint turned into a store visit",
            },
            {
              label: "A ceiling on volume",
              value: "≤ 25%",
              hint: "of sales, well under silver's old share of pieces: scarcity by rule",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "The same silver piece is worth twenty times more to your standing as an object people keep than as one more archive re-issue, because the index gives each lane less credit the fuller it already is and your archive lane sits at 97 of 100. The lanes with room — objects, community, collaboration and place — are together worth about +3.6; a meaningful return and a high-scoring return are the same plan.",
          title: "One silver play, lane by lane",
          provenance: "projected",
          mode: "pair",
          a: { label: "Lane today", color: "#94A3B8" },
          b: { label: "After one silver play", color: "#4ADE80" },
          note: "Each lane's score on the index as it stood on 24 August, and after one strong silver play routed through it; the tail is the index points that play adds at landing. Basis: the index's own saturation rule — lane score = 100 × (1 − e^(−strength ÷ 120)) — and its lane weights. The published index is smoothed and takes the points in over several runs. Tap a row for the evidence on the shelf.",
          rows: [
            {
              id: "lane-objects",
              label: "Objects",
              sub: "the emptiest lane",
              a: 21.9,
              b: 44.0,
              tail: "+1.57 pts",
              note: "The objects lane sits at 21.9, the emptiest on your shelf — three plays in it this summer, received at 6.7. A numbered silver edition is an object people keep, which is exactly what this lane credits.",
            },
            {
              id: "lane-community",
              label: "Community",
              sub: "the crowd is organised, you are not",
              a: 60.0,
              b: 72.0,
              tail: "+1.03 pts",
              note: "Resale depth scores 80 to 100 and the collectors already discuss vintage silver authentication on their own forums; your owned spaces and membership score 20. A registry fills the gap the assessment names.",
            },
            {
              id: "lane-collab",
              label: "Collab",
              sub: "three silver collabs, all with a tag",
              a: 84.2,
              b: 88.6,
              tail: "+0.63 pts",
              note: "The three silver products on the shelf we read are all collaborations carrying your tag on a partner's product — Disney, Supreme, Beyoncé. None is a design story of your own; one built on a Peretti form would be.",
            },
            {
              id: "lane-experience",
              label: "Experience",
              sub: "your best-received lane",
              a: 80.7,
              b: 86.2,
              tail: "+0.39 pts",
              note: "Experience is your best-received lane: average reception 48.6, and 86% of its plays were read above zero. A room where silver is made adds to it.",
            },
            {
              id: "lane-content",
              label: "Content",
              sub: "full on volume",
              a: 92.9,
              b: 94.9,
              tail: "+0.28 pts",
              note: "Twenty-four pieces already; fandom is your best-received strategy (65, +47) and sits on only four plays, none of them content — a campaign by the people who own the cuff would be the first.",
            },
            {
              id: "lane-archive",
              label: "Archive re-issue",
              sub: "full — twelve returns this year",
              a: 97.1,
              b: 98.0,
              tail: "+0.08 pts",
              note: "Your archive lane sits at 97 of 100, filled with high jewelry and watches, so one more re-issue adds almost nothing — twenty times less than the same piece played as an object.",
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Played as another archive re-issue, silver moves nothing; played as objects, a collector community, a collaboration and a place, it moves the index by three to four points. Silver is where your craft and the crowd's fandom already meet: you have made the trophies of American sport for about 160 years at your Rhode Island workshop — the Lombardi and the Larry O'Brien are your silver — and among the best-received plays at home this summer was a trophy moment, the Knicks' title night lighting the flagship at 80 and +73.",
          title: "The cultural plan, priced",
          provenance: "projected",
          plays: [
            {
              name: "Numbered archive editions, one a season — the Gehry Torque and Fish, the 1997 heart tag toggle, Paloma's Graffiti",
              itemType: "merch",
              window:
                "The holiday window, then one a season · about 12,000 of each in a heavier gauge, hallmarked with the year, never repeated — when the run is sold, it is gone",
              strategies: [
                { code: "scarcity", fit: 0.85 },
                { code: "fandom", fit: 0.6 },
                { code: "identity_signal", fit: 0.45 },
              ],
              why: "Three discontinued pieces come back in silver, one a season: the Gehry Torque and Fish, the 1997 heart tag toggle, and Paloma Picasso's Graffiti — each a numbered run of about twelve thousand in a heavier gauge, hallmarked with the year, and never repeated. The index reads this as objects, the lane that credits a thing people keep, and as scarcity at a price people can reach. The objects lane sits at 21.9, the emptiest on your shelf, with three plays in it this summer; the field's returns that landed were faithful objects a crowd once owned — a car, a kit, a backpack.",
              effect: {
                label: "CIQ",
                delta: 1.6,
                series: [0, 0.6, 1.1, 1.45, 1.6],
              },
              precedents: 7,
              reception: "an object people keep opens the emptiest lane",
              similar: [
                {
                  brand: "ferrari",
                  brandName: "Ferrari",
                  title: "Ferrari 250 GTO restoration honoured at Villa d'Este",
                  pts: 71.4,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Nike Brazil 1998 R9 Kit Re-Issue",
                  pts: 39.3,
                },
                {
                  brand: "prada",
                  brandName: "Prada",
                  title: "Prada Re-Nylon Backpack Relaunch",
                  pts: 37.9,
                },
              ],
            },
            {
              name: "A collector registry — hallmark dating and a house resale desk",
              itemType: "community",
              window:
                "With the first edition · an owner registers a piece by its hallmark and gets its year and maker; a resale desk in your stores buys and sells vintage silver with your authentication; registered owners get first access to each edition",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "fandom", fit: 0.65 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "A home for the people who already collect your silver. An owner registers a piece by its hallmark and gets its year and maker; a resale desk in your stores buys and sells vintage silver with your authentication; registered owners get first access to each numbered edition. The index reads this as community — an owned space with membership, which you score 20 on today, while resale depth scores 80 to 100 and the collectors already discuss vintage silver authentication on forums you do not own. The field's community plays that carried were built for a crowd that already loved something.",
              effect: {
                label: "CIQ",
                delta: 1.0,
                series: [0, 0.35, 0.65, 0.9, 1.0],
              },
              precedents: 6,
              reception:
                "membership reads as fandom where the crowd is already organised",
              similar: [
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title: "Starbucks and POP MART Celebrate 20 Years of MOLLY",
                  pts: 58.5,
                },
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "NYC MoMA Friday Night Uniqlo Free Entry Program",
                  pts: 37.4,
                },
                {
                  brand: "gap",
                  brandName: "Gap",
                  title: "Hailey Bieber x Gap Denim Collection",
                  pts: 36.3,
                },
              ],
            },
            {
              name: "One collaboration built on a Peretti form, with no logo tag",
              itemType: "collab",
              window:
                "One season · a designer or an artist reworks the Bone Cuff or the Bottle pendant in silver; both names go on the hallmark, neither on the face of the piece",
              strategies: [
                { code: "fandom", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.6 },
                { code: "scarcity", fit: 0.5 },
              ],
              why: "One partner, one Peretti form, no logo tag. A designer or an artist reworks the Bone Cuff or the Bottle pendant for one season, in silver, and both names go on the hallmark rather than on the face of the piece. This is the opposite of the three silver collaborations on your shelf this summer — Disney, Supreme, Beyoncé — which were your tag on a partner's product. The field's collaborations that carried are the ones where the partner's hands made the object.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.25, 0.45, 0.55, 0.6],
              },
              precedents: 9,
              reception: "the maker on the object reads at 85 to 100",
              similar: [
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton x Singer Porsche 911 Reimagined Collection",
                  pts: 73.3,
                },
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title: "Hermès Dress Code carré, designed by Daniel Clowes",
                  pts: 46.2,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton Objets Nomades Cocoon Dichroic Chair with Humberto Campana and Géraldine Guyot-Arnault",
                  pts: 41.6,
                },
              ],
            },
            {
              name: "A silver workshop people can enter, at the Landmark",
              itemType: "experience",
              window:
                "Year-round · a working silversmith's bench inside the Landmark — watch a cuff raised and finished, book a session to finish a piece of your own, have your own silver polished for free while you wait",
              strategies: [
                { code: "opacity", fit: 0.5 },
                { code: "aesthetic_innovation", fit: 0.5 },
                { code: "identity_signal", fit: 0.4 },
              ],
              why: "A working silversmith's bench inside the Landmark. Visitors watch a cuff being raised and finished, can book a session to finish a piece of their own, and have their own silver polished for free while they wait. The index reads this as experience, your best-received lane — average reception 48.6, 86% of its plays read above zero — and the free polish answers the aftercare complaint in the room where it is made. The field's rooms that carried were built around one house's objects.",
              effect: {
                label: "CIQ",
                delta: 0.4,
                series: [0, 0.15, 0.3, 0.38, 0.4],
              },
              precedents: 7,
              reception: "a room built around an object reads at 85",
              similar: [
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "The House of Miss Dior Pop-up at South Coast Plaza",
                  pts: 42.0,
                },
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "NYC MoMA Friday Night Uniqlo Free Entry Program",
                  pts: 37.4,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Dior: Crafting Fashion Exhibition, SCAD FASH Atlanta",
                  pts: 22.6,
                },
              ],
            },
            {
              name: "The Bone Cuff in silver, shot by the people who wear it",
              itemType: "content",
              window:
                "With the registry · no model — the cuff on the wrists of the people who own one, in their own photographs, gathered through the registry and the collectors' forums, run as your own content",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "identity_signal", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.4 },
              ],
              why: "A campaign with no model. The Bone Cuff in silver on the wrists of the people who own one, in their own photographs, gathered through the registry and the collectors' forums, and run as your own content. Fandom is your best-received strategy — 65 against the board's 43, warm at +47 — and it sits on only four plays, none of them a product; the strongest content on the board is made by the crowd, and the field's carrying content is what the fans post themselves.",
              effect: {
                label: "CIQ",
                delta: 0.3,
                series: [0, 0.1, 0.2, 0.27, 0.3],
              },
              precedents: 8,
              reception: "the crowd's own content is received at eighty",
              similar: [
                {
                  brand: "apple",
                  brandName: "Apple",
                  title: '"Shot on iPhone" Campaign (Ongoing Activity)',
                  pts: 88.4,
                },
                {
                  brand: "bottega-veneta",
                  brandName: "Bottega Veneta",
                  title: "RM BTS Ambassadorship Magazine Covers",
                  pts: 77.3,
                },
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title:
                    "Hermès x Sarah Martinon Illustrated Digital Experience",
                  pts: 40.4,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are index points at landing, priced on the index's own lane saturation as the lanes stood on 24 August and on the field's measured plays of the same shape; the published index is smoothed and takes them in over several runs. The five together are the Silver Lab's whole cultural plan — about +3 to +4 — and the archive lab's three returns, the fan lab's three moves and the collab scout's lead are its parts, not additions to it.",
        },
        {
          kind: "shift",
          insight:
            "You sell fewer silver pieces than before 2021 at about twice the price — about 240,000 added pieces at an average near $1,300 — and silver's share of sales moves from about 14 to 19% to about 18 to 23%, still below the old 30%. A second effect arrives later: about 130,000 customers new to your house, 18% of whom step up to gold and diamonds within five years.",
          title: "What it is worth by 2028",
          provenance: "projected",
          note: "Added pieces, average price and revenue in 2028, line by line; the gross less what the new lines take from existing ones; the margin; and the later gold and diamond sales from the customers the return brings in.",
          rows: [
            {
              label: "Peretti sculptural",
              context: "Bone Cuff, Mesh, Scorpion · 45,000 pieces at $2,100",
              value: "$95M",
            },
            {
              label: "Pendants, chains and rings at the new floor",
              context: "110,000 pieces at $900",
              value: "$99M",
            },
            {
              label: "Numbered archive editions",
              context: "5 editions × 12,000 · 60,000 pieces at $1,400",
              value: "$84M",
            },
            {
              label: "Men's silver",
              context: "25,000 pieces at $1,200",
              value: "$30M",
            },
            {
              label: "Gross",
              context: "240,000 added pieces",
              value: "$308M",
            },
            {
              label: "Less 15% taken from existing lines",
              context: "the sales the new pieces displace",
              value: "−$46M",
            },
            {
              label: "Net new silver revenue",
              context: "by 2028",
              value: "~$260M",
            },
            {
              label: "Gross profit",
              context:
                "at an 85% margin — the metal is under a tenth of a Bone Cuff's price even after silver doubled: roughly $120 to $190 of silver in a $2,300 cuff",
              value: "~$220M",
            },
            {
              label: "Later gold and diamond sales",
              context:
                "about 130,000 customers new to your house · 18% step up within five years · about $6,000 each",
              value: "~$140M",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The elevated return adds about a quarter of a billion dollars and keeps silver below a quarter of sales; the volume return earns more for a while and brings back the crowded stores of 2002; continuing to cut protects margin and keeps thinning the supply of new customers. At today's metal prices cheap silver is being squeezed across the market, and silver priced as design is the version that still works.",
          title: "Three roads to 2028",
          provenance: "projected",
          note: "Silver revenue today and in 2028 on three roads. Basis: the volumes and prices in the table above, a 15% allowance for sales taken from existing lines, and an 85% gross margin.",
          rows: [
            {
              label: "Today",
              context: "30% of sales cut by more than a third",
              value: "$0.85B",
            },
            {
              label: "Keep cutting",
              context:
                "margin holds; the supply of new customers keeps thinning · about $150M below today",
              value: "$0.70B",
            },
            {
              label: "Elevated return",
              context:
                "fewer pieces than before 2021 at about twice the average price · about $260M above today",
              value: "$1.11B",
            },
            {
              label: "Volume return",
              context:
                "the 2002 problem: more sales, a lower average price, crowded stores · about $500M above today, and the house cheapened",
              value: "$1.35B",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The fast clock is Gen Z's — search, resale and new customers under 35 move within months — and the slow clock is Millennials' and Gen X's: full-price silver, the step up to gold and the top of the ladder show over two years and last. Judge the return on both, or the quarter will say it failed before the ladder has moved.",
          title: "Which audience moves which metric",
          provenance: "projected",
          note: "Each metric the return should be judged on, the clock it runs on and the generation that moves it.",
          rows: [
            {
              label: "Search interest and mentions",
              context: "Gen Z",
              value: "fast clock",
            },
            {
              label: "Resale prices and vintage searches",
              context: "Gen Z, Millennials",
              value: "fast clock",
            },
            {
              label: "New customers under 35",
              context: "Gen Z, Millennials",
              value: "fast clock",
            },
            {
              label: "Silver sales at full price",
              context: "Millennials, Gen X",
              value: "slow clock",
            },
            {
              label: "Repeat purchase and the step up to gold",
              context: "Millennials",
              value: "slow clock",
            },
            {
              label: "High jewelry and the top of the ladder",
              context: "Gen X, older Millennials",
              value: "slow clock",
            },
            {
              label: "Cultural capital on the index",
              context: "Millennials, Gen X",
              value: "slow clock",
            },
          ],
        },
        {
          kind: "impact",
          title: "What the whole plan carries",
          provenance: "projected",
          delta: 3.9,
          body: "About four points on your published score at landing — from 74.6 to roughly 78 — taken in over several runs as the editions, the registry, the collaboration and the workshop follow one another; the Bone Cuff alone is about a third of it. The Peretti licence runs to 2032 and bars promotional pricing, the price of the metal is volatile, and your owner's stated direction is gold and high jewelry, so the plan has to be argued as recruitment for that direction.",
        },
        {
          kind: "modelView",
          body: "Bring silver back — as design, not as the entry line. Silver was about a third of your sales and the door most of your customers came in through, and you closed it on purpose. The demand did not leave; it moved to resale, where your silver trades at a record and the Bone Cuff leads, while the people looking for you fell by half and the ones who complain loudest about your price are the generation that is your largest customer and your future brand fan. A silver piece bought at twenty-five is the gold buyer at forty; stop making the first and you stop making the second.\n\nThe audience is Gen Z and Millennial women buying for themselves, with Gen X's Peretti admirers paying full price first and men a smaller fourth group — they move search, resale and new customers within months, and full-price silver over two years. The categories are cuffs and bangles, then pendants and sculptural necklaces, then chain bracelets, then rings; no new charms. The pieces are the Bone Cuff in front, Mesh and the Bottle behind it, and numbered editions of Gehry, the heart tag and Graffiti, one a season. Price it as design from the middle of the range up, make it heavier, polish it for life as you do gold, cap its share of sales, and build the registry, the collaboration and the workshop around it. Played that way it is worth about three to four points on the index and about a quarter of a billion dollars a year by the end of the decade — argued to your owner as recruitment for gold, not a retreat from it.",
        },
      ],
    },
    {
      id: "archive-bring-back",
      itemType: "archive_reissue",
      type: "archive",
      // OFF the recommended chips since 2026-10-12 (user call: "show just 3
      // questions … comment out which archival product should tiffany…") —
      // the answer stays: typed phrasings, aliases, the briefing's deep link
      // and the advisor slate all still land here.
      featured: false,
      // 2026-10-06 — REPLACED "How to win GenZ through archive?" (user call:
      // "replace some of the current ones with: Which archival products
      // should Tiffany bring back?"), re-read from the Tiffany Silver Lab's
      // analysis; the former title and its aliases stay reachable below, so
      // the briefing's deep link and typed phrasings still land.
      question: "Which archival products should Tiffany bring back?",
      aliases: [
        "which archival products should we bring back",
        "which archive products should tiffany bring back",
        "which archive products should we bring back",
        "what archival products should tiffany bring back",
        "which archival pieces should tiffany bring back",
        "which archive pieces should we bring back",
        "what should we bring back from the archive",
        "what should we reissue from the archive",
        "which reissues should we do next",
        "which silver should we bring back",
        // the question's former titles (2026-09-07 → 2026-10-06)
        "how to win genz through archive",
        "which archive pieces should we release back for gen z",
        "which archive pieces should we release back",
        "which archived products should we release back",
        "which archived products should tiffany release back based on activity on resale market and interests of gen z",
      ],
      askedOn: "2026-10-05",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Bring silver back as design: the Bone Cuff first, then numbered editions of Gehry, the heart tag and Graffiti. Not the charms.",
        },
        {
          kind: "stats",
          provenance: "measured",
          insight:
            "Your archive year was played at the top of the house and received by the trade: the strongest returns on paper on the board, landing in the lower half because nobody but a collector can own them. Silver — the metal most of your customers came in through — is on four of ninety-three plays, and never as a design story of your own.",
          items: [
            {
              label: "Your returns this year",
              value: "12",
              hint: "every one a Schlumberger motif, a watch or a clock — Bird on a Rock five times, Sixteen Stone twice, the Astronomical Clock",
            },
            {
              label: "Graded at launch",
              value: "49.5",
              hint: "of 100 — the highest average of any brand on the board; the next luxury houses sit at 27 to 38",
            },
            {
              label: "Received",
              value: "21st of 32",
              hint: "brands with returns this year, by how much the returns were noticed afterwards — the best read was the Paradise Bird Parrot watch at 70",
            },
            {
              label: "Silver on your shelf",
              value: "4 of 93",
              hint: "plays this summer mention silver, three of them collaborations carrying a tag — Disney, Supreme, Beyoncé; Elsa Peretti and Return to Tiffany, never",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "The returns that land are things people owned or wanted — a fragrance, a shoe, a bag — brought back as they were; yours were the pieces no one could own, graded top on heritage and read by a trade write-up each. Your equivalent of a Gap fragrance is a silver cuff or a heart tag, and neither is on the shelf we read.",
          title: "Archive returns, brand by brand",
          provenance: "measured",
          note: "Average peak reception of each brand's archive returns this year, 0 to 100 — how much a return was noticed after it landed, the best read per play averaged. Ten of the houses on the board with returns; across the whole board you are 21st of 32. Tap a row for what came back.",
          rows: [
            {
              id: "gap",
              label: "Gap",
              context: "the 1990s fragrances, the summer clothing revival",
              score: 72.5,
              drivers: [
                "Two returns read at 90 and 80: the fragrances of the nineties and the clothes people wore with them — things a whole generation owned, back as they were.",
              ],
            },
            {
              id: "valentino",
              label: "Valentino",
              context: "the Vendetta fragrance, the Rockstud",
              score: 55.8,
              drivers: [
                "The Vendetta franchise read at 90 and the Rockstud at 75 — a scent and a shoe people wanted back, not a museum piece.",
              ],
            },
            {
              id: "hermes",
              label: "Hermès",
              context: "the So Kelly re-edition",
              score: 50.0,
              drivers: [
                "A bag re-edited rather than re-shown, read at 65 — the house's illustrated pages carried the largest content lift on the board around it.",
              ],
            },
            {
              id: "uniqlo",
              label: "Uniqlo",
              context: "retro Pokémon returns",
              score: 45.6,
              drivers: [
                "A crowd's childhood on a T-shirt, read at 80 — the return that costs the least and lands with the most people.",
              ],
            },
            {
              id: "armani",
              label: "Giorgio Armani",
              context: "Archivio, the second re-edition",
              score: 45.0,
              drivers: [
                "A numbered archive capsule in its second season, read at 80 and warm — the edition as a rhythm rather than an anniversary.",
              ],
            },
            {
              id: "nike",
              label: "Nike",
              context: "Air Jordan 11 Space Jam, the 2001 Air Force 1",
              score: 40.8,
              drivers: [
                "Two shoes brought back in their original molds, read at 80 and 75 — the faithfulness is the campaign.",
              ],
            },
            {
              id: "tiffany",
              label: "Tiffany & Co.",
              context:
                "Bird on a Rock five times, Sixteen Stone twice, the watches, the clock",
              score: 32.5,
              role: "you",
              drivers: [
                "Twelve returns graded higher at launch than anyone's, received by a single trade write-up each and cooling within the month; the best read was the Paradise Bird Parrot watch at 70. The archive is being played to collectors of the unreachable.",
              ],
            },
            {
              id: "saint-laurent",
              label: "Saint Laurent",
              context: "the Mombasa bag returns",
              score: 30.0,
              drivers: [
                "One bag from the Tom Ford years, read at 80 and the warmest return on the board — the shape a generation of women remembers wanting.",
              ],
            },
            {
              id: "prada",
              label: "Prada",
              context: "the Re-Nylon backpack relaunch",
              score: 27.0,
              drivers: [
                "The 1984 backpack back in recycled nylon, read at 65 — a wearable icon re-made, with what changed said out loud.",
              ],
            },
            {
              id: "chanel",
              label: "Chanel",
              context: "the Première Édition Originale watch",
              score: 10.0,
              drivers: [
                "A faithful watch reissue, barely read — faithfulness alone is not reception when the piece was never a crowd's.",
              ],
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Cuffs and pendants are the only silver strong with Gen Z, Millennials and Gen X at the same time — which is why the Bone Cuff leads and the pendants follow. Rings are Gen Z's own category; charms score only with the youngest buyer at the lowest price, the category most likely to cheapen the house.",
          title: "Which silver each generation wants",
          provenance: "projected",
          note: "Rows are silver categories, columns generations. Each cell is a modeled read, 0 to 100, of how strongly that generation responds to that category in silver — from what each age group buys for itself, searches on resale and wore the first time. Tap a cell for the read.",
          cols: ["Gen Alpha", "Gen Z", "Millennials", "Gen X", "Boomers"],
          rows: [
            {
              label: "Cuffs and bangles",
              cells: [
                {
                  v: 20,
                  note: "Too large and too costly for a gift to a child.",
                },
                {
                  v: 84,
                  note: "The Bone Cuff is the resale piece of the moment — searches more than doubled in a year, the price up 30% — a step behind necklaces and rings for this group, and strong.",
                },
                {
                  v: 78,
                  note: "The self-purchase piece at $2,000 to $3,000 — inside the range one in five of this generation says it would spend on itself.",
                },
                {
                  v: 74,
                  note: "The Peretti admirers: they knew the cuff the first time and can pay full price on day one.",
                },
                { v: 46, note: "Admired more than bought." },
              ],
            },
            {
              label: "Chain and link bracelets",
              cells: [
                {
                  v: 45,
                  note: "A first-bracelet gift, at the edge of what you should sell here.",
                },
                {
                  v: 80,
                  note: "HardWear and the toggle chain, worn stacked — carried by men as well.",
                },
                {
                  v: 76,
                  note: "The heart tag bracelet they owned once, wanted back heavier.",
                },
                { v: 58, note: "Worn, seldom sought." },
                { v: 38, note: "Low." },
              ],
            },
            {
              label: "Pendants and necklaces",
              cells: [
                { v: 62, note: "The classic first-jewelry gift." },
                {
                  v: 82,
                  note: "Necklaces are this generation's first choice of piece to buy for itself — the only age group where they beat rings.",
                },
                {
                  v: 80,
                  note: "Bean, Open Heart and the toggle necklace — your most-owned silver.",
                },
                {
                  v: 66,
                  note: "The gift they give as often as the piece they wear.",
                },
                {
                  v: 52,
                  note: "The strongest silver category for this generation, and still modest.",
                },
              ],
            },
            {
              label: "Rings — stacking, signet",
              cells: [
                { v: 30, note: "Sizes change too fast." },
                {
                  v: 86,
                  note: "The highest cell on the grid: stacked and signet rings, for women and men, under $500.",
                },
                { v: 68, note: "Solid, behind bracelets and pendants." },
                { v: 50, note: "Gold is the ring metal for this group." },
                { v: 30, note: "Low." },
              ],
            },
            {
              label: "Earrings",
              cells: [
                { v: 40, note: "Studs as a gift after a first piercing." },
                { v: 70, note: "Good, undistinctive — bought everywhere." },
                { v: 66, note: "Good, undistinctive." },
                { v: 60, note: "Mesh and Bean earrings hold up here." },
                { v: 44, note: "Moderate." },
              ],
            },
            {
              label: "Charms and tags",
              cells: [
                {
                  v: 78,
                  note: "The highest score for this generation, and the reason charms are a trap — the youngest buyer at the lowest price.",
                },
                {
                  v: 72,
                  note: "Charm bracelets are up 21% on resale — wanted as vintage, which is different from wanting them new.",
                },
                {
                  v: 70,
                  note: "Nostalgia for the charm bracelet of the two-thousands.",
                },
                { v: 40, note: "Low." },
                { v: 28, note: "Low." },
              ],
            },
            {
              label: "Sculptural — mesh, bottle, belt",
              cells: [
                { v: 8, note: "No fit." },
                {
                  v: 62,
                  note: "Growing through resale — the Mesh scarf necklace is tipped next.",
                },
                { v: 64, note: "The step up from the pendant." },
                {
                  v: 72,
                  note: "Their category — the only one where Gen X leads every other generation.",
                },
                {
                  v: 48,
                  note: "Admired by those who remember the seventies originals.",
                },
              ],
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "The top right corner belongs to Elsa Peretti: the Bone Cuff is the only piece both wanted now and worth real ground, because every other move can be built on it and it is already in your stores. The heart tag has the most demand on the list and earns its place only as one numbered edition; charms are wanted, cheap and worth nothing — the way the early two-thousands went wrong.",
          title: "Eleven candidates — what each adds, and who wants it",
          provenance: "projected",
          x: {
            label: "What it adds to your CIQ",
            low: "little",
            high: "a lot",
            hint: "an index of the lift the piece carries at landing — the lanes it opens and the strategy it carries",
          },
          y: {
            label: "Demand heat",
            low: "quiet",
            high: "wanted now",
            hint: "resale prices, searches and what customers say they miss",
          },
          quadrants: {
            tr: "Bring it back",
            tl: "Wanted — not a line",
            br: "For the collectors",
            bl: "Leave it",
          },
          note: "Dot size is the silver price. Haloed dots are the recommended returns; hollow ones are on the counter today. Tap a dot for the read.",
          points: [
            {
              id: "bone-cuff",
              label: "Elsa Peretti Bone Cuff · 1970",
              short: "Bone Cuff",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 94,
              y: 92,
              w: 61,
              status: "recommended",
              note: "The lead — about a third of the plan's lift on its own, because the objects, content, collaboration and workshop moves can all be built on this one form; up 30% on resale in a year, and already in your stores. What is missing is a silver-first story: the anniversary pushes led with colour, pavé and gold.",
            },
            {
              id: "mesh",
              label: "Elsa Peretti Mesh · 1975",
              short: "Mesh",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 70,
              y: 78,
              w: 64,
              status: "recommended",
              note: "The scarf necklace and the earrings — tipped as the next Peretti piece to rise on resale, and the step up for the Millennial who already owns a pendant. Second, at a price that holds.",
            },
            {
              id: "gehry",
              label: "Frank Gehry Torque and Fish · 2006",
              short: "Gehry",
              era: "The Gehry years",
              color: "#60A5FA",
              x: 64,
              y: 70,
              w: 53,
              status: "recommended",
              note: "The first numbered return: discontinued, traded thin on resale, a design crowd that knows it from the internet and cannot buy it. About twelve thousand in a heavier gauge, hallmarked with the year, never repeated. The rights sit with the Gehry side.",
            },
            {
              id: "heart-tag",
              label: "Return to Tiffany heart tag toggle · the 1997 edition",
              short: "Heart tag",
              era: "The Y2K years",
              color: "#4FC3F7",
              x: 56,
              y: 95,
              w: 40,
              status: "recommended",
              note: "The most demand on the list and the most fandom — and it earns its place only as ONE numbered edition in the original weight, hallmarked with the year, in the holiday window. As a volume line it would add nothing: the toggle was never discontinued, and 'bring it back' is a complaint about price.",
            },
            {
              id: "bottle",
              label: "Elsa Peretti Bottle pendant · 1969",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 54,
              y: 64,
              w: 42,
              note: "The pendant door at an elevated price — necklaces are the piece Gen Z buys for itself first, and the Bottle is the one the youngest buyer keeps.",
            },
            {
              id: "scorpion",
              label: "Elsa Peretti Scorpion and Snake · 1970s",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 46,
              y: 60,
              w: 80,
              note: "Statement pieces, numbered — scarcity for the collectors at the top of the silver range.",
            },
            {
              id: "graffiti",
              label: "Paloma Picasso Graffiti · 1983",
              era: "The Picasso era",
              color: "#F472B6",
              x: 45,
              y: 54,
              w: 39,
              note: "LOVE and XO in silver forty years before the word-jewelry trend — the third numbered edition, after Gehry and the tag.",
            },
            {
              id: "forge",
              label: "Tiffany Forge and Makers · 2023",
              era: "In line today",
              color: "#94A3B8",
              x: 36,
              y: 50,
              w: 61,
              status: "current",
              note: "Not a return — on the counter already, and the door for the men who are a third of your site's visitors; Gen Z men buy jewelry for themselves more than any generation of men before them.",
            },
            {
              id: "bean",
              label: "Elsa Peretti Bean and Open Heart · 1974",
              era: "The Peretti era",
              color: "#D7A97C",
              x: 22,
              y: 84,
              w: 27,
              status: "current",
              note: "Came back for the fiftieth and sells today — a trust repair, not a return: hold the price, raise the weight and the finish, polish it for free. It moves reviews, not the index.",
            },
            {
              id: "somerset",
              label: "Somerset mesh and the original Atlas · 1990s",
              era: "The house lines",
              color: "#2DD4BF",
              x: 20,
              y: 48,
              w: 31,
              note: "Missed by the people who owned them, thin on resale — the bench, for later.",
            },
            {
              id: "charms",
              label: "Charms and charm bracelets · 2000s",
              era: "The Y2K years",
              color: "#4FC3F7",
              x: 14,
              y: 80,
              w: 20,
              note: "The trap: demand near the top of the list, at the lowest price, for the youngest buyer. An entry line is read as an entry line — this is how the early two-thousands went wrong, when silver crowded the stores and you raised its price on purpose.",
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three forms carry the return and one rule prices it: silver as design, from $500 up, led by a piece you already sell. Another heritage re-issue adds almost nothing to a shelf that already holds twelve; the same silver played as objects people keep, with a collectors' registry and a workshop behind them, moves the index by three to four points.",
          title: "Three returns, priced",
          provenance: "projected",
          plays: [
            {
              name: "Elsa Peretti's Bone Cuff — silver first, new expressions, the people who wear it holding the camera",
              itemType: "archive_reissue",
              window:
                "November · the holiday window — the silver cuff in front of the gold one, a numbered archive edition in a heavier gauge behind the open line",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "identity_signal", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.5 },
              ],
              why: "The cuff is up 30% on resale in a year, admired by Gen Z, Millennials and Gen X at once and negative with none of them — the one subject every paying generation agrees on. Your anniversary pushes led with colour, pavé and gold; lead with the silver at $2,000 to $3,000, add a numbered archive edition behind the open line, and shoot it on the wrists of the people who own one. Fandom is the strategy you use least and are received best for, and a product fan's love for one piece is a fandom.",
              effect: {
                label: "CIQ",
                delta: 1.2,
                series: [0, 0.5, 0.85, 1.05, 1.2],
              },
              precedents: 9,
              reception: "the icon people already wear is the proof case",
              similar: [
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title:
                    "Gucci Horsebit 1955 bag, highlighted as heritage design",
                  pts: 30.4,
                },
                {
                  brand: "valentino",
                  brandName: "Valentino",
                  title: "Valentino Garavani Rockstud reintroduction",
                  pts: 21.4,
                },
                {
                  brand: "bottega-veneta",
                  brandName: "Bottega Veneta",
                  title: "Bottega Veneta Lauren 1979 bag, archival reissue",
                  pts: 21.2,
                },
              ],
            },
            {
              name: "Elsa Peretti Mesh — the scarf necklace and the earrings, as they were",
              itemType: "archive_reissue",
              window:
                "March · spring — silver first, the step up from the pendant, the anchor of a collectors' registry",
              strategies: [
                { code: "aesthetic_innovation", fit: 0.7 },
                { code: "identity_signal", fit: 0.5 },
                { code: "scarcity", fit: 0.5 },
              ],
              why: "Mesh is the Peretti piece resale tips to rise next, and the sculptural category is the one where Gen X leads every other generation — the admirers who pay full price on day one. It is the step up for the Millennial who owns a Bean, and the anchor of a collectors' registry: an owner registers a piece by its hallmark, gets its year and maker, and first access to each numbered edition. Return it as it was — the proportions, the weight — and say what changed.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.25, 0.45, 0.55, 0.6],
              },
              precedents: 7,
              reception: "the sculptural pieces are the collectors' category",
              similar: [
                {
                  brand: "prada",
                  brandName: "Prada",
                  title: "Prada Re-Nylon Backpack Relaunch",
                  pts: 37.9,
                },
                {
                  brand: "chanel",
                  brandName: "Chanel",
                  title: "Chanel Première Édition Originale watch reissue",
                  pts: 27.9,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton × Takashi Murakami twentieth-anniversary re-edition",
                  pts: 22.4,
                },
              ],
            },
            {
              name: "Frank Gehry — the Torque and the Fish, the first numbered return",
              itemType: "archive_reissue",
              window:
                "February · design week — about twelve thousand, a heavier gauge, hallmarked with the year, never repeated; the heart tag's edition already out in the holiday window, Paloma's Graffiti the spring after",
              strategies: [
                { code: "scarcity", fit: 0.85 },
                { code: "aesthetic_innovation", fit: 0.7 },
                { code: "opacity", fit: 0.4 },
              ],
              why: "Six collections, discontinued for years, a dozen pieces on the market at any time: the Gehry line is the archive the design crowd knows from the internet and cannot buy. An honest numbered edition on the twentieth anniversary turns a thin secondary market into a queue, opens the lane your shelf is emptiest in — an object people keep — and sets the rule for every edition, the tag's holiday edition before it and Graffiti's after: one a season, the run sold and gone.",
              effect: {
                label: "CIQ",
                delta: 0.5,
                series: [0, 0.2, 0.35, 0.45, 0.5],
              },
              precedents: 7,
              reception: "a dozen pieces on the market at any time",
              similar: [
                {
                  brand: "ferrari",
                  brandName: "Ferrari",
                  title: "Ferrari 250 GTO restoration honoured at Villa d'Este",
                  pts: 71.4,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Nike Brazil 1998 R9 Kit Re-Issue",
                  pts: 39.3,
                },
                {
                  brand: "coca-cola",
                  brandName: "Coca-Cola",
                  title: "Coca-Cola brings back the nostalgic Share a Coke",
                  pts: 22.8,
                },
              ],
            },
          ],
          footnote:
            "Projected effects assume a faithful, elevated return — original proportions, a heavier gauge, the hallmark and the year, nothing new under $300, free polishing for silver as for gold — priced on your measured archive record and the field's best returns of the same shape.",
        },
        {
          kind: "impact",
          title: "What the Bone Cuff carries",
          provenance: "projected",
          delta: 1.2,
          body: "The silver cuff, led from the holiday window, carries a projected lift on your published score over the following two windows — most of it in the first, as the resale crowd meets a silver story in the store, the rest as the numbered editions follow one a season. The same silver played as one more heritage re-issue would move almost nothing.",
        },
        {
          kind: "modelView",
          body: "Bring back silver as design, not as the entry line. Your archive year was played at the top of the house — the birds, the enamel, the clocks — and every piece scored on history and cooled within the month, because the crowd for it buys at auction, not at a counter.\n\nThe demand did not leave; it moved to resale, where your silver trades at a record and the Bone Cuff leads. Lead with Elsa Peretti's forms, the cuff in front, Mesh and the Bottle behind it, and put numbered editions behind them one a season — the heart tag in its original weight beside the cuff this holiday, Gehry the first return in February, then Paloma's scribbles — each hallmarked with the year, sold once and gone. Price it as design, from the middle of the range up; polish it for life, as you do gold; keep the tag to one edition and leave the charms alone, because a cheap line for the youngest buyer is how the early two-thousands went wrong. A silver piece bought at twenty-five is the gold buyer at forty; stop making the first and you stop making the second.",
        },
      ],
    },
    {
      id: "genz-content",
      itemType: "content",
      type: "content",
      // OFF the recommended chips since 2026-10-06 (user call: "remove
      // highest engagement content proposed question from ui") — the answer
      // stays: the briefing's Cartier and Pandora cards deep-link here and
      // the advisor slate carries its three priced pieces
      featured: false,
      // displayed title renamed 2026-09-08 (user call), answer unchanged;
      // the former title stays an alias
      question: "What's the highest engagement content?",
      aliases: [
        "which content resonates with gen z the most",
        "which content resonates with gen z",
        "what content resonates with gen z the most",
        "what content works with gen z",
        "which content should we make for gen z",
        "what should we post for gen z",
        "which content performs best with gen z",
        "which of our content does gen z share",
      ],
      askedOn: "2026-09-03",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Beautifully made, quietly received. Less film, more feed: the fandom's camera, the crowd's argument, the bench.",
        },
        {
          kind: "arena",
          title: "Seven content formats, field and yours",
          provenance: "measured",
          unit: "graded strength · pts",
          note: "Bands are the field's range for content of each format — typical to ceiling of graded strength across every brand on the board; the ring is the field's strongest piece there, the dots are your twenty-four. Received = the best presence measured for that format. Tap a format for the read.",
          rows: [
            {
              id: "camera",
              label: "Fandom's own camera",
              sub: "the face posts it",
              typical: 36,
              ceiling: 45,
              best: {
                brandName: "Bottega Veneta",
                title: "RM (BTS) ambassadorship covers",
                pts: 51.5,
              },
              received: 80,
              own: [
                { title: "This is Tiffany", pts: 33.3 },
                { title: "Kendrick Lamar's piece", pts: 29.3 },
              ],
              status: "recommended",
              note: "The field's carrying format — a face the crowd already follows, posting the piece itself; received at 80 and read as the face's, not the house's. You have two pieces here, and one of them is the warmest read on your shelf.",
            },
            {
              id: "crowd",
              label: "Crowd's content",
              sub: "creators, participation",
              typical: 40,
              ceiling: 45,
              best: {
                brandName: "Apple",
                title: "Shot on iPhone",
                pts: 73.7,
              },
              received: 80,
              note: "The strongest content on the board is made by the crowd — Apple's phone campaign carries the biggest fandom fit on record — and the format with the largest CIQ lifts this summer: Duolingo's stunt, Pandora's stylist series. You have never let the crowd make a piece.",
            },
            {
              id: "made",
              label: "Made thing",
              sub: "animated, illustrated",
              typical: 33,
              ceiling: 38,
              best: {
                brandName: "Saint Laurent",
                title: "Love Letters, Love Matters — the Qixi film series",
                pts: 41.4,
              },
              received: 90,
              own: [{ title: "Where Light Meets Rebellion, RIOT", pts: 15.7 }],
              note: "The best-received format of the summer — Dior's hand-drawn Miss Dior film read at 90, and the human hand is the counter-signal a feed full of machine images rewards. Your one made thing this year is an art film nobody measured.",
            },
            {
              id: "bench",
              label: "The bench",
              sub: "the workshop, the making",
              typical: 31,
              ceiling: 38,
              best: {
                brandName: "Louis Vuitton",
                title: "Reinvents the Trunk — the monogram at 130",
                pts: 40.3,
              },
              received: 65,
              note: "The format your house is built for and never films: you set the stones, engrave the trophies and keep the archive, and none of it is on your shelf below the Blue Book. The field's craft pieces carry identity, not just beauty.",
            },
            {
              id: "face",
              label: "Face film",
              sub: "an actress, a director",
              typical: 31,
              ceiling: 37,
              best: {
                brandName: "Dior",
                title: "Miss Dior campaign film — Natalie Portman",
                pts: 38.1,
              },
              received: 85,
              own: [
                { title: "Icons, Natalie Portman", pts: 28.3 },
                { title: "Love & Celebration, Mikey Madison", pts: 28.2 },
                { title: "With Love, Since 1837, Rosie", pts: 26.8 },
                { title: "A HardWear Film", pts: 25.9 },
                { title: "HardWear campaign film", pts: 25.6 },
                { title: "the Mona Fastvold film", pts: 24.7 },
                { title: "Sixteen Stone, Natalie Portman", pts: 23.3 },
                { title: "Grace Wright film", pts: 20.9 },
                { title: "Anna Weyant film", pts: 15.4 },
              ],
              note: "Your default — nine pieces this year, five of them Natalie Portman — graded on beauty and received at 25 to 65 by the audience you already own. The same face reads 85 for Miss Dior, because a fragrance reaches a crowd a diamond does not.",
            },
            {
              id: "tiein",
              label: "Tie-in",
              sub: "a partner's story",
              typical: 30,
              ceiling: 37,
              best: {
                brandName: "Starbucks",
                title: "Pumpkin Spice Latte × Martha Stewart",
                pts: 39.2,
              },
              received: 70,
              own: [
                { title: "The Devil Wears Prada 2", pts: 37.3 },
                { title: "Frankenstein, the Cannes Lion", pts: 36.0 },
              ],
              note: "Your two highest-graded pieces of the year, and both cooled by half within the month — the partner's audience came, looked, and left with the partner.",
            },
            {
              id: "still",
              label: "Still & editorial",
              sub: "the campaign image",
              typical: 28,
              ceiling: 34,
              best: {
                brandName: "Saint Laurent",
                title: "Fall/Winter 2026 campaign",
                pts: 46.3,
              },
              received: 80,
              own: [
                { title: "1837 Blue conservation", pts: 33.5 },
                { title: "Blue Book: Hidden Garden", pts: 33.2 },
                { title: "Blue Book editorial", pts: 32.3 },
                { title: "Bird on a Rock campaign", pts: 28.5 },
                { title: "Lose Yourself in Love", pts: 26.7 },
                { title: "Learning Lines", pts: 26.3 },
                { title: "Connor Storrie, Blue Book", pts: 23.0 },
                { title: "Love & Celebration", pts: 22.7 },
                { title: "Vivienne Rohner", pts: 20.3 },
                { title: "Strong Like Mom", pts: 14.2 },
              ],
              note: "Ten pieces, the most of any format on your shelf, graded in the twenties and read in the twenties where they were read at all — except the Blue Book pages, which the high-jewelry crowd answered at 65 and 75. The field's stills carry when a fandom face is in the frame — Saint Laurent's read 80 — and yours carry a motif.",
            },
          ],
        },
        {
          kind: "radar",
          title: "The capital your content carries",
          provenance: "observed",
          note: "Each axis is one of the five capitals a piece of content can carry. Your content and the field's are measured strategy fit on the record; what Gen Z shares is modeled on the pieces the crowd carried this year. Tap a series to morph the shape — the dashed outline is the field's whole content shelf.",
          axes: [
            "Scarcity",
            "Opacity",
            "Aesthetic innovation",
            "Fandom",
            "Identity signal",
          ],
          baseline: {
            id: "field",
            label: "The field's content",
            values: [12, 10, 52, 24, 34],
          },
          series: [
            { id: "yours", label: "Your content", values: [6, 8, 58, 4, 18] },
            {
              id: "carrying",
              label: "The field's carrying content",
              values: [20, 12, 68, 62, 74],
            },
            {
              id: "genz",
              label: "What Gen Z shares",
              values: [18, 8, 46, 88, 72],
            },
          ],
        },
        {
          kind: "quadrant",
          title: "Your shelf, piece by piece",
          provenance: "observed",
          x: { label: "Capital carried", low: "quiet", high: "carried" },
          y: { label: "Gen Z pull", low: "not theirs", high: "theirs" },
          quadrants: {
            tr: "Make more of this",
            tl: "Shared, not kept",
            br: "Prestige, not a crowd",
            bl: "Retire the format",
          },
          note: "Capital carried is each piece's graded strength on the record; Gen Z pull is modeled on who shared it. The three haloed dots are the recommended formats, placed where the field's precedents price them. Tap a dot for the read.",
          points: [
            {
              id: "camera",
              label: "The ambassador's own camera",
              short: "Their camera",
              era: "Fandom's camera",
              color: "#4FC3F7",
              x: 84,
              y: 84,
              w: 60,
              status: "recommended",
              note: "Jimin and ROSÉ shoot the Lock and post it first — the field's carrying content is what the faces post themselves.",
            },
            {
              id: "oldnew",
              label: "Old vs new, by the crowd",
              short: "Old vs new",
              era: "Crowd's content",
              color: "#B388FF",
              x: 74,
              y: 72,
              w: 55,
              status: "recommended",
              note: "Hand the heart-tag argument to the creators already having it; the workshop verifies, the best clip gets the piece.",
            },
            {
              id: "bench",
              label: "The bench, weekly",
              short: "The bench",
              era: "The bench",
              color: "#4ADE80",
              x: 54,
              y: 60,
              w: 45,
              status: "recommended",
              note: "Thirty seconds a week from the workshop, phone-shot — the human hand is the counter-signal the feed rewards.",
            },
            {
              id: "this-is-tiffany",
              label: "This is Tiffany · Jimin, Zoë Kravitz, Gal Gadot",
              era: "Fandom's camera",
              color: "#4FC3F7",
              x: 66,
              y: 82,
              w: 60,
              note: "Your only piece with fandom faces and the warmest read on your shelf — presence 75, warm at plus eighty, and three faces split the conversation three ways.",
            },
            {
              id: "kendrick",
              label: "Kendrick Lamar · the unprecedented piece",
              era: "Fandom's camera",
              color: "#4FC3F7",
              x: 58,
              y: 74,
              w: 45,
              note: "Fresh on the run — the first content you have made with a musician's own audience attached.",
            },
            {
              id: "dwp2",
              label: "The Devil Wears Prada 2 campaign",
              era: "Tie-in",
              color: "#F472B6",
              x: 66,
              y: 54,
              w: 50,
              note: "Your highest-graded piece of the year, and it cooled by half in a month — the film's audience, not yours.",
            },
            {
              id: "frankenstein",
              label: "Frankenstein · the Cannes Gold Lion",
              era: "Tie-in",
              color: "#F472B6",
              x: 56,
              y: 44,
              w: 45,
              note: "A Gold Lion is the trade's applause, not a crowd's.",
            },
            {
              id: "conservation",
              label: "1837 Blue conservation campaign",
              era: "Still & editorial",
              color: "#D7A97C",
              x: 54,
              y: 30,
              w: 40,
              note: "An award from the business press — the story Gen Z would share if it were a clip from the field, not a release.",
            },
            {
              id: "bluebook",
              label: "Blue Book · Hidden Garden editorial",
              era: "Still & editorial",
              color: "#D7A97C",
              x: 52,
              y: 12,
              w: 50,
              note: "Read at 65 and 75 by the high-jewelry crowd — the trade's feed, not Gen Z's.",
            },
            {
              id: "mikey",
              label: "Love & Celebration · Mikey Madison",
              era: "Face film",
              color: "#94A3B8",
              x: 46,
              y: 38,
              w: 45,
              note: "The right face for the self-purchase story, read at 65 by the audience you already own and shared by nobody younger.",
            },
            {
              id: "natalie",
              label: "Natalie Portman · the HardWear films",
              era: "Face film",
              color: "#94A3B8",
              x: 42,
              y: 22,
              w: 70,
              note: "Five pieces this year, presence 25 to 50 — admired by the audience you already own.",
            },
            {
              id: "rosie",
              label: "With Love, Since 1837 · Rosie Huntington-Whiteley",
              era: "Face film",
              color: "#94A3B8",
              x: 36,
              y: 16,
              w: 35,
              note: "The heritage line, read at 60 by the audience you already own — delivered by a face the crowd does not follow.",
            },
            {
              id: "riot",
              label: "Where Light Meets Rebellion · RIOT",
              era: "Made thing",
              color: "#FDE047",
              x: 26,
              y: 44,
              w: 30,
              note: "The one made thing on your shelf — and the field's made things are received at 90.",
            },
            {
              id: "learning",
              label: "Learning Lines",
              era: "Still & editorial",
              color: "#D7A97C",
              x: 30,
              y: 26,
              w: 30,
              note: "Presence 20 — a campaign the record barely noticed.",
            },
            {
              id: "strong",
              label: "Strong Like Mom",
              era: "Still & editorial",
              color: "#D7A97C",
              x: 18,
              y: 14,
              w: 25,
              note: "Your weakest piece of the year — a greeting card, not a story.",
            },
          ],
        },
        {
          kind: "plays",
          title: "Three plays, priced",
          provenance: "projected",
          plays: [
            {
              name: "The ambassador's own camera — the Lock, shot by Jimin and ROSÉ, on their channels first",
              itemType: "content",
              window:
                "October · the Lock window — their channels first, yours a day later, the film cut from their footage",
              strategies: [
                { code: "fandom", fit: 0.9 },
                { code: "identity_signal", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.4 },
              ],
              why: "This is Tiffany is your only content with fandom faces and the warmest read on your shelf. The field's carrying content is what the faces post themselves — RM's covers for Bottega Veneta read 77, Ningning for Gucci 68, Jimin's own summer clips for Dior — because a clip a face shoots reads as the face's, and a film you cut about the face reads as your advertisement. Give Jimin and ROSÉ the Lock and the camera, let their channels go first, and cut your film from their footage rather than the other way round.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.4, 0.65, 0.75, 0.8],
              },
              precedents: 9,
              reception: "the fandom's content is received at eighty",
              similar: [
                {
                  brand: "bottega-veneta",
                  brandName: "Bottega Veneta",
                  title: "RM BTS Ambassadorship Magazine Covers",
                  pts: 77.3,
                },
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title:
                    "Beauty and the Bag campaign featuring Ningning of Aespa",
                  pts: 68.0,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title:
                    "Jimin Shares New Dior Campaign Content for #diorsummer27",
                  pts: 36.8,
                },
              ],
            },
            {
              name: "Old vs new, by the crowd — the heart-tag argument, handed to the creators already having it",
              itemType: "content",
              window:
                "November · with the heart tag's return — the workshop verifies the pieces, the best clip gets one",
              strategies: [
                { code: "identity_signal", fit: 0.8 },
                { code: "fandom", fit: 0.7 },
                { code: "scarcity", fit: 0.5 },
              ],
              why: "TikTok already argues old versus new Return to Tiffany without you, and Pandora's own revival began with a creator's clip, not a campaign. The strongest content on the board is made by the crowd — Apple's phone campaign carries the biggest fandom fit on record — and the format with the largest CIQ lifts this summer was participation, not production. Make the argument official: invite the comparisons, let the workshop verify the vintage pieces on camera, and give the best clip the new edition.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.2, 0.4, 0.55, 0.6],
              },
              precedents: 7,
              reception: "the crowd's own content is received at eighty",
              similar: [
                {
                  brand: "apple",
                  brandName: "Apple",
                  title: '"Shot on iPhone" Campaign (Ongoing Activity)',
                  pts: 88.4,
                },
                {
                  brand: "duolingo",
                  brandName: "Duolingo",
                  title: "RIP Duo Campaign",
                  pts: 41.0,
                },
                {
                  brand: "pandora",
                  brandName: "Pandora",
                  title:
                    "Pandora unveils Pandora Wonders with a whimsical Harry Lambert collaboration",
                  pts: 38.7,
                },
              ],
            },
            {
              name: "The bench — thirty seconds a week from the workshop, phone-shot, unpolished",
              itemType: "content",
              window:
                "September on · one clip a week — a setter, an engraver, a trophy, an archive drawer",
              strategies: [
                { code: "identity_signal", fit: 0.6 },
                { code: "aesthetic_innovation", fit: 0.6 },
                { code: "opacity", fit: 0.3 },
              ],
              why: "The feed is full of machine-made images, and the counter-signal Gen Z rewards is the human hand: the best-received content of the summer was Dior's hand-drawn film at 90, and Hermès' illustrated pages carried the largest content lift on the board. You have a workshop, trophies, setters and an archive, and none of it is on your shelf below the Blue Book. Thirty seconds a week, shot on a phone, no face — a series compounds where a film cools.",
              effect: {
                label: "CIQ",
                delta: 0.5,
                series: [0, 0.1, 0.25, 0.4, 0.5],
              },
              precedents: 8,
              reception: "the made thing is received at ninety",
              similar: [
                {
                  brand: "dior",
                  brandName: "Dior",
                  title:
                    "The Story of A Miss (Miss Dior Studio Ghibli-esque Animated Video)",
                  pts: 50.1,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton Reinvents the Trunk (130th Monogram Anniversary Trunk Campaign)",
                  pts: 44.8,
                },
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title:
                    "Hermès x Sarah Martinon Illustrated Digital Experience",
                  pts: 40.4,
                },
              ],
            },
          ],
        },
        {
          kind: "impact",
          title: "What the ambassador's camera carries",
          provenance: "projected",
          delta: 0.8,
          body: "The Lock shot by Jimin and ROSÉ and posted on their channels first carries a projected lift on your published score over the following two windows — most of it in the first, as the fandom shares it, with the rest arriving as your own cut lands on the footage.",
        },
        {
          kind: "modelView",
          body: "Make less film and more feed. Your content is the best-made on the board and the least shared, because it is built to be admired: a face you hired, a director you commissioned, a cut you approved.\n\nThe field's content that carries is built to be passed along — a face the crowd already follows, holding the camera; a crowd allowed to make the piece; a hand shown doing the work. Gen Z does not share an advertisement; it shares a person, an argument or a craft. Give Jimin and ROSÉ the Lock and let them post it first, give the creators the old-versus-new argument they are already having, and give the bench a weekly thirty seconds. Keep the films for the diamond buyer, who wants to be reassured rather than reached — and stop reading the lane's score as proof: a shelf of quiet pieces reads strong and moves nobody.",
        },
      ],
    },
    {
      id: "where-in-culture",
      itemType: "experience",
      type: "experience",
      // OFF the recommended chips since 2026-10-06 (user call: "where in
      // culture should we show up next — remove it from recommended in lab");
      // the ring-night briefing card still deep-links here and the advisor
      // slate carries its three priced experiences
      featured: false,
      question:
        "Where in culture should we show up next — and what should we do there?",
      aliases: [
        "where in culture should we show up next",
        "where should we appear in culture",
        "where should tiffany appear in culture",
        "which experience should we do next",
        "which experience would have the biggest impact",
        "which experience has the best return",
        "should our next experience be intimate or mass",
        "new york or paris",
        "should we do it in our store or somewhere else",
        "which cultural stage should we take next",
      ],
      askedOn: "2026-09-04",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Be the host, not the guest: a public New York stage, a crowd you didn't gather — the trophy, not the gala.",
        },
        {
          kind: "arena",
          title: "Seven stages, field and yours",
          provenance: "measured",
          unit: "graded strength · pts",
          note: "Bands are the field's range for experiences and events on each stage — typical to ceiling of graded strength across every brand on the board; the ring is the field's strongest play there, the dots are yours. Received = the best presence measured on that stage. Tap a stage for the read.",
          rows: [
            {
              id: "fashion",
              label: "Fashion",
              sub: "the runway, the gala",
              typical: 41,
              ceiling: 52,
              best: {
                brandName: "Chanel",
                title: "Fall/Winter 2026/27 Haute Couture show",
                pts: 63.3,
              },
              received: 85,
              own: [
                { title: "Summer Garden cocktail", pts: 37.9 },
                { title: "Hidden Garden unveiling, Hong Kong", pts: 30.9 },
                { title: "Garden Series conclusion", pts: 29.3 },
                { title: "Hidden Garden launch gala", pts: 28.7 },
                { title: "East Hampton cocktail", pts: 28.3 },
              ],
              note: "The field's strongest stage and the fashion houses' format — a runway, a couture week, a front row. You play it as a jeweler plays it: the gala. Five this summer, graded high on brand fit and low on draw, received by the guest list.",
            },
            {
              id: "music",
              label: "Music",
              sub: "the concert, the festival",
              typical: 32,
              ceiling: 38,
              best: {
                brandName: "Netflix",
                title: "Flight of the Conchords reunion",
                pts: 52.0,
              },
              received: 70,
              note: "A stage you have never played as an experience — your music is faces and collaborations. When the field puts a singer in a room the room is received at 70, and your fandom bench is the deepest on the board.",
            },
            {
              id: "sport",
              label: "Sport",
              sub: "the stadium, the trophy",
              typical: 30,
              ceiling: 37,
              best: {
                brandName: "Louis Vuitton",
                title: "FIFA World Cup 2026 trophy trunk",
                pts: 54.8,
              },
              received: 90,
              own: [
                { title: "US Open pop-up", pts: 34.1 },
                { title: "Knicks trophy week", pts: 28.4 },
                { title: "US Open pop-up, the event", pts: 26.0 },
              ],
              status: "recommended",
              note: "The field's best-received stage — public crowds read at 80 and 90, and the field's best play here is a trophy trunk. You hold what nobody else on the board has: you make the trophy — and you have played it as a store display and a photo corner.",
            },
            {
              id: "entertainment",
              label: "Entertainment",
              sub: "the premiere, the red carpet",
              typical: 29,
              ceiling: 35,
              best: {
                brandName: "Giorgio Armani",
                title: "Zendaya at the Spider-Man premiere, Rome",
                pts: 48.9,
              },
              received: 90,
              own: [
                { title: "Devil Wears Prada window", pts: 23.1 },
                { title: "Frankenstein windows", pts: 22.5 },
              ],
              note: "For a jeweler the red carpet is a loan, not a play — a lent piece worn and credited is reception, never an event. Your two tie-ins this year were windows, and windows cool in a month.",
            },
            {
              id: "design",
              label: "Design & heritage",
              sub: "the exhibition, the museum",
              typical: 28,
              ceiling: 34,
              best: {
                brandName: "Louis Vuitton",
                title: "Visionary Journeys, LV The Place Bangkok",
                pts: 53.3,
              },
              received: 80,
              own: [
                { title: "Legendary Legacy, Bangkok", pts: 36.1 },
                { title: "Tiffany Wonder, Tokyo", pts: 30.7 },
                { title: "Garden in Bloom, Singapore", pts: 26.2 },
                { title: "the Astronomical Clock", pts: 24.3 },
                { title: "Treasures of Tiffany", pts: 23.1 },
              ],
              note: "Your heritage stage — five exhibitions this year, graded on stature rather than draw: no named attendee, no queue. The class cools fastest of all: Tiffany Wonder read 31 in June and 5 by August.",
            },
            {
              id: "street",
              label: "The street",
              sub: "the bodega, the block",
              typical: 27,
              ceiling: 32,
              best: {
                brandName: "Coca-Cola",
                title: "Jacob's Soda Fountain at The Battery",
                pts: 39.6,
              },
              received: 85,
              own: [{ title: "Blue Bodega takeover", pts: 23.9 }],
              note: "Your most Tiffany idea of the year lasted one day, so it graded as a stunt with no crowd. The field's street plays keep their level because they repeat — a Friday night at MoMA, a rec center, a soda fountain that is still there.",
            },
            {
              id: "rooms",
              label: "Your own rooms",
              sub: "the flagship, the café",
              typical: 25,
              ceiling: 31,
              best: {
                brandName: "Louis Vuitton",
                title: "Gaggan at Louis Vuitton, Bangkok",
                pts: 68.6,
              },
              received: 85,
              own: [
                { title: "Lee Gardens Three café", pts: 55.9 },
                { title: "the Landmark experience", pts: 47.9 },
                { title: "ION Orchard café", pts: 47.0 },
                { title: "Lee Gardens flagship", pts: 44.1 },
                { title: "South Coast Plaza", pts: 33.8 },
                { title: "ION Orchard reopening", pts: 28.1 },
                { title: "Ginza grand opening", pts: 23.6 },
                { title: "Taikoo Li Sanlitun", pts: 18.3 },
              ],
              note: "Your strongest stage by your own grades — the café sits above the field's whole hospitality range and Lee Gardens is your best-received play outside the United States. Each room opens once; the field's ceiling here is a restaurant that stays open.",
            },
          ],
        },
        {
          kind: "matrix",
          title: "Format × stage, priced as carry",
          provenance: "projected",
          cols: ["Your store", "The city", "Someone else's stage"],
          note: "Cell brightness is modeled carry per play — what an experience of that shape is worth on your shelf, priced on the field's record and yours. Tap a cell for the read.",
          rows: [
            {
              label: "Intimate · a room, a list",
              cells: [
                {
                  v: 58,
                  note: "Your default — the gala, the salon, the café lunch: strong on brand fit, read by a guest list. The Lee Gardens café is the exception, because a crowd found it on its own.",
                },
                {
                  v: 44,
                  note: "East Hampton, the Armory — a cocktail travels exactly as far as its guest list.",
                },
                {
                  v: 52,
                  note: "A dinner at the Garden, a box at Flushing Meadows — reads as a guest at someone else's party, unless a fandom carries it out of the room.",
                },
              ],
            },
            {
              label: "Public · a crowd, a queue",
              cells: [
                {
                  v: 63,
                  note: "The Knicks week: the building lit, the trophy on the sixth floor — the crowd came to the door, and the record cooled within the month.",
                },
                {
                  v: 71,
                  note: "The bodega, done once for a day. The field's street plays keep their level because they repeat — Uniqlo's Friday nights, Nike's rec center.",
                },
                {
                  v: 88,
                  note: "The field's ceiling — Red Bull at Mostar, Nike at Fanatics Fest, Coca-Cola at The Battery: crowds the brand did not have to gather, received at 80 and 90.",
                },
              ],
            },
          ],
        },
        {
          kind: "geoCompare",
          title: "Host or guest — the pull of each city",
          provenance: "projected",
          metric: "Home-stage pull",
          focus: "new-york",
          note: "Modeled pull of a public experience in each city — whether the house is the host there or a guest on someone else's calendar. New York is the ringed focus; tap a city to read it against New York.",
          markets: [
            {
              id: "new-york",
              label: "New York",
              x: 30.3,
              y: 11.5,
              value: 92,
              note: "The host's city — your trophies, your Landmark, the year's two biggest public moments — and every play you ran here, you ran from the store.",
            },
            {
              id: "hong-kong",
              label: "Hong Kong",
              x: 84.1,
              y: 18.2,
              value: 74,
              note: "Your best-received play outside the United States — the Lee Gardens flagship and café read 85, the Lee Gardens Three café 70; the Hidden Garden unveiling landed on top of them and read nothing.",
            },
            {
              id: "tokyo",
              label: "Tokyo",
              x: 91.3,
              y: 13.3,
              value: 71,
              note: "Ginza opened with the café in August — a stage already built; Tiffany Wonder proved the exhibition crowd lives here.",
            },
            {
              id: "seoul",
              label: "Seoul",
              x: 87.7,
              y: 12.6,
              value: 66,
              note: "The fandom's capital — the crowd that buys the Lock on a date; a stage you have only ever played through faces.",
            },
            {
              id: "singapore",
              label: "Singapore",
              x: 81.1,
              y: 25.9,
              value: 58,
              note: "ION Orchard reopened with the café — three plays this summer, presence in the forties.",
            },
            {
              id: "shanghai",
              label: "Shanghai",
              x: 86.1,
              y: 15.0,
              value: 55,
              note: "Archive masterpieces in the boutique this spring, and Beijing's Sanlitun flagship opened in August — no measured crowd on the mainland yet.",
            },
            {
              id: "bangkok",
              label: "Bangkok",
              x: 80.1,
              y: 21.4,
              value: 52,
              note: "Legendary Legacy and the HardWear wrap — a heritage stage, with the field's hospitality ceiling next door at Louis Vuitton.",
            },
            {
              id: "los-angeles",
              label: "Los Angeles",
              x: 17.7,
              y: 13.9,
              value: 47,
              note: "The premiere city — the red carpet borrows your pieces, and the loan is never the work.",
            },
            {
              id: "london",
              label: "London",
              x: 51.4,
              y: 7.5,
              value: 40,
              note: "Frankenstein at the Old Selfridges Hotel — a window on someone else's story, not a stage.",
            },
            {
              id: "paris",
              label: "Paris",
              x: 52.1,
              y: 8.5,
              value: 33,
              note: "The guest's city — Place Vendôme is Cartier's street, the runway is the fashion houses' format and the parent's stage is Louis Vuitton's; you present the Blue Book in couture week and leave. Prices a third of New York.",
            },
          ],
        },
        {
          kind: "plays",
          title: "Three experiences, priced",
          provenance: "projected",
          plays: [
            {
              name: "Ring night at the Garden — the trophy's homecoming, and a free public week behind it",
              itemType: "experience",
              window:
                "October · opening night, the twentieth — the Garden floor, then a public hall for the week",
              strategies: [
                { code: "fandom", fit: 0.85 },
                { code: "identity_signal", fit: 0.7 },
                { code: "scarcity", fit: 0.35 },
              ],
              why: "The Knicks raise their first banner in fifty-three years on national television, and the trophy they lift is yours. Put the house on the floor for the ceremony and open a free room in the city for the week after — every trophy you make, the engravers at their benches, the Larry O'Brien back from the museum — and the crowd is one you did not have to gather. Your June play had the right idea and the wrong room: a sixth floor is a display; a public hall is a stage.",
              effect: {
                label: "CIQ",
                delta: 0.9,
                series: [0, 0.45, 0.75, 0.85, 0.9],
              },
              precedents: 9,
              reception: "public sport plays are received at 80 and 90",
              similar: [
                {
                  brand: "red-bull",
                  brandName: "Red Bull",
                  title: "Red Bull Cliff Diving World Series 2026 - Mostar",
                  pts: 71.4,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Nike at Fanatics Fest 2026",
                  pts: 41.8,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title: "FIFA World Cup 2026 trophy trunk",
                  pts: 39.9,
                },
              ],
            },
            {
              name: "Landmark After Hours — one music face, one night in your rooms, seats by public ballot",
              itemType: "experience",
              window:
                "November · the first session before the holidays — one face, one room, the film out by morning",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "scarcity", fit: 0.7 },
                { code: "identity_signal", fit: 0.5 },
              ],
              why: "Your intimate rooms are your best-graded plays and your least-received: a guest list reads to a guest list. A live session after closing — one fandom face, the Lock room, a hundred seats drawn by a public ballot, the film out by morning — keeps the room small and lets the fandom carry it out of the building. Chanel walked Wang Yibo through the 19M and it read like a public event; Starbucks put a singer in a room and was received at 70.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.3, 0.5, 0.6, 0.6],
              },
              precedents: 8,
              reception: "a ballot turns a hundred seats into a public",
              similar: [
                {
                  brand: "chanel",
                  brandName: "Chanel",
                  title:
                    "Wang Yibo explores the 2026 Métiers d'Art collection at the 19M building",
                  pts: 49.3,
                },
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title:
                    'Marriott Bonvoy and Starbucks Host "One Night With Myles Smith"',
                  pts: 28.7,
                },
                {
                  brand: "red-bull",
                  brandName: "Red Bull",
                  title:
                    "Red Bull Chapters Ticket Launch (Rauw Alejandro concert)",
                  pts: 27.9,
                },
              ],
            },
            {
              name: "Blue Bodega Saturdays — the street play, repeated until it is a ritual",
              itemType: "experience",
              window:
                "Spring · ten Saturdays, ten neighborhoods — the heart tag on the counter, the coffee on the house",
              strategies: [
                { code: "identity_signal", fit: 0.75 },
                { code: "aesthetic_innovation", fit: 0.5 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "The bodega takeover was your most Tiffany idea of the year and it lasted a day, so it graded as a stunt with no crowd. The field's street plays keep their level because they repeat — Uniqlo's free Friday nights at MoMA, Nike's rec center in Crenshaw, a soda fountain that is still open — and repetition is what turns a stunt into a ritual. Ten Saturdays, ten neighborhoods, a counter that sells one silver piece and gives the coffee away: the ritual is the product.",
              effect: {
                label: "CIQ",
                delta: 0.5,
                series: [0, 0.15, 0.3, 0.45, 0.5],
              },
              precedents: 6,
              reception: "the street reads at 80 when it comes back",
              similar: [
                {
                  brand: "coca-cola",
                  brandName: "Coca-Cola",
                  title:
                    "Coca-Cola Pop-up Experience at The Battery Atlanta: Jacob's Soda Fountain",
                  pts: 44.6,
                },
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "NYC MoMA Friday Night Uniqlo Free Entry Program",
                  pts: 37.4,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "The Crenshaw Rec by Foot Locker",
                  pts: 30.0,
                },
              ],
            },
          ],
        },
        {
          kind: "impact",
          title: "What ring night does to your CIQ",
          provenance: "projected",
          delta: 0.9,
          body: "Ring night at the Garden, with the public week behind it, carries a projected lift on your published score over the following two windows — most of it in the first, as the crowd and the coverage land, with the rest arriving while the room keeps its queue.",
        },
        {
          kind: "modelView",
          body: "Be the host, not the guest. Your record says your experiences are your own rooms and your own lists — beautifully graded, quietly received — and the field says the experiences that carry are public crowds on stages the brand did not build.\n\nThe mistake would be to answer that with a bigger gala or a Paris show: Paris is where you are a guest of the fashion houses, and a runway is not your format. New York is the one city where you are the host — the trophy is yours, the building is yours, and the year's biggest crowds walked past both — so take the Garden on ring night, open a free room for the week, and let a crowd you did not have to gather do the receiving. Keep the intimate room, but only where a fandom can carry it out of the building, and give the street a rhythm instead of a stunt. Where to appear is settled by who is already there; what to do there is settled by whether they can get in.",
        },
      ],
    },
    {
      id: "fans-per-market",
      itemType: "community",
      type: "fans",
      question: "Who are Tiffany's biggest fans, per market?",
      aliases: [
        "who are tiffanys biggest fans per market",
        "who are our biggest fans per market",
        "who are our biggest fans in each market",
        "who are tiffanys biggest fans in each market",
        "who are our biggest fans by market",
        "who are tiffanys biggest fans by market",
        "who are our biggest fans market by market",
        "who are our fans per market",
        "who are our biggest fans",
        "who are tiffanys biggest fans",
        "where are our biggest fans",
        "which market has our biggest fans",
        "which markets have our biggest fans",
      ],
      askedOn: "2026-10-06",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Millennial women at home, Gen X in Japan, Gen Z in Seoul and Shanghai — fans of one piece, not yet of the house.",
        },
        {
          kind: "stats",
          insight:
            "Your house is American in its sales, its visitors and its fans — and abroad, the one play the crowd answered this summer was a room it could sit in.",
          provenance: "observed",
          items: [
            {
              label: "Sales at home",
              value: "44%",
              hint: "in the Americas, last own filing · Asia-Pacific 28 · Japan 15 · Europe 11",
            },
            {
              label: "Site visitors from the US",
              value: "72%",
              hint: "of tiffany.com's visitors · two in three women · 25 to 34 the largest age group",
            },
            {
              label: "Plays abroad this summer",
              value: "16 of 85",
              hint: "plays we measured outside the US · 14 in Asia-Pacific · 2 in Europe · none in Korea",
            },
            {
              label: "Best read abroad",
              value: "85",
              hint: "the Lee Gardens café, Hong Kong · Tokyo, Milan and the mainland read nothing",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Depth follows silver and age: the markets where your fans are brand fans are the ones that bought your silver twenty years ago — home and Japan — and the markets where the fans are loudest, Seoul and the mainland, have a ladder with one rung.",
          title: "Fan depth, market by market",
          provenance: "projected",
          note: "Fan depth is a modelled index, 0 to 100, of how far each market's customers climb the ladder — from a gift bought once to a collector who brings others in — weighted by how many of them there are. The United States is the Silver Lab's own ladder; the other markets are modelled on it from their record and their public facts. Fast clock: the fans respond within weeks, in searches, resale and posts. Slow clock: over years, in repeat purchase and full price. Tap a market for the evidence.",
          rows: [
            {
              id: "united-states",
              label: "United States",
              context: "Millennial women, self-bought",
              score: 84,
              role: "Biggest and deepest",
              horizon: "long",
              drivers: [
                "Forty-four percent of sales in the Americas in your last own filing, and seventy-two percent of your site's visitors — two in three of them women, twenty-five to thirty-four the largest age group.",
                "Every hundred US customers of the last three years sort into thirty-four occasion buyers, forty-one product fans, twenty-one brand fans and four superfans; the quarter at the top brings more than half the sales.",
                "About half of today's brand fans and nearly a third of the superfans started with a silver piece. Gen X ranks you first among jewelry brands and is your most loyal generation; Gen Z ranks you second, behind Cartier.",
                "Six of your sixteen plays at home were read this summer — the Knicks' title night and the lit flagship 80, the CFDA awards 75, the Garden Series parties 60.",
              ],
            },
            {
              id: "japan",
              label: "Japan",
              context: "Gen X — the Open Heart generation",
              score: 76,
              role: "Most loyal abroad",
              horizon: "long",
              drivers: [
                "Fifteen percent of sales in your last own filing and your second market for three decades; the Open Heart and the Bean sold here as nowhere else.",
                "The women who bought them in the nineties are Gen X now — the most loyal fans you have in any market, and the generation that pays full price for Peretti.",
                "Nothing you played there this summer was read: the Ginza anniversary and the Wonder exhibition read zero; the Ginza flagship opened with the café in August, too new for a read.",
              ],
            },
            {
              id: "korea",
              label: "South Korea",
              context: "Gen Z — the fandom's capital",
              score: 68,
              role: "Loudest fans, thinnest ladder",
              horizon: "short",
              drivers: [
                "Jimin and ROSÉ are the faces of the house; the warmest piece of content on your shelf is the Jimin campaign — read at 75, warm at +80, level with your best room.",
                "Their fandoms buy the Lock and HardWear on a date — product fans of one piece, made in weeks; nearly half of your Korean fans are Gen Z, and few have had the years or the money to climb.",
                "No play in Seoul itself this summer — no room, no event; every Korean fan you have was reached through a face.",
              ],
            },
            {
              id: "hong-kong-singapore",
              label: "Hong Kong and Singapore",
              context: "Clients and the café queue",
              score: 62,
              role: "The client and the café queue",
              horizon: "long",
              drivers: [
                "The Lee Gardens flagship and Blue Box Café read 85 and warm at +80 — your best-received play outside the United States; ION Orchard reopened with the café and a Singapore-only Sixteen Stone watch, read 65.",
                "The two cities hold your deepest superfans abroad — the high-jewelry clients the Blue Book travels to — over a café queue of product fans.",
                "Hospitality is the one stage where your own rooms beat the field's, and here the room is the fandom's.",
              ],
            },
            {
              id: "china",
              label: "Mainland China",
              context: "Gen Z and Millennial self-buyers",
              score: 55,
              role: "Product fans, no brand fans yet",
              horizon: "short",
              drivers: [
                "Asia-Pacific was twenty-eight percent of sales in your last own filing, the mainland the largest part of it; the fans there are Gen Z and Millennial women buying HardWear and the T for themselves.",
                "Product fans by every measure — one piece, bought on a date, worn as a signal — and almost no brand fans yet: the ladder above that rung is empty, as it is for every house a decade into the market.",
                "No play on the mainland was read this summer; the Sanlitun flagship opened in August, too new for a read.",
              ],
            },
            {
              id: "europe",
              label: "Europe",
              context: "The gift, the tourist, the collector",
              score: 38,
              role: "Thinnest base",
              horizon: "long",
              drivers: [
                "Eleven percent of sales in your last own filing; Place Vendôme is Cartier's street and Bond Street a tourist's.",
                "Two plays in the region this summer — the Milan window and a film — and neither was read; Frankenstein's London installation, played from New York, read 40.",
                "The fans you have here are collectors in the vintage trade, where London and Paris dealers price your silver; the brand fan is the American on holiday.",
              ],
            },
          ],
        },
        {
          kind: "stacks",
          insight:
            "Only two markets have a real top of the ladder — home and Japan, where a quarter or more of customers are brand fans — and in the young markets half the customers love one piece, the rung where a silver piece does its work.",
          title: "The ladder, market by market",
          provenance: "projected",
          note: "Every hundred customers in each market sorted onto four rungs: occasion buyers who bought once, for a gift or a milestone; product fans who love one piece; brand fans who own several collections and follow the house; superfans who collect, know the hallmarks and bring others in. The United States row is the Silver Lab's own ladder; the other markets are modelled on the same basis from their record and public facts. Tap a row.",
          legend: [
            { key: "occ", label: "Occasion buyers", color: "#94A3B8" },
            { key: "prod", label: "Product fans", color: "#60A5FA" },
            { key: "brand", label: "Brand fans", color: "#4ADE80" },
            { key: "coll", label: "Superfans", color: "#FF9F43" },
          ],
          rows: [
            {
              id: "united-states",
              label: "United States",
              sub: "the Silver Lab's own ladder",
              parts: [
                { key: "occ", v: 34 },
                { key: "prod", v: 41 },
                { key: "brand", v: 21 },
                { key: "coll", v: 4 },
              ],
              note: "A quarter of your customers bring more than half the sales, and the other three quarters are where that quarter comes from. Product fans are the largest rung — someone who loves one piece — and for most of your history that piece was silver.",
            },
            {
              id: "japan",
              label: "Japan",
              sub: "deepest abroad",
              parts: [
                { key: "occ", v: 28 },
                { key: "prod", v: 36 },
                { key: "brand", v: 29 },
                { key: "coll", v: 7 },
              ],
              note: "The only market outside home where brand fans are more than a quarter: the Open Heart generation, thirty years in, owns several collections and follows the house. The superfans are the Ginza high-jewelry clients.",
            },
            {
              id: "hong-kong-singapore",
              label: "Hong Kong and Singapore",
              sub: "the client and the café queue",
              parts: [
                { key: "occ", v: 36 },
                { key: "prod", v: 40 },
                { key: "brand", v: 18 },
                { key: "coll", v: 6 },
              ],
              note: "A top-heavy ladder for its size — the high-jewelry clients the Blue Book travels to — over a queue of product fans at the café.",
            },
            {
              id: "korea",
              label: "South Korea",
              sub: "the fandom's capital",
              parts: [
                { key: "occ", v: 36 },
                { key: "prod", v: 52 },
                { key: "brand", v: 10 },
                { key: "coll", v: 2 },
              ],
              note: "Half of every hundred customers love one piece — the Lock, HardWear — bought on a face's date. The brand-fan rung is a tenth: nobody has had the years.",
            },
            {
              id: "china",
              label: "Mainland China",
              sub: "product fans, young",
              parts: [
                { key: "occ", v: 40 },
                { key: "prod", v: 46 },
                { key: "brand", v: 12 },
                { key: "coll", v: 2 },
              ],
              note: "Four in ten bought once, for a gift or a milestone; nearly half love one piece, HardWear or the T, bought for themselves. The two rungs above are thin, as they are for every house a decade in.",
            },
            {
              id: "europe",
              label: "Europe",
              sub: "the gift and the tourist",
              parts: [
                { key: "occ", v: 50 },
                { key: "prod", v: 36 },
                { key: "brand", v: 12 },
                { key: "coll", v: 2 },
              ],
              note: "Half the customers bought once — a gift, a stop on a trip. The brand fans are a small base of collectors; the superfans are vintage buyers who know the hallmarks.",
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Millennials are the largest fan group in four of six markets; Japan's fan is Gen X and Korea's is Gen Z — no market's fans are younger than Korea's or older than Japan's, and neither of the two was reached this summer.",
          title: "Fans by generation and market",
          provenance: "projected",
          note: "Each row is one market's fans — product fans, brand fans and superfans together — split by generation, adding to a hundred. The United States row is derived from the Silver Lab's ladder; the others are modelled on the same basis. Tap a cell for the read.",
          cols: ["Gen Alpha", "Gen Z", "Millennials", "Gen X", "Boomers"],
          rows: [
            {
              label: "United States",
              cells: [
                {
                  v: 1,
                  note: "Gift recipients — a tag or a pendant someone gave them. Not fans yet, which is normal at this age.",
                },
                {
                  v: 17,
                  note: "Product fans, often found second-hand — the supply for the rungs above.",
                },
                {
                  v: 41,
                  note: "Four in ten of your American fans are Millennials — the women who bought a silver piece at twenty-five and are the brand fans of forty.",
                },
                {
                  v: 27,
                  note: "Gen X ranks you first and holds the Peretti pieces; a third of them are brand fans or superfans, the deepest share of any generation.",
                },
                {
                  v: 14,
                  note: "Mostly occasion buyers and the established high-jewelry clients.",
                },
              ],
            },
            {
              label: "Japan",
              cells: [
                { v: 1 },
                {
                  v: 9,
                  note: "The thinnest Gen Z share of any market: you have not recruited here in a decade.",
                },
                {
                  v: 27,
                  note: "The second generation of Open Heart buyers, now in their thirties and forties.",
                },
                {
                  v: 36,
                  note: "The Open Heart generation — your most loyal fans anywhere, and the first full-price buyers of Peretti.",
                },
                {
                  v: 27,
                  note: "The bubble-era buyers, still clients at Ginza.",
                },
              ],
            },
            {
              label: "South Korea",
              cells: [
                { v: 1 },
                {
                  v: 46,
                  note: "Nearly half: the fandom that buys what Jimin and ROSÉ wear, on the date it drops.",
                },
                {
                  v: 40,
                  note: "The HardWear and T buyers, bought for themselves.",
                },
                {
                  v: 10,
                  note: "Thin — the house arrived here with the faces, not before them.",
                },
                { v: 3 },
              ],
            },
            {
              label: "Hong Kong and Singapore",
              cells: [
                { v: 1 },
                {
                  v: 24,
                  note: "The café queue — product fans who post the room.",
                },
                {
                  v: 40,
                  note: "The largest group, and the one that steps up to the Blue Book.",
                },
                {
                  v: 24,
                  note: "The high-jewelry clients — your deepest superfans abroad.",
                },
                { v: 11 },
              ],
            },
            {
              label: "Mainland China",
              cells: [
                { v: 1 },
                {
                  v: 38,
                  note: "The second-youngest fan base after Korea; product fans of one piece.",
                },
                {
                  v: 45,
                  note: "The largest fan group on the mainland: women buying HardWear and the T for themselves.",
                },
                { v: 12 },
                { v: 4 },
              ],
            },
            {
              label: "Europe",
              cells: [
                { v: 1 },
                {
                  v: 22,
                  note: "The vintage buyers — your silver found in London and Paris, not bought on Bond Street.",
                },
                { v: 38, note: "The heart tag's recipients, a generation on." },
                { v: 25 },
                { v: 14 },
              ],
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Where silver was the door the fans stayed and climbed — home and Japan; where the door was gold and diamonds the fans are younger, louder and one piece deep, which is why a silver return recruits abroad as much as at home.",
          title: "What the fans came in through",
          provenance: "projected",
          note: "The share of each market's fans whose first piece from the house was silver, against the share that came in through gold or diamonds. The United States figure is the Silver Lab's own — about half of today's brand fans and nearly a third of the superfans started with a silver piece — and the other markets are modelled on the same basis. The tail names the piece the market's fans love most. Tap a row.",
          mode: "split",
          a: { label: "Silver first", color: "#9AA6B2" },
          b: { label: "Gold and diamonds first", color: "#D4A72C" },
          rows: [
            {
              id: "japan",
              label: "Japan",
              sub: "Gen X · the Open Heart generation",
              a: 68,
              b: 32,
              tail: "Open Heart",
              note: "Two in three came in through silver — the Open Heart and the Bean of the nineties — and stayed for thirty years. The deepest silver door you have, and the one you have not opened in a decade.",
            },
            {
              id: "united-states",
              label: "United States",
              sub: "Millennial women · bought for themselves",
              a: 56,
              b: 44,
              tail: "Heart tag",
              note: "More than half of your American fans started with a silver piece; the brand fans of forty are the heart-tag buyers of twenty-five. Stop making the first and you stop making the second.",
            },
            {
              id: "europe",
              label: "Europe",
              sub: "the collector · the gift",
              a: 45,
              b: 55,
              tail: "Vintage silver",
              note: "Split down the middle: the collectors came in through vintage silver, the gift recipients through a diamond. Neither door is one you are standing at.",
            },
            {
              id: "korea",
              label: "South Korea",
              sub: "Gen Z · the fandom",
              a: 38,
              b: 62,
              tail: "The Lock",
              note: "The fans arrived with the faces, through the Lock and HardWear in gold — a piece bought on a date. Silver has never been the door here, which is why the ladder has one rung.",
            },
            {
              id: "china",
              label: "Mainland China",
              sub: "Gen Z and Millennials · self-purchase",
              a: 34,
              b: 66,
              tail: "HardWear",
              note: "Two in three came in through gold — HardWear, the T — bought for themselves. The youngest fans in gold are the ones a silver piece at a reachable price would turn into members.",
            },
            {
              id: "hong-kong-singapore",
              label: "Hong Kong and Singapore",
              sub: "the client · the Blue Book",
              a: 30,
              b: 70,
              tail: "Blue Book",
              note: "The high-jewelry client came in through diamonds and the café queue through the T; the one place abroad where the top of the ladder is gold on both sides.",
            },
          ],
        },
        {
          kind: "geoCompare",
          insight:
            "The crowd answered a room, not a launch: a café in Hong Kong read higher than anything you opened in Tokyo, Milan or on the mainland, and at home ten of sixteen plays read nothing.",
          title: "Where the crowd answered",
          provenance: "measured",
          metric: "Reception there",
          focus: "new-york",
          note: "Each city's value is the average best read of the plays you ran there this summer, 0 to 100 — a read that finds little is a limit of our search, never proof nobody noticed. New York is the ringed focus; tap a city to read it against home.",
          markets: [
            {
              id: "new-york",
              label: "New York",
              x: 30.3,
              y: 11.5,
              value: 23,
              note: "Sixteen plays at home, six of them read: the Knicks' title night and the lit flagship 80, the CFDA awards 75, the Garden Series parties 60. The clock, the bodega, the exhibitions and the Landmark galas read nothing.",
            },
            {
              id: "hong-kong",
              label: "Hong Kong",
              x: 84.1,
              y: 18.2,
              value: 52,
              note: "The Lee Gardens flagship and Blue Box Café read 85 and warm at +80 — your best-received play outside the United States; the second Lee Gardens opening read 70; the Hidden Garden unveiling nothing.",
            },
            {
              id: "singapore",
              label: "Singapore",
              x: 81.1,
              y: 25.9,
              value: 38,
              note: "The Singapore-only Sixteen Stone watch read 65, the ION Orchard café 45, the reopening 40, the archival capsule exhibition nothing.",
            },
            {
              id: "bangkok",
              label: "Bangkok",
              x: 80.1,
              y: 21.4,
              value: 32,
              note: "The Legendary Legacy private evening read 50 and the HardWear building wrap 45; the exhibition itself nothing.",
            },
            {
              id: "tokyo",
              label: "Tokyo",
              x: 91.3,
              y: 13.3,
              value: 0,
              note: "The Ginza anniversary and the Wonder exhibition read nothing; the Ginza flagship opened with the café in August, too new for a read. Your most loyal fans abroad, unmeasured.",
            },
            {
              id: "seoul",
              label: "Seoul",
              x: 87.7,
              y: 12.6,
              value: 0,
              note: "No play in the market this summer — every Korean fan was reached through a face. The Jimin campaign, read at 75 and warm at +80, is the warmest piece of content on your shelf.",
            },
            {
              id: "china",
              label: "Mainland China",
              x: 86.1,
              y: 15.0,
              value: 0,
              note: "No play on the mainland was read this summer; the Sanlitun flagship opened in August, too new for a read.",
            },
            {
              id: "milan",
              label: "Milan",
              x: 52.6,
              y: 9.3,
              value: 0,
              note: "The Devil Wears Prada window read nothing, and so did the film released in the region; Frankenstein's London installation, played from New York, read 40.",
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "The biggest fans are made, not found, and silver is how you made them — so open the registry where the ladder is shortest, give Japan's generation its own spring at Ginza, and give the collectors at home a desk; three first steps of a community lane worth about a point house-wide.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "Owners first — the registry opens in Seoul and Shanghai, where the fans are one piece deep",
              itemType: "community",
              window:
                "February · with the Gehry edition — registered owners in Korea and China get each numbered edition a week before the counter",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "identity_signal", fit: 0.6 },
                { code: "scarcity", fit: 0.5 },
              ],
              why: "Your Korean and Chinese fans are product fans of the Lock and HardWear, made in weeks by a face and a date, and the ladder above that rung is empty — our community read scores your owned spaces and membership at twenty against a resale depth scored eighty to a hundred. A registry by hallmark — an owner enters a piece, gets its year and maker and first access to each numbered edition — turns the one-piece fan into a member, and costs nothing to open in the two markets first. The field's Asian plays that carried were made for a crowd that already loved something: POP MART's Molly at Starbucks, Toho's Human Vapor at Netflix.",
              effect: {
                label: "CIQ",
                delta: 0.4,
                series: [0, 0.15, 0.3, 0.38, 0.4],
              },
              precedents: 6,
              reception: "membership reads as fandom where the fans are young",
              similar: [
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title: "Starbucks and POP MART Celebrate 20 Years of MOLLY",
                  pts: 58.5,
                },
                {
                  brand: "gap",
                  brandName: "Gap",
                  title: "Hailey Bieber x Gap Denim Collection",
                  pts: 36.3,
                },
                {
                  brand: "netflix",
                  brandName: "Netflix",
                  title: "Netflix x Toho: The Human Vapor Reboot Series",
                  pts: 32.2,
                },
              ],
            },
            {
              name: "Peretti's Japan — the Open Heart generation's own show at Ginza, bring your piece",
              itemType: "experience",
              window:
                "Spring · the Ginza flagship's first spring — the Open Heart and the Bean on the walls with the women who bought them first; hallmark dating at the counter, polishing free",
              strategies: [
                { code: "fandom", fit: 0.75 },
                { code: "aesthetic_innovation", fit: 0.5 },
                { code: "opacity", fit: 0.3 },
              ],
              why: "Japan is the market where your fans are deepest abroad and oldest — Gen X women whose first real jewelry was a silver Open Heart in the nineties — and the only market where nothing you played this summer was read. The Ginza flagship opened in August with the café; give it a spring that belongs to them: Peretti's silver as the show, their own pieces dated by hallmark and polished free, their photographs on the walls. The field's rooms that carried were built around one house's objects, not a launch — the House of Miss Dior at South Coast Plaza, Gucci on the Riviera.",
              effect: {
                label: "CIQ",
                delta: 0.4,
                series: [0, 0.2, 0.3, 0.38, 0.4],
              },
              precedents: 7,
              reception: "a room built around an object reads at 85",
              similar: [
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "The House of Miss Dior Pop-up at South Coast Plaza",
                  pts: 42.0,
                },
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title:
                    "Gucci Debuts a Pop-Up at La Rose Des Vents Monte Carlo",
                  pts: 33.7,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Dior: Crafting Fashion Exhibition, SCAD FASH Atlanta",
                  pts: 22.6,
                },
              ],
            },
            {
              name: "Hallmark Saturdays at the Landmark — the desk that dates, buys back and polishes your silver",
              itemType: "community",
              window:
                "Autumn · the first Saturday of the month on the Landmark's ground floor — bring a piece, leave with its year, a free polish and a registry card",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "fandom", fit: 0.6 },
                { code: "scarcity", fit: 0.3 },
              ],
              why: "Your biggest fans are at home, and about half of your brand fans started with a silver piece they still own; the complaints they voice are about how you treat that silver — a paid polish against a free gold cleaning, a repair fee. A monthly desk that dates a piece by its hallmark, buys vintage silver back with your authentication and polishes it for free turns the complaint into a reason to come back, and gives the collectors who discuss your hallmarks on forums you do not own a room you do. Repetition is what the field's home-city plays have and yours did not: Uniqlo's Friday nights at MoMA, a festival stage that returns every year.",
              effect: {
                label: "CIQ",
                delta: 0.3,
                series: [0, 0.1, 0.2, 0.27, 0.3],
              },
              precedents: 6,
              reception: "the room reads when it comes back",
              similar: [
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "NYC MoMA Friday Night Uniqlo Free Entry Program",
                  pts: 37.4,
                },
                {
                  brand: "coca-cola",
                  brandName: "Coca-Cola",
                  title:
                    "Coca-Cola Activations at the 2026 ESSENCE Festival of Culture",
                  pts: 18.5,
                },
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title: "Gucci Takes Over Times Square",
                  pts: 15.8,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on the Silver Lab's community lane — a registry, hallmark dating and a house resale desk are worth about one index point house-wide — and on the field's measured rooms. These three are its first steps, each at or under the advisor's smallest archive pick, so the slate's order stands.",
        },
        {
          kind: "impact",
          title: "What owners-first carries",
          provenance: "projected",
          delta: 0.4,
          body: "The registry, opened in Seoul and Shanghai with the Gehry edition, carries a projected lift on your published score over the following two windows — most of it in the first, as the fans who own one piece are counted as members, the rest as Ginza and the Landmark desk follow. The three together are the first steps of the Silver Lab's community lane, worth about a point house-wide once the registry is everywhere.",
        },
        {
          kind: "modelView",
          body: "Your biggest fans are at home, and they are women in their thirties who bought a silver piece for themselves and stayed. Nearly half of your sales are American, nearly three in four of your site's visitors are American, and only at home — and in Japan — does the ladder have a top: a quarter of customers who own several collections and bring more than half the money. Japan's fans are a generation older, the women who bought the Open Heart first; they are your most loyal fans anywhere, and the ones you did not reach this summer.\n\nIn Seoul and on the mainland the fans are the youngest and the loudest and one piece deep — the Lock, HardWear — made in weeks by a face, with no rung above them yet. Hong Kong and Singapore hold the high-jewelry clients and the café queue, the one place abroad where a crowd answered a room. Europe is where you are a gift and a tourist's stop; the fans there are collectors in the vintage trade. The pattern is silver: where it was the door, the fans climbed; where the door was gold, they are young and thin. So open the registry where the ladder is shortest, give Japan's generation its own spring at Ginza, and give the collectors at home a desk — the biggest fans are made, and silver is how you made them.",
        },
      ],
    },
    {
      id: "next-collab",
      // the FIFTH question (user call 2026-10-06: "like we had collab
      // questions for other brands, add for Tiffany but show Tiffany
      // relevant data") — on the UGG / Starbucks packs' `collab` type and
      // item type; the shelf, the shapes and the houses' hit rates are the
      // dev DB's, the partners are modelled on them and on the Silver Lab's
      // one collab rule (a maker's hands on a Peretti form, no logo tag)
      itemType: "collab",
      type: "collab",
      question: "Who should Tiffany collaborate with next?",
      aliases: [
        "who should tiffany collaborate with next",
        "who should we collaborate with next",
        "who should we collab with next",
        "who should tiffany collab with next",
        "who should tiffany collab with",
        "who should we collaborate with",
        "which collab should we do next",
        "which collaboration should we do next",
        "who should we partner with next",
        "who should tiffany partner with next",
        "what should our next collab be",
        "whats our next collab",
        "which partner should we collaborate with",
        "who to collaborate with next",
      ],
      askedOn: "2026-10-06",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Hands on a Peretti form, no tag: Arsham on the Bone Cuff first, then ROSÉ's own Lock in silver, then the Knicks' silver.",
        },
        {
          kind: "quadrant",
          insight:
            "The houses whose partners make the thing get answered almost every time — Hermès, Vuitton, Dior — and the two jewelers sit together at the bottom of the odds, where a licence or a name on a tag gets noticed six times in ten. When yours do land they land as hard as anyone's; the problem is how often.",
          title: "Where the houses' collabs land",
          provenance: "measured",
          x: {
            label: "How often it's noticed",
            low: "rarely",
            high: "most times",
            hint: "how many of its read collaborations found an audience at all",
          },
          y: {
            label: "How hard it lands",
            low: "a ripple",
            high: "a moment",
            hint: "how strong that attention was, on the ones that were noticed",
          },
          quadrants: {
            tr: "Often, and hard",
            tl: "Rarely, but hard",
            br: "Often, not hard",
            bl: "Neither",
          },
          note: "Every luxury house on the board with at least five collaborations read since April, and the two jewelers. Across: the share of them the world noticed at all. Up: how strongly those measured when it did. Dot size is how many the house ran; the jewelers in pink. Tap a dot for the read.",
          points: [
            {
              id: "tiffany",
              label: "Tiffany",
              era: "Jewelry",
              color: "#F472B6",
              x: 60,
              y: 57,
              w: 46,
              note: "Thirteen collaborations, ten read, six noticed — and those six measured as hard as Dior's. Nine of the thirteen were a partner's name on your product or yours on theirs; the one where the partner made something, Arsham's vessel, was read once.",
            },
            {
              id: "pandora",
              label: "Pandora",
              era: "Jewelry",
              color: "#F472B6",
              x: 64,
              y: 53,
              w: 38,
              note: "Eleven collaborations and ten of them a licence on a charm — Disney four times, Star Wars, Marvel, Bridgerton. The crowd answers a character it loves at 60 to 70 every time, and the record grades the shelf formulaic, so it adds little.",
            },
            {
              id: "louis-vuitton",
              label: "Louis Vuitton",
              era: "Fashion house",
              color: "#B388FF",
              x: 89,
              y: 66,
              w: 66,
              note: "Nineteen collaborations, fourteen of them with a named person whose hands are on the object — Newson's suitcase, Grcic's crayon, the Campanas' chair — and nine in ten noticed. The hardest landings on the board: a Porsche remade, the World Cup trophy's trunk.",
            },
            {
              id: "hermes",
              label: "Hermès",
              era: "Fashion house",
              color: "#B388FF",
              x: 91,
              y: 62,
              w: 42,
              note: "Twelve collaborations, every one a named maker — Katie Scott, Daniel Clowes, Barber and Osgerby — and the best odds of any house on the board. Nothing is a licence; the partner draws, the house makes.",
            },
            {
              id: "dior",
              label: "Dior",
              era: "Fashion house",
              color: "#B388FF",
              x: 88,
              y: 54,
              w: 38,
              note: "Nine of eleven with a person — Lynda Benglis on the couture, Travis Scott's shoe, Lewis Hamilton's capsule — and nearly nine in ten noticed.",
            },
            {
              id: "jacquemus",
              label: "Jacquemus",
              era: "Fashion house",
              color: "#B388FF",
              x: 75,
              y: 69,
              w: 42,
            },
            {
              id: "prada",
              label: "Prada",
              era: "Fashion house",
              color: "#B388FF",
              x: 60,
              y: 70,
              w: 18,
              note: "Five collaborations, three noticed — and the one that landed hardest on the board this summer was a spacesuit garment with Axiom Space, read at 90. The Labubu read nothing.",
            },
            {
              id: "valentino",
              label: "Valentino",
              era: "Fashion house",
              color: "#B388FF",
              x: 67,
              y: 46,
              w: 21,
            },
            {
              id: "giorgio-armani",
              label: "Giorgio Armani",
              era: "Fashion house",
              color: "#B388FF",
              x: 57,
              y: 48,
              w: 49,
              note: "Fourteen collaborations, mostly residences and a retailer's shoes, and the same odds as yours — a name beside a name, read a little over half the time.",
            },
            {
              id: "gucci",
              label: "Gucci",
              era: "Fashion house",
              color: "#B388FF",
              x: 50,
              y: 48,
              w: 32,
              note: "Nine collaborations and the worst odds of any house here — Disney, adidas, The North Face, a racing team: the biggest names, half of them never read at all.",
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "The shape that gets noticed most, and that the houses above you run almost exclusively, is a maker with their hands on the object. You have run it once, with Daniel Arsham, and it is the best-graded collaboration on your shelf. Everything else you ran this year was a name — on a tag, on a dial, on a necklace — and a name is the shape the field answers least.",
          title: "Seven collab shapes, the field and yours",
          provenance: "measured",
          unit: "graded strength · pts",
          note: "Bands are the field's range for collaborations of each shape — typical to ceiling of graded strength across every brand on the board; the ring is the field's strongest collab there, the dots are your thirteen. Received = the best presence measured for that shape. Tap a shape for the read.",
          rows: [
            {
              id: "maker",
              label: "The maker's hands",
              sub: "a designer, an artist, the object",
              typical: 38,
              ceiling: 42,
              best: {
                brandName: "Nike",
                title: 'Victor Solomon\'s "Trophies" collection',
                pts: 70.6,
              },
              received: 100,
              own: [
                {
                  title: "Tiffany & Arsham Studio — the Eroded Penny Vessel",
                  pts: 42.7,
                },
              ],
              status: "recommended",
              note: "The field's most-noticed shape — a named person makes the thing and the house makes it real: Newson's suitcase for Vuitton, Katie Scott's Birkin, a trophy sculptor for Nike. Yours is Arsham's bronze vessel around a HardWear necklace — the best grade on your shelf, read once at 45, because the thing he made was the box, not the piece.",
            },
            {
              id: "face",
              label: "The face's own drop",
              sub: "a star, their edition",
              typical: 35,
              ceiling: 38,
              best: {
                brandName: "Nike",
                title: "The BTS world-tour merch",
                pts: 65.9,
              },
              received: 90,
              own: [
                { title: "Beyoncé — the RENAISSANCE Round Tag", pts: 39.7 },
                { title: "Pharrell — Tiffany Titan", pts: 30.4 },
              ],
              note: "A face who is a fandom, given a product of their own: BTS for Nike, Travis Scott for Dior. Yours were the two biggest names on the shelf — Beyoncé's album name on your round tag, Pharrell's pearls — both graded as little as a tag can be for the star's own hand. Pharrell's was silent for fourteen weeks and then read at 70; Beyoncé's is too new to have a read.",
            },
            {
              id: "fandom",
              label: "A fandom object",
              sub: "a crowd's own obsession, made",
              typical: 39,
              ceiling: 43,
              best: {
                brandName: "Louis Vuitton",
                title: "The Singer Porsche 911, reimagined",
                pts: 73.3,
              },
              received: 90,
              note: "The highest single collab on the board is a crowd's own obsession made by the house — a Porsche for Vuitton, One Piece for Nike, MOLLY for Starbucks. You have never made one. Pandora makes nothing else, and its charms are answered at 60 to 70 and graded formulaic: the shape pays when the object is yours, not the licence.",
            },
            {
              id: "object",
              label: "A cross-world object",
              sub: "a suitcase, a skin, a pearl",
              typical: 38,
              ceiling: 42,
              best: {
                brandName: "Nike",
                title: "The Book 2 McDonald's sneaker",
                pts: 69.6,
              },
              received: 90,
              own: [
                {
                  title: "League of Legends — the Crystal Rose skins",
                  pts: 35.7,
                },
                {
                  title: "Disney Cruise Line — the silver necklace",
                  pts: 34.1,
                },
                { title: "Supreme — the pearl necklace", pts: 26.7 },
              ],
              note: "Two worlds with distance between them, and an object people post: the World Cup trophy's trunk read at 90. Three of yours are here and none was noticed: a necklace sold on two cruise ships, a pearl strand with your tag under Supreme's, a game skin that leaked. The distance was there; the object nobody wanted to hold.",
            },
            {
              id: "story",
              label: "Inside a story",
              sub: "a film, a series, a soundtrack",
              typical: 32,
              ceiling: 37,
              best: {
                brandName: "Duolingo",
                title: "Squid Game, in Korean",
                pts: 53.4,
              },
              received: 85,
              own: [
                {
                  title: "Netflix — Frankenstein's narrative jewels",
                  pts: 39.4,
                },
              ],
              note: "Your second-best read of the year: twenty-seven jewels written into del Toro's Frankenstein, answered at 70 twice. Nothing was for sale. It is the one shape where your jewels were seen as objects in a story rather than as a brand on a brand — keep it, and next time make the piece people can buy.",
            },
            {
              id: "heritage",
              label: "Heritage to heritage",
              sub: "two old names, one dial",
              typical: 32,
              ceiling: 36,
              best: {
                brandName: "Nike",
                title: "The Renegade Vaporfly",
                pts: 49.1,
              },
              received: 80,
              own: [
                { title: "Patek Philippe — the Nautilus 5990", pts: 33.3 },
                {
                  title: "Patek Philippe — the Tiffany Blue Nautilus",
                  pts: 28.1,
                },
                { title: "Steiff — the teddy bear", pts: 32.3 },
              ],
              note: "The most authentic pairing on your shelf — a hundred and seventy years with Patek — and the quietest: two Nautilus releases this summer, one read at 35, the other not at all. A dial with two names on it is a trade note. The bear is too new to have a read.",
            },
            {
              id: "patron",
              label: "A patron's programme",
              sub: "an award, a fund, a scholar",
              typical: 31,
              ceiling: 32,
              best: {
                brandName: "Chanel",
                title: "The Culture Fund on the High Line",
                pts: 50.8,
              },
              received: 75,
              own: [{ title: "CFDA — the jewelry designer award", pts: 32.3 }],
              note: "Your best collaboration read of the year was not a product: the CFDA designers' award, read at 75 and as warm as anything at home. The shape has the lowest ceiling on the board and the field's best presence here is yours. The designers it funds are the makers the first row is missing.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Asked whether the partner actually made the thing, your collaborations grade half what the houses' do, and that is the question that decides whether anything is noticed. Everything that follows from it — how well it is made, whether anyone would keep it, whether it is scarce — grades at half too. The one thing you grade higher than anyone is that both names are clearly on it.",
          title: "How your pairings grade",
          provenance: "measured",
          mode: "pair",
          a: { label: "Your collabs", color: "#60A5FA" },
          b: { label: "The luxury houses", color: "#B388FF" },
          note: "Your thirteen collaborations against the eleven luxury houses' hundred, on the questions the board asks of every partnership. The tail is the whole board's grade. Tap a row for the read.",
          rows: [
            {
              id: "maker",
              label: "The maker's hands",
              sub: "did the partner make the thing",
              a: 35,
              b: 64,
              tail: "board 50",
              note: "The clearest gap in the whole rubric and the one that matters most: a named person who made the object is the shape the field notices most. Of your four person collaborations only Arsham's graded above 20 for the partner's own hand — Beyoncé's and Pharrell's were names on a form you already make.",
            },
            {
              id: "quality",
              label: "Well made",
              sub: "the object, as an object",
              a: 34,
              b: 55,
              tail: "board 34",
              note: "You grade with the board, not with the houses — a round tag with an engraving, a pearl strand with a tag, a colourway on a watch. Arsham's vessel graded 80 here and Frankenstein's jewels 60; nothing else above 40.",
            },
            {
              id: "kept",
              label: "Something kept",
              sub: "would anyone collect it",
              a: 15,
              b: 32,
              tail: "board 27",
              note: "Half the houses' grade. A silver necklace on two cruise ships and a bear are the closest you came to a thing people collect; the registry the fan lab opens is built for exactly this question.",
            },
            {
              id: "scene",
              label: "A scene",
              sub: "a crowd with its own rules",
              a: 19,
              b: 32,
              tail: "board 33",
              note: "League of Legends was the one scene you touched, and it leaked rather than launched. Beyoncé's and ROSÉ's crowds are scenes you already have the keys to; the record has not seen you use them on a product.",
            },
            {
              id: "scarce",
              label: "Scarce",
              sub: "capped, dated, gone",
              a: 14,
              b: 28,
              tail: "board 23",
              note: "Nothing you collaborated on this year carried a number — the cruise necklace was one of a kind and sold where nobody could queue. The houses cap half of theirs.",
            },
            {
              id: "new",
              label: "New faces",
              sub: "buyers you did not have",
              a: 6,
              b: 18,
              tail: "board 17",
              note: "Three times lower than the houses — your partners' crowds were already yours, or never came in. This is the grade a fandom object exists to move.",
            },
            {
              id: "surprise",
              label: "Surprise",
              sub: "nobody saw it coming",
              a: 26,
              b: 35,
              tail: "board 31",
              note: "Frankenstein and the game skins were the surprises; the rest of the year was the expected name in the expected place.",
            },
            {
              id: "story",
              label: "A shared story",
              sub: "a real reason to be together",
              a: 43,
              b: 43,
              tail: "board 37",
              note: "Level with the houses and above the board — Patek's hundred and seventy years, Beyoncé's campaigns, Arsham's fourth year. The reasons are real; what is missing is the thing made for them.",
            },
            {
              id: "names",
              label: "Two names on it",
              sub: "both names, clearly",
              a: 69,
              b: 65,
              tail: "board 64",
              note: "The one question you grade above everyone. Both names are always on the piece — which is the Silver Lab's point: the next one puts them on the hallmark, not on the face.",
            },
          ],
        },
        {
          kind: "stacks",
          insight:
            "Building for a crowd that already organises itself is the best-received thing a collaboration can do on this board, and the houses spend a tenth of their tags on it. You spend none — five of your thirteen carry a strategy at all, and the only two they carry are saying who you are and looking new. Fandom is the strategy the whole house is received best for, and it has never been on a product.",
          title: "What a collab is used for",
          provenance: "measured",
          note: "Every collaboration on the board is tagged with the strategies it runs on. These are the shares of those tags — yours, Pandora's, the luxury houses' and the whole board's. Tap a row for the read.",
          legend: [
            { key: "identity", label: "Identity signal", color: "#FB923C" },
            {
              key: "aesthetic",
              label: "Aesthetic innovation",
              color: "#4FC3F7",
            },
            { key: "scarcity", label: "Scarcity", color: "#FDE047" },
            { key: "fandom", label: "Fandom", color: "#B388FF" },
            { key: "opacity", label: "Opacity", color: "#94A3B8" },
          ],
          rows: [
            {
              id: "tiffany",
              label: "Your collabs",
              sub: "seven tags on five of thirteen",
              parts: [
                { key: "identity", v: 43 },
                { key: "aesthetic", v: 43 },
                { key: "scarcity", v: 14 },
                { key: "fandom", v: 0 },
                { key: "opacity", v: 0 },
              ],
              note: "Eight of your thirteen carry no strategy the record could name. The five that do split between saying who the wearer is and looking new; one scarcity tag, on the cruise necklace. No fandom, anywhere — on the shelf where fandom is the strategy you are received best for.",
            },
            {
              id: "pandora",
              label: "Pandora's collabs",
              sub: "nine tags on eight of eleven",
              parts: [
                { key: "identity", v: 67 },
                { key: "aesthetic", v: 22 },
                { key: "scarcity", v: 11 },
                { key: "fandom", v: 0 },
                { key: "opacity", v: 0 },
              ],
              note: "The other jeweler runs licences on charms and tags them as identity — a Disney princess on your wrist says who you are. The crowd answers at 60 to 70 and the grade stays low: a licence is a borrowed crowd, not a built one.",
            },
            {
              id: "houses",
              label: "The luxury houses",
              sub: "161 tags across eleven houses",
              parts: [
                { key: "identity", v: 40 },
                { key: "aesthetic", v: 32 },
                { key: "scarcity", v: 19 },
                { key: "fandom", v: 9 },
                { key: "opacity", v: 0 },
              ],
              note: "The houses cap a fifth of their collaborations and build a tenth for a crowd — Vuitton's Porsche, Dior's Travis Scott, Jacquemus with the French team. Fandom-built collaborations are the best received on the board, at 64 when they land.",
            },
            {
              id: "board",
              label: "Every collab on the board",
              sub: "746 tags on 545 plays",
              parts: [
                { key: "identity", v: 42 },
                { key: "aesthetic", v: 33 },
                { key: "scarcity", v: 16 },
                { key: "fandom", v: 8 },
                { key: "opacity", v: 0 },
              ],
              note: "Collaborations are what brands reach for when they want to say who a customer is. Opacity — the if-you-know play — is never tagged on one; a partnership is the one thing brands never keep quiet about.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "One partner is already in the building and already graded as a maker; the second is a face whose fans are the thinnest, loudest crowd you have; the third is a crowd you made the trophy for. Under them, the archive calendar and a maker not yet named. The bottom of the list is the summer you just had — a third Nautilus, another tag under a streetwear logo — and the charm crowd everyone else is chasing, which for this house is the old trap.",
          title: "Nine partners, ranked",
          provenance: "projected",
          note: "Nine named partners and partner shapes, each graded on the questions the board asks of every collaboration — the maker's hand, the crowd already there, what is kept, what it does to the house's silver. The score blends what it would move this quarter, what it would move in a year, and how much of the case the record already proves. Tap a partner for the evidence.",
          rows: [
            {
              id: "arsham",
              label: "Daniel Arsham — the Bone Cuff",
              context: "the maker, act two",
              score: 86,
              role: "Hands on a Peretti form",
              horizon: "long",
              drivers: [
                "The Silver Lab's one collaboration rule: a designer or an artist reworks the Bone Cuff or the Bottle pendant for one season, in silver, both names on the hallmark and nothing on the face.",
                "He is already your partner — four years in — and the best-graded collaboration on your shelf is his: creative involvement 80, execution 80, the only one of your thirteen graded as a maker at all.",
                "His vessel was read once at 45 because the thing he made was the box around a HardWear necklace; the shape the field answers nine times in ten is the maker on the object itself.",
              ],
            },
            {
              id: "rose",
              label: "ROSÉ — the Lock, her edition",
              context: "the face, her own drop",
              score: 82,
              role: "A fandom you already hold",
              horizon: "short",
              drivers: [
                "Fandom-built collaborations are the best received on the board and you have never tagged one; fandom is the strategy the whole house is received best for, on four plays, none of them a product.",
                "Seoul's fans are the youngest and loudest you have and one piece deep — the Lock, made in weeks by a face. Her numbered edition, in silver, is the second piece the fan lab says they are missing.",
                "The reference case is the face's own drop at the top of the shape: the BTS merch for Nike at 66 and Travis Scott's shoe for Dior at 57 — and Beyoncé's tag, graded 20 for her own hand, is the version you ran.",
              ],
            },
            {
              id: "knicks",
              label: "The Knicks — the trophy's silver",
              context: "the crowd you made the cup for",
              score: 78,
              role: "A trophy maker's object",
              horizon: "short",
              drivers: [
                "The best-received play at home this summer was the Knicks lifting the Larry O'Brien you make, read at 80 and as warm as anything on your shelf — and it was played as a lit building, not an object.",
                "The field's trophy objects are its hardest landings: Vuitton's World Cup trunk at 90, Jacquemus with the French team at 80, the Formula 1 trophy trunk at 75.",
                "Ring night at the Garden is on the experience lab's calendar for the twentieth of October; a numbered silver trophy pendant sold there, made in Rhode Island, is the object that night is missing.",
              ],
            },
            {
              id: "gehry",
              label: "Frank Gehry — the return",
              context: "already on the archive calendar",
              score: 70,
              role: "An edition, not a collab",
              horizon: "long",
              drivers: [
                "The archive lab already prices the Torque and the Fish as the first numbered edition; the rights sit with the Gehry side, which makes it a collaboration in law and an archive return in the index.",
                "Counted once, there, not here.",
              ],
            },
            {
              id: "sculptor",
              label: "A sculptor on the Bottle pendant",
              context: "the maker not yet named",
              score: 64,
              role: "The second Peretti form",
              horizon: "long",
              drivers: [
                "The Silver Lab's alternative to the cuff: the pendant the youngest buyer keeps, reworked by a maker for one season.",
                "The CFDA designers you fund are the shortlist — the award is your best collaboration read of the year and the shape with the lowest ceiling; move one of them from the award to the bench.",
              ],
            },
            {
              id: "netflix",
              label: "Netflix — the next film",
              context: "the story, with a piece to buy",
              score: 58,
              role: "Jewels in a story",
              horizon: "long",
              drivers: [
                "Frankenstein was your second-best read, at 70 twice, and nothing was for sale; the shape ceilings low on the board because it rarely leaves the screen.",
                "Keep the shape and finish it: one of the twenty-seven jewels, made for sale, numbered, when the next story comes.",
              ],
            },
            {
              id: "patek",
              label: "Patek Philippe — a third Nautilus",
              context: "the summer you had",
              score: 40,
              role: "The trade note",
              horizon: "long",
              drivers: [
                "Two Nautilus releases this summer, one read at 35, the other never — the most authentic pairing on your shelf and the one the crowd does not answer.",
                "A dial with two names on it is news for the watch trade; it moves nothing the index counts for the house.",
              ],
            },
            {
              id: "streetwear",
              label: "Supreme, or the next label",
              context: "your tag under their logo",
              score: 34,
              role: "The pearl again",
              horizon: "short",
              drivers: [
                "The pearl necklace with both logos on a silver tag was read once in August and found nothing — the highest distance on your shelf and nothing anyone wanted to hold.",
                "The 2023 sneaker is the memory the shape carries: argued about more than it was worn.",
              ],
            },
            {
              id: "charm",
              label: "POP MART — the charm crowd",
              context: "the collectible crowd of the year",
              score: 28,
              role: "The old trap",
              horizon: "short",
              drivers: [
                "The year's collectible crowd for the coffee chains and the boot brands — Starbucks read 85 with MOLLY. Prada's Labubu read nothing.",
                "For this house a charm is the charm bracelet again: among the most wanted pieces on the Silver Lab's list, at the lowest price, and the 2002 problem — an entry line crowding the stores. Not a line.",
              ],
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Nothing you ran this summer reaches the top right: the partners with the biggest crowds — Beyoncé, Disney, a game — put a name on your tag, and the partners who make things made them for a few. The three dots in that corner are the three moves: a maker on your most famous form, a face whose fans already own one piece, and a crowd that watched you make its trophy.",
          title: "Partner candidates",
          provenance: "projected",
          x: {
            label: "A crowd already there",
            low: "a scene",
            high: "an army",
            hint: "the size and heat of the partner's own following this year",
          },
          y: {
            label: "Hands on the silver",
            low: "a name on it",
            high: "they made it",
            hint: "how much of the piece the partner would actually make",
          },
          quadrants: {
            tr: "Drop it",
            tl: "Made, for few",
            br: "A name on your tag",
            bl: "Leave it",
          },
          note: "Crowd reads the size and heat of the partner's own following; hands reads how much of the piece they would make. Hollow dots are partners you already ran this summer. Dot size is how much of the story the partner would carry. Tap a dot for the read.",
          points: [
            {
              id: "arsham",
              label: "Daniel Arsham · the Bone Cuff",
              short: "Arsham",
              era: "The maker's hands",
              color: "#60A5FA",
              x: 56,
              y: 92,
              w: 60,
              status: "recommended",
              note: "Four years your partner, graded 80 for his own hand — the only maker on your shelf. His eroded Bone Cuff in silver, one season, both names on the hallmark.",
            },
            {
              id: "rose",
              label: "ROSÉ · the Lock, her edition",
              short: "ROSÉ",
              era: "The face's own drop",
              color: "#F472B6",
              x: 90,
              y: 64,
              w: 55,
              status: "recommended",
              note: "The biggest crowd on the map that is already wearing one of your pieces. Her Lock, in silver, numbered, her channels first — the edition Seoul's registry sends to its owners first.",
            },
            {
              id: "knicks",
              label: "The Knicks · the trophy's silver",
              short: "The Knicks",
              era: "A fandom object",
              color: "#FF5A76",
              x: 84,
              y: 58,
              w: 50,
              status: "recommended",
              note: "You made the trophy they lifted; the crowd that watched is the fandom. A numbered silver pendant of it, sold at the Garden on ring night.",
            },
            {
              id: "gehry",
              label: "Frank Gehry · the Torque and the Fish",
              era: "The maker's hands",
              color: "#60A5FA",
              x: 40,
              y: 88,
              w: 45,
              note: "Already the archive lab's first numbered edition — a maker's return, counted there.",
            },
            {
              id: "sculptor",
              label: "A sculptor · the Bottle pendant",
              era: "The maker's hands",
              color: "#60A5FA",
              x: 22,
              y: 90,
              w: 40,
              note: "The Silver Lab's second form for a maker's hands — a name from your own CFDA shortlist.",
            },
            {
              id: "cfda",
              label: "CFDA · the designer award",
              era: "A patron's programme",
              color: "#2DD4BF",
              x: 18,
              y: 56,
              w: 30,
              status: "recent",
              note: "Your best collaboration read of the year, at 75 — a programme, not a piece. The designers it funds are the bench for the row above.",
            },
            {
              id: "netflix",
              label: "Netflix · Frankenstein",
              era: "Inside a story",
              color: "#B388FF",
              x: 70,
              y: 40,
              w: 45,
              status: "recent",
              note: "Twenty-seven jewels in a story, read at 70 twice, none for sale.",
            },
            {
              id: "steiff",
              label: "Steiff · the bear",
              era: "Heritage to heritage",
              color: "#94A3B8",
              x: 36,
              y: 44,
              w: 30,
              status: "recent",
              note: "A mohair bear with Tiffany Blue paws, out in August — too new to have a read.",
            },
            {
              id: "patek",
              label: "Patek Philippe · two Nautilus",
              era: "Heritage to heritage",
              color: "#94A3B8",
              x: 30,
              y: 30,
              w: 35,
              status: "recent",
              note: "A hundred and seventy years together, two dials this summer, one read at 35.",
            },
            {
              id: "pharrell",
              label: "Pharrell · Tiffany Titan",
              era: "The face's own drop",
              color: "#F472B6",
              x: 80,
              y: 24,
              w: 40,
              status: "recent",
              note: "The biggest name of the spring, graded 20 for his own hand — silent for fourteen weeks, then read at 70.",
            },
            {
              id: "beyonce",
              label: "Beyoncé · the RENAISSANCE tag",
              era: "The face's own drop",
              color: "#F472B6",
              x: 96,
              y: 18,
              w: 50,
              status: "recent",
              note: "The biggest crowd on the map and her album's name on your round tag: graded 100 for the pairing, 20 for the hand. Too new to have a read.",
            },
            {
              id: "lol",
              label: "League of Legends · the skins",
              era: "A cross-world object",
              color: "#FFB74D",
              x: 86,
              y: 20,
              w: 30,
              status: "recent",
              note: "A game's crowd and a leak — read once at 45, nothing to hold.",
            },
            {
              id: "disney",
              label: "Disney · the cruise necklace",
              era: "A cross-world object",
              color: "#FFB74D",
              x: 92,
              y: 10,
              w: 35,
              status: "recent",
              note: "The largest brand on your shelf, a one-of-a-kind silver necklace sold on two ships — nine reads, nothing.",
            },
            {
              id: "supreme",
              label: "Supreme · the pearl necklace",
              era: "A cross-world object",
              color: "#FFB74D",
              x: 62,
              y: 12,
              w: 35,
              status: "recent",
              note: "Your tag under their logo on a pearl strand — one read, nothing.",
            },
            {
              id: "popmart",
              label: "POP MART · a charm",
              era: "A fandom object",
              color: "#FF5A76",
              x: 94,
              y: 30,
              w: 40,
              note: "The crowd of the year for everyone else; for you, a charm is the 2002 problem again. Leave it.",
            },
          ],
        },
        {
          kind: "playsTimeline",
          insight:
            "Your collaboration year on one line: thirteen plays, none above forty, the biggest names at the bottom and the one maker at the top. Right of now, the three drops stand in impact order — the cuff largest, because it is the one the Silver Lab prices, the edition and the pendant behind it.",
          title: "Your collabs, and three drops priced",
          provenance: "projected",
          today: "2026-10-06",
          note: "Left of NOW: every collaboration on your measured shelf by strength today. Right of NOW: the three drops on their own projected-CIQ scale — height is impact. Tap a dot for the read.",
          points: [
            {
              d: "2026-04-22",
              v: 21.4,
              label: "Tiffany Titan by Pharrell Williams",
              itemType: "collab",
            },
            {
              d: "2026-04-23",
              v: 29.4,
              label: "The Disney Cruise Line silver necklace",
              itemType: "collab",
            },
            {
              d: "2026-04-28",
              v: 38.2,
              label: "Tiffany & Arsham Studio — the Eroded Penny Vessel",
              itemType: "collab",
            },
            {
              d: "2026-04-30",
              v: 26.6,
              label: "Patek Philippe Nautilus 5990",
              itemType: "collab",
            },
            {
              d: "2026-05-10",
              v: 36.1,
              label: "The CFDA jewelry designer award",
              itemType: "collab",
            },
            {
              d: "2026-05-27",
              v: 25.2,
              label: "League of Legends — the Crystal Rose skins",
              itemType: "collab",
            },
            {
              d: "2026-06-05",
              v: 36.9,
              label: "Netflix — Frankenstein's narrative jewels",
              itemType: "collab",
            },
            {
              d: "2026-07-03",
              v: 25.2,
              label: "Patek Philippe — the Tiffany Blue Nautilus",
              itemType: "collab",
            },
            {
              d: "2026-07-23",
              v: 26.6,
              label: "RIMOWA — the Rock Cut carry-on",
              itemType: "collab",
            },
            {
              d: "2026-08-11",
              v: 22.8,
              label: "Supreme — the pearl necklace",
              itemType: "collab",
            },
            {
              d: "2026-08-21",
              v: 39.7,
              label: "Beyoncé — the RENAISSANCE Round Tag",
              itemType: "collab",
            },
            {
              d: "2026-08-23",
              v: 32.3,
              label: "Steiff — the teddy bear",
              itemType: "collab",
            },
            {
              d: "2026-10-20",
              v: 44,
              label:
                "The Knicks — the trophy's silver, ring night at the Garden",
              itemType: "collab",
              projected: true,
              effect: 0.3,
              detail: "projected +0.3 CIQ",
            },
            {
              d: "2027-02-12",
              v: 52,
              label: "ROSÉ — the Lock in silver, her edition",
              itemType: "collab",
              projected: true,
              effect: 0.4,
              detail: "projected +0.4 CIQ",
            },
            {
              d: "2027-05-06",
              v: 58,
              label: "Daniel Arsham — the Bone Cuff, eroded, in silver",
              itemType: "collab",
              projected: true,
              effect: 0.6,
              detail: "projected +0.6 CIQ",
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three drops, one rule: in each the partner is the maker, the crowd is one you already hold, and the piece carries a number. The cuff is the Silver Lab's own move and the largest; the edition and the pendant are smaller because the lane is fuller once the first has landed.",
          title: "Three drops, priced",
          provenance: "projected",
          plays: [
            {
              name: "Daniel Arsham — the Bone Cuff, eroded, in silver: one season, both names on the hallmark, nothing on the face",
              itemType: "collab",
              window:
                "May · Frieze week in New York, the Landmark — a numbered run, registered owners first, the gold version never",
              strategies: [
                { code: "fandom", fit: 0.7 },
                { code: "scarcity", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.6 },
              ],
              why: "The Silver Lab's one collaboration is a maker's hands on a Peretti form with no logo tag, and the record says why: the shape the field notices most is a named person who made the object, and the houses above you on the odds run almost nothing else. Arsham is the only maker on your shelf and the best grade on it; what he made last time was the box. Put his erosion on the cuff itself, in silver, for one season, and the piece carries the three things the artifact asks for at once — a fandom's object, a number, a design story of your own — on the form the resale market already prices highest.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.25, 0.45, 0.55, 0.6],
              },
              precedents: 9,
              reception: "the maker on the object reads at 85 to 100",
              similar: [
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton x Singer Porsche 911 Reimagined Collection",
                  pts: 73.3,
                },
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title: "Hermès Dress Code carré, designed by Daniel Clowes",
                  pts: 46.2,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton Objets Nomades Cocoon Dichroic Chair with Humberto Campana and Géraldine Guyot-Arnault",
                  pts: 41.6,
                },
              ],
            },
            {
              name: "ROSÉ — the Lock in silver, her edition: numbered, her channels first, Seoul's registry gets it first",
              itemType: "collab",
              window:
                "February · Seoul and Shanghai a week before the rest of the world — her post before your press, the number on the box",
              strategies: [
                { code: "fandom", fit: 0.9 },
                { code: "scarcity", fit: 0.7 },
                { code: "identity_signal", fit: 0.5 },
              ],
              why: "Fandom is the strategy the whole house is received best for and the one you have never put on a product; on collaborations it is the best-received strategy on the board, and the houses spend a tenth of their tags on it. Your fans in Seoul are the youngest and loudest you have and one piece deep — the Lock, made by a face in weeks. The face's own drop is the shape at the top of that lane, BTS for Nike, Travis Scott for Dior; Beyoncé's tag was the version with her hand graded at 20. Give ROSÉ the Lock as an edition — in silver, at the Silver Lab's price floor, numbered — and let her channel go first: the fan lab's registry, open in Seoul that month, sends the number she posts to its owners before the counter.",
              effect: {
                label: "CIQ",
                delta: 0.4,
                series: [0, 0.2, 0.3, 0.37, 0.4],
              },
              precedents: 8,
              reception: "the face's own drop reads at 75 to 90",
              similar: [
                {
                  brand: "nike",
                  brandName: "Nike",
                  title:
                    "Nike x BTS WORLD TOUR “ARIRANG” Merch and Nike By You Experience",
                  pts: 65.9,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Travis Scott's Cactus Jack x Dior Shoes",
                  pts: 56.5,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title:
                    "Nike x G-Dragon's PEACEMINUSONE South Korea World Cup Collection",
                  pts: 51.3,
                },
              ],
            },
            {
              name: "The Knicks — the trophy's silver: a numbered pendant of the Larry O'Brien, made in Rhode Island, sold at the Garden on ring night",
              itemType: "collab",
              window:
                "October 20 · ring and banner night at the Garden — the Garden's doors first, the Fifth Avenue window the morning after",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "scarcity", fit: 0.6 },
                { code: "identity_signal", fit: 0.5 },
              ],
              why: "The best-received play at home this summer was a crowd lifting a trophy you made, and you played it as a lit building. The field's trophy objects are its hardest landings — Vuitton's World Cup trunk at 90, Jacquemus with the French team at 80 — and they are objects a fan can hold. The experience lab already puts you at the Garden on ring night; this is the thing to sell there: the trophy you have made for the league for years, in your own silver, numbered to the season, a fandom's object from the one house that can make it.",
              effect: {
                label: "CIQ",
                delta: 0.3,
                series: [0, 0.15, 0.24, 0.28, 0.3],
              },
              precedents: 6,
              reception: "the trophy's object reads at 75 to 90",
              similar: [
                {
                  brand: "jacquemus",
                  brandName: "Jacquemus",
                  title:
                    'Jacquemus x Nike x French Football Federation "Les Bleus" Collection',
                  pts: 67.1,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton x FIFA World Cup 2026™ Official Trophy Trunk and Limited-Edition Collection",
                  pts: 65.4,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton x Formula 1 Miami Grand Prix Trophy Trunk",
                  pts: 21.3,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on the Silver Lab's collaboration lane — one collaboration built on a Peretti form is worth about six tenths of a point — and on the field's measured drops of the same shape; the second and third add less each as the lane fills. The lead ties the advisor's middle picks and sits outside its slate, so the slate's order stands.",
        },
        {
          kind: "impact",
          title: "What Arsham's cuff carries",
          provenance: "projected",
          delta: 0.6,
          body: "The eroded Bone Cuff in silver, dropped at the Landmark in Frieze week to registered owners first, carries a projected lift on your published score over the following two windows — most of it in the first, as the maker's crowd and the cuff's own resale market answer, the rest as the gold version is refused and the number holds. It is the Silver Lab's own collaboration, priced at its figure; the edition and the pendant add less each behind it, because the lane is fuller once the first has landed.",
        },
        {
          kind: "modelView",
          body: "Stop booking names and start commissioning hands. Your year of collaborations was the most famous partner list in jewelry — a superstar, a producer, a watchmaker, a skate label, a studio, a game — and what each of them made with you was a tag: yours on their thing, or their name on yours. The record answered the two where somebody made something, and the houses that out-land you every week run nothing else.\n\nSo give the one maker already in the building your most famous form, in the metal the Silver Lab is bringing back, with both names on the hallmark and nothing on the face. Give the face whose fans are youngest and thinnest her own numbered piece, and let her post it before you do. And sell the crowd that watched you make its trophy a piece of that trophy, on the night it comes home. Leave the charm crowd to the coffee chains; for this house a charm is the old trap with a new toy on it.",
        },
      ],
    },
    {
      id: "units-per-market",
      // the SIXTH question (user call 2026-10-07: "like we added other
      // questions and answers for Tiffany add this one too — How does
      // Tiffany's reach, relevance and resonance differ per market?
      // investigate first in detail then add response with insights") — on
      // the Estée pack's `geo` type (the market-scan script and the Market
      // scan tag); the three units are the Culture Index's (reach, relevance,
      // resonance), read here on the dev DB's regional record: reach = the
      // plays read in a market, relevance = whether what you ran there is
      // what that market answers, resonance = how warm a read lands
      itemType: "experience",
      type: "geo",
      // OFF the recommended chips since 2026-10-12 (user call: "show just 3
      // questions … comment out how does tiffanys reach…") — the answer
      // stays reachable by a typed question, an alias or the deep link.
      featured: false,
      question:
        "How does Tiffany's reach, relevance and resonance differ per market?",
      aliases: [
        "how does tiffanys reach relevance and resonance differ per market",
        "how do tiffanys reach relevance and resonance differ per market",
        "how does our reach relevance and resonance differ per market",
        "how do our reach relevance and resonance differ per market",
        "how do reach relevance and resonance differ per market",
        "how does reach relevance and resonance differ per market",
        "how do reach relevance and resonance differ by market",
        "reach relevance and resonance per market",
        "reach relevance resonance per market",
        "reach relevance and resonance by market",
        "how does tiffany differ per market",
        "how do we differ per market",
        "where are we relevant",
        "where do we resonate",
        "which markets are we relevant in",
        "which markets do we resonate in",
        "how does our culture score differ per market",
        "how does tiffanys culture score differ per market",
      ],
      askedOn: "2026-10-07",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Reach is American and warmth follows a read; relevance lives in Asia's rooms, and Europe has read nothing of you.",
        },
        {
          kind: "matrix",
          insight:
            "Reach is where you sell and relevance is where you were answered, and they are not the same places: home is known and half-heard, two Asian cities and a fandom in Seoul answer you, Japan and Europe are reach without a read.",
          title: "Three units, six markets",
          provenance: "projected",
          note: "Each cell is an index, 0 to 100. Reach is how much of a market you touch — sales, visitors, the plays read there this summer. Relevance is whether what you ran there is what that market answers now. Resonance is how warm a read lands, praise against criticism. Where the summer's plays were read, the cell is the record; where nothing was read, it is modelled on the market's own facts and reads as the gap it is. Tap a cell.",
          cols: ["Reach", "Relevance", "Resonance"],
          rows: [
            {
              label: "United States",
              cells: [
                {
                  v: 86,
                  note: "Forty-four percent of sales and seventy-two percent of your site's visitors — and of sixteen plays at home this summer, six were read. The houses' home plays were read three times in four.",
                },
                {
                  v: 46,
                  note: "Home answers a stage with a face on it — the Met steps, a premiere, a cruise show; you ran nine galas and exhibitions in your own rooms. The two reads above seventy were the city's title and the trade's award, neither a play of yours alone.",
                },
                {
                  v: 78,
                  note: "When home reads you it is the warmest market on your shelf — the lit flagship and the CFDA award at plus seventy-three, no criticism all summer, above every house's typical read.",
                },
              ],
            },
            {
              label: "Hong Kong and Singapore",
              cells: [
                {
                  v: 64,
                  note: "Your deepest clients abroad and the café queue; five of seven plays read — the only market where more of your plays were read than not.",
                },
                {
                  v: 72,
                  note: "Rooms are nearly half of what Asia answered this summer, the field's biggest lane in any market — and every room you opened was read: Lee Gardens 85, Lee Gardens Three 70, ION 45 and 40.",
                },
                {
                  v: 60,
                  note: "The Lee Gardens café at plus eighty is the warmest room on your shelf; the ION pair at plus seven is the summer's one cold read, judged on its food and its prices.",
                },
              ],
            },
            {
              label: "South Korea",
              cells: [
                {
                  v: 40,
                  note: "No play ran in Korea and no room was opened; what reached the market was two faces and a campaign — the thinnest footprint of the six.",
                },
                {
                  v: 74,
                  note: "The warmest piece of content on your shelf is Jimin's, read at 75 and plus eighty: the house matters here through what its faces wear on a date — the unit Korea has in full, and the one you do not own.",
                },
                {
                  v: 72,
                  note: "Plus eighty on that campaign, as warm as any read on your shelf — a fandom's warmth, lent for as long as the faces are yours.",
                },
              ],
            },
            {
              label: "Japan",
              cells: [
                {
                  v: 70,
                  note: "Fifteen percent of sales and your second market for three decades; nothing you ran there was read — the Wonder exhibition and the Ginza anniversary read zero on every pass, the Ginza flagship opened too late for one.",
                },
                {
                  v: 38,
                  note: "Japan's field reads what is made by hand in front of people — Hermès' summer class read 80 — and your year there was a heritage show. The Open Heart generation that keeps you second was not addressed.",
                },
                {
                  v: 50,
                  note: "Unmeasured — no read to be warm about. The loyalty is observed, in Gen X's full-price Peretti, not in anything played this summer.",
                },
              ],
            },
            {
              label: "Mainland China",
              cells: [
                {
                  v: 52,
                  note: "The largest part of Asia-Pacific's twenty-eight percent, HardWear and the T bought for themselves; the Sanlitun flagship opened in August, too new for a read, and nothing else ran there.",
                },
                {
                  v: 42,
                  note: "The mainland answers an authored place — Saint Laurent's Beijing exhibition read 80, Vuitton's Shanghai concept store 60 — and your place there is weeks old.",
                },
                {
                  v: 42,
                  note: "Unmeasured; the fans there are one piece deep and warm about the piece, not yet about the house.",
                },
              ],
            },
            {
              label: "Europe",
              cells: [
                {
                  v: 28,
                  note: "Eleven percent of sales; two plays in the region all summer — a window in Milan and a film — against the houses' three hundred and thirty-six, and neither was read.",
                },
                {
                  v: 22,
                  note: "Europe answers rooms and shows — two thirds of what it read — and collabs most reliably of all; you have no stage and no room there, and Place Vendôme is Cartier's street.",
                },
                {
                  v: 30,
                  note: "Unmeasured; what warmth you have is the vintage trade's, where London and Paris dealers price your silver.",
                },
              ],
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "At home fewer than four in ten of your plays were read against three in four of the houses' — reach by sales is not reach by play; abroad you were read at the field's rate in Asia and not at all in Europe, where you ran two plays to the houses' three hundred.",
          title: "Reach: the plays read, you against the houses",
          provenance: "measured",
          note: "Of the plays run in each region since April, the share that registered any read — against the same share for the eleven luxury houses and Pandora. The tail is how many plays you ran there. Worldwide is the shelf with no city: campaigns, drops, collaborations. A read that finds nothing is a limit of our search, never proof nobody noticed. Tap a row.",
          mode: "pair",
          a: { label: "Your plays read", color: "#60A5FA" },
          b: { label: "The houses' plays read", color: "#B388FF" },
          rows: [
            {
              id: "north-america",
              label: "North America",
              sub: "home · galas, exhibitions, the clock",
              a: 38,
              b: 75,
              tail: "18 plays",
              note: "Six of sixteen pulsed plays read at home: the lit flagship on the Knicks' night 80, the CFDA award 75, the two Garden Series parties 60, the Origami evenings 55, the Landmark experience 45. The clock, the bodega, the Blue Book gala, the Treasures exhibition and the US Open pop-up read nothing — ten plays, all in your own rooms or your own tent.",
            },
            {
              id: "asia-pacific",
              label: "Asia-Pacific",
              sub: "Hong Kong, Singapore, Bangkok, Tokyo",
              a: 50,
              b: 60,
              tail: "17 plays",
              note: "Seven of fourteen read — four rooms, two archive plays and one evening. Tokyo's two plays and the Ginza anniversary read nothing on every pass; the two August openings, Ginza and Sanlitun, are unread because they are new.",
            },
            {
              id: "worldwide",
              label: "Worldwide",
              sub: "campaigns, drops, collabs — no city",
              a: 64,
              b: 61,
              tail: "56 plays",
              note: "The one place you are read at the houses' rate: thirty-four of fifty-three pulsed plays, led by the Timer 85, Jimin's campaign 75, the Legendary Bird 75, Pharrell's Titan and Frankenstein 70. This is the shelf the whole world sees — and the one with no market in it.",
            },
            {
              id: "europe",
              label: "Europe",
              sub: "a window in Milan, a film",
              a: 0,
              b: 67,
              tail: "2 plays",
              tailLow: true,
              note: "Nothing read: the Devil Wears Prada window and the film released in the region were pulsed nine times between them and registered nothing. The houses ran three hundred and thirty-six plays in Europe this summer and two in three were read.",
            },
          ],
        },
        {
          kind: "stacks",
          insight:
            "Asia answers a room, Europe a room or a show, home a stage with a face on it — and the one market where what you ran is what the market answers is Asia, which is why your best reads of the summer are two cafés.",
          title: "Relevance: what each market answered",
          provenance: "measured",
          note: "Every hundred plays the luxury houses had READ in a region since April, by the shape of the play — a stage (a show, a gala, a premiere), a room (a store, a café, an exhibition of their own), content, a collaboration, a drop (a capsule or an object), an archive return. What a market answers is what it is relevant to. Tap a row for what you ran there against it.",
          legend: [
            { key: "stage", label: "A stage", color: "#FF9F43" },
            { key: "room", label: "A room", color: "#4ADE80" },
            { key: "content", label: "Content", color: "#60A5FA" },
            { key: "collab", label: "A collab", color: "#B388FF" },
            { key: "drop", label: "A drop", color: "#FDE047" },
            { key: "archive", label: "An archive return", color: "#D7A97C" },
          ],
          rows: [
            {
              id: "north-america",
              label: "North America",
              sub: "a stage with a face on it",
              parts: [
                { key: "stage", v: 33 },
                { key: "room", v: 24 },
                { key: "content", v: 10 },
                { key: "collab", v: 17 },
                { key: "drop", v: 16 },
                { key: "archive", v: 0 },
              ],
              note: "A third of what home answered was a stage — the Met Gala, a premiere, a cruise show, a World Cup party — and the stage reads hardest here, 67 on average. You ran nine stages at home, all of them yours: garden parties, galas, an exhibition opening, a clock unveiled. The three read were the city's title, the trade's award and a garden party.",
            },
            {
              id: "asia-pacific",
              label: "Asia-Pacific",
              sub: "a room — nearly half",
              parts: [
                { key: "stage", v: 16 },
                { key: "room", v: 44 },
                { key: "content", v: 17 },
                { key: "collab", v: 5 },
                { key: "drop", v: 17 },
                { key: "archive", v: 1 },
              ],
              note: "Nearly half of what Asia answered was a room — Vuitton's café in Bangkok, Dior's Gold House, Hermès' class in Japan — the biggest single lane in any market. Your four rooms there were all read; your eight stages, one. This is the market where you ran what it answers.",
            },
            {
              id: "europe",
              label: "Europe",
              sub: "a room, then a show",
              parts: [
                { key: "stage", v: 30 },
                { key: "room", v: 38 },
                { key: "content", v: 10 },
                { key: "collab", v: 10 },
                { key: "drop", v: 10 },
                { key: "archive", v: 2 },
              ],
              note: "Rooms and shows are two thirds of what Europe answered — the couture shows, Jacquemus' beach club, Hermès' new Bond Street — and collaborations were read most reliably of all, five in six. You ran a window and a film.",
            },
            {
              id: "worldwide",
              label: "Worldwide",
              sub: "a drop, then content",
              parts: [
                { key: "stage", v: 1 },
                { key: "room", v: 0 },
                { key: "content", v: 31 },
                { key: "collab", v: 15 },
                { key: "drop", v: 42 },
                { key: "archive", v: 11 },
              ],
              note: "Drops and content are three quarters of what the world answered without a city, and your worldwide shelf is the same mix — twenty-one pieces of content, fifteen drops, ten collaborations, nine returns — read at the field's rate. The shelf is relevant; the markets are where it is not.",
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "Wherever you are read you are warm — at home warmer than any house's typical read, with no criticism all summer — and the one cold read on the shelf is a café in Singapore judged on its food and its prices.",
          title: "Resonance: how warm a read lands, market by market",
          provenance: "measured",
          unit: "Warmth of a read, 0 to 100 — praise against criticism",
          note: "Each row is a market; the band is the field's range of warmth in that region — the median and upper quartile of the luxury houses' read plays — the ring the warmest house play in that city, the dots your own plays read there. A market with no dot had nothing read this summer. Tap a row.",
          rows: [
            {
              id: "new-york",
              label: "New York",
              sub: "home — warm, and rarely read",
              typical: 47,
              ceiling: 60,
              best: {
                brandName: "Gucci",
                title: "2026 Met Gala",
                pts: 93,
              },
              own: [
                { title: "The CFDA award", pts: 73 },
                { title: "The Knicks' night, the lit flagship", pts: 73 },
                { title: "The Garden Series party", pts: 53 },
                { title: "East Hampton", pts: 53 },
                { title: "The Origami evenings", pts: 47 },
                { title: "The Landmark experience", pts: 40 },
              ],
              status: "recommended",
              note: "Every read at home landed warm and none landed cold — the warmest market you have, and the one where ten plays in sixteen were never read at all. The field's warmest home read is a face on the Met steps.",
            },
            {
              id: "hong-kong",
              label: "Hong Kong",
              sub: "the café and the flagship",
              typical: 53,
              ceiling: 60,
              best: {
                brandName: "Chanel",
                title: "Signes & Symboles, the Hong Kong launch",
                pts: 60,
              },
              own: [
                { title: "Lee Gardens flagship and café", pts: 80 },
                { title: "Lee Gardens Three", pts: 60 },
              ],
              note: "The warmest room on your shelf — above the field's ceiling and above the warmest house play in the city. A store and a café, reviewed by people who sat in it.",
            },
            {
              id: "singapore",
              label: "Singapore",
              sub: "ION Orchard — the cold read",
              typical: 53,
              ceiling: 60,
              best: {
                brandName: "Dior",
                title: "Dior Paradise, with Tatler Singapore",
                pts: 67,
              },
              own: [
                { title: "The Sixteen Stone watch", pts: 53 },
                { title: "The ION Orchard café", pts: 7 },
                { title: "The ION reopening", pts: 7 },
              ],
              note: "The Singapore-only watch read warm; the café and the renovated flagship read at plus seven — praised for the room, criticised for the food and the prices. The one criticism of your summer, and it is a review.",
            },
            {
              id: "bangkok",
              label: "Bangkok",
              sub: "the evening and the wrap",
              typical: 53,
              ceiling: 60,
              best: {
                brandName: "Dior",
                title: "Dior Gold House, Bangkok",
                pts: 73,
              },
              own: [
                { title: "The Legendary Legacy evening", pts: 47 },
                { title: "The HardWear building wrap", pts: 47 },
              ],
              note: "Two warm reads under the field's typical; the exhibition itself was not read. The city's warmest house play is a house — Dior's Gold House, a room.",
            },
            {
              id: "japan",
              label: "Japan",
              sub: "Tokyo, Ginza — nothing read",
              typical: 53,
              ceiling: 60,
              best: {
                brandName: "Hermès",
                title: "The Skills Academy summer class",
                pts: 67,
              },
              note: "No read, so no warmth: the Wonder exhibition and the Ginza anniversary registered nothing on six passes each. The field's warmest Japan play was a class where things were made by hand in front of people.",
            },
            {
              id: "seoul",
              label: "Seoul",
              sub: "no play — two faces",
              typical: 53,
              ceiling: 60,
              best: {
                brandName: "Hermès",
                title: "Mystery at the Grooms, the Seoul stop",
                pts: 73,
              },
              note: "Nothing of yours ran in Seoul. The warmth Korea gives you is on the worldwide shelf — Jimin's campaign at plus eighty, as warm as any read you have — and it belongs to a fandom, not to a room of yours.",
            },
            {
              id: "china",
              label: "Mainland China",
              sub: "Sanlitun — too new for a read",
              typical: 53,
              ceiling: 60,
              best: {
                brandName: "Saint Laurent",
                title: "No. 223, the Rive Droite Beijing exhibition",
                pts: 67,
              },
              note: "The flagship opened in August and nothing else ran there. The field's warmest mainland reads are authored places — a photography exhibition in Beijing, a concept store in Shanghai.",
            },
            {
              id: "europe",
              label: "Europe",
              sub: "a window and a film — unread",
              typical: 53,
              ceiling: 60,
              best: {
                brandName: "Hermès",
                title: "Into the Horsescape, the high-jewelry presentation",
                pts: 80,
              },
              note: "Two plays, neither read. The field's warmest European read is a jeweler's high-jewelry presentation in Paris — the stage you do not have there.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Your culture index is highest where you are smallest — two cities and a fandom — and lowest where you are a gift; home sits in the middle, the most known and the least answered.",
          title: "Six markets, ranked",
          provenance: "projected",
          note: "The three units folded into one index per market, 0 to 100, weighted the way the Culture Index weights them — relevance carries most, reach about a sixth, resonance about a tenth. Fast clock: a market that answers within weeks, in reads and posts. Slow clock: one that answers over years, in loyalty and full price. Tap a market for its three reads.",
          rows: [
            {
              id: "hong-kong-singapore",
              label: "Hong Kong and Singapore",
              context: "Answered — the rooms",
              score: 69,
              role: "Relevant and read",
              horizon: "long",
              drivers: [
                "Reach: your deepest clients abroad and the café queue; five of seven plays read — the only market where more of your plays were read than not.",
                "Relevance: rooms are nearly half of what Asia answered, the field's biggest lane in any market, and every room you opened was read — Lee Gardens 85, Lee Gardens Three 70, ION 45 and 40; your exhibitions and galas there, one read in four.",
                "Resonance: the Lee Gardens café at plus eighty is the warmest room on your shelf; the ION pair at plus seven is the summer's one cold read, judged on food and price.",
              ],
            },
            {
              id: "korea",
              label: "South Korea",
              context: "Relevant through two faces",
              score: 68,
              role: "Borrowed relevance",
              horizon: "short",
              drivers: [
                "Reach: no play ran in Korea this summer and no room was opened; what reached the market was two faces and a campaign — the thinnest footprint of your six.",
                "Relevance: the warmest piece of content on your shelf is Jimin's, read at 75 and plus eighty — the house matters here through what its faces wear on a date, the one unit Korea has in full.",
                "Resonance: plus eighty on that campaign, as warm as any read on your shelf — a fandom's warmth, lent to you for as long as the faces are yours.",
              ],
            },
            {
              id: "united-states",
              label: "United States",
              context: "Known, half-heard",
              score: 56,
              role: "Reach without relevance",
              horizon: "long",
              drivers: [
                "Reach: forty-four percent of sales and seventy-two percent of your site's visitors; of sixteen plays at home, six were read — the houses' home plays were read three times in four.",
                "Relevance: home answers a stage with a face on it — the Met steps, a premiere, a cruise show — and fandom is its best-received strategy; you ran nine galas and exhibitions in your own rooms and tagged fandom on one play in ten. The two reads above seventy were the city's title and the trade's award.",
                "Resonance: when home reads you it is the warmest market on your shelf — plus seventy-three for the lit flagship and the CFDA award, no criticism all summer, above every house's typical read.",
              ],
            },
            {
              id: "japan",
              label: "Japan",
              context: "Reach without a read",
              score: 45,
              role: "Loyal and unaddressed",
              horizon: "long",
              drivers: [
                "Reach: fifteen percent of sales and your second market for three decades; nothing you ran there this summer was read — the Wonder exhibition and the Ginza anniversary read zero on every pass, the Ginza flagship opened too late for one.",
                "Relevance: Japan's field reads what is made by hand in front of people — Hermès' summer class read 80 — and your year there was a heritage show; the Open Heart generation that keeps you second was not addressed.",
                "Resonance: unmeasured — no read to be warm about; the loyalty is observed, in Gen X's full-price Peretti, not in anything played this summer.",
              ],
            },
            {
              id: "china",
              label: "Mainland China",
              context: "Product fans, no read yet",
              score: 44,
              role: "A place weeks old",
              horizon: "short",
              drivers: [
                "Reach: the largest part of Asia-Pacific's twenty-eight percent, HardWear and the T bought for themselves; the Sanlitun flagship opened in August, too new for a read, and nothing else ran there.",
                "Relevance: the mainland answers an authored place — Saint Laurent's Beijing exhibition read 80, Vuitton's Shanghai concept store 60 — and your place there is weeks old.",
                "Resonance: unmeasured; the fans there are one piece deep and warm about the piece, not yet about the house.",
              ],
            },
            {
              id: "europe",
              label: "Europe",
              context: "Nothing to read",
              score: 24,
              role: "A gift and a tourist's stop",
              horizon: "long",
              drivers: [
                "Reach: eleven percent of sales; two plays in the region all summer — a window in Milan and a film — against the houses' three hundred and thirty-six, and neither was read.",
                "Relevance: Europe answers rooms and shows — two thirds of what it read — and collabs most reliably of all; you have no stage and no room there, and Place Vendôme is Cartier's street.",
                "Resonance: unmeasured; what warmth you have is the vintage trade's, where London and Paris dealers price your silver.",
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "One move per unit, each where that unit is weakest: relevance at home by putting your faces on the city's stage, reach in Europe with the one room you know how to run, resonance in Asia by giving the rooms the fandom's warmth — each at or under the advisor's smallest pick.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "Your faces on the city's stage — ROSÉ and Jimin wear the Lock on the Met steps, the house's own night there",
              itemType: "event",
              window:
                "May · the first Monday of the Met — two faces, the Lock in silver, the Fifth Avenue window dressed the same night, their posts before your press",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "identity_signal", fit: 0.6 },
                { code: "aesthetic_innovation", fit: 0.4 },
              ],
              why: "At home you are the most known and the least answered: six of sixteen plays read, the field's three in four. What home answered this summer was a stage with a face on it — Gucci on the Met steps read 90 and warm at plus ninety-three, Jacquemus there 85, a premiere, a cruise show at the Frick — and fandom is the best-received strategy at home, which you tag on one play in ten. Your two faces are the warmest thing on your shelf, and the record has not read them on a New York stage for you. Put them on the steps with the Lock and the city reads you the way it read the Knicks: as its own.",
              effect: {
                label: "CIQ",
                delta: 0.4,
                series: [0, 0.2, 0.3, 0.37, 0.4],
              },
              precedents: 7,
              reception: "a face on the home stage reads at 80 to 90",
              similar: [
                {
                  brand: "saint-laurent",
                  brandName: "Saint Laurent",
                  title:
                    'Kourtney Kardashian Dressed in Saint Laurent at "Travis Barker: Louder Than Fear" Premiere',
                  pts: 38.3,
                },
                {
                  brand: "jacquemus",
                  brandName: "Jacquemus",
                  title: "Jacquemus at the Met Gala 2026",
                  pts: 37.1,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title:
                    "Charlize Theron in Dior at 'The Odyssey' New York City Premiere",
                  pts: 36.8,
                },
              ],
            },
            {
              name: "The Blue Box Café at Old Bond Street — a room of yours in Europe",
              itemType: "experience",
              window:
                "Spring · the first floor of Old Bond Street, bookable, a Peretti counter at the door — no gala, a room the city can sit in",
              strategies: [
                { code: "identity_signal", fit: 0.6 },
                { code: "aesthetic_innovation", fit: 0.5 },
                { code: "fandom", fit: 0.4 },
              ],
              why: "Europe is the one market where you have nothing to be read: two plays all summer, a window and a film, neither registered, while the houses ran three hundred and thirty-six and two in three were read. What Europe answers is a room — the largest share of its reads — and your room is the one play of yours that has carried everywhere it opened: Hong Kong 85, Singapore 45, the Landmark at home. London is where your silver is priced by dealers and where the house has a flagship and no room the record has read; give the street the room, and Europe has something of yours to read.",
              effect: {
                label: "CIQ",
                delta: 0.3,
                series: [0, 0.12, 0.22, 0.28, 0.3],
              },
              precedents: 8,
              reception: "a house's room in Europe reads at 75 to 85",
              similar: [
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title: "Gucci X La Rose des Vents",
                  pts: 46.2,
                },
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title: "Hermès Maison Bond Street London Flagship Opening",
                  pts: 45.5,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Dior Spa at Belmond Hotel Cipriani, Venice",
                  pts: 43.7,
                },
              ],
            },
            {
              name: "A reason to come back — the café's menu by the faces, a season at a time, in every Asian room",
              itemType: "experience",
              window:
                "Autumn · Lee Gardens, ION, Ginza and Sanlitun together — Jimin's set first, ROSÉ's in spring, the piece of the season on the table and nowhere else",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "scarcity", fit: 0.4 },
                { code: "identity_signal", fit: 0.4 },
              ],
              why: "Asia is where you ran what the market answers — rooms, nearly half of what it read — and your rooms there are the summer's best reads and its one cold one: Lee Gardens at plus eighty, ION at plus seven, judged on its food and its prices. Ginza and Sanlitun opened in August and have not been read yet. The warmest content on your shelf is a fandom's — Jimin's campaign at plus eighty, level with Lee Gardens — and the fandom has never been in a room of yours. A seasonal menu chosen by the faces, with the season's piece on the table, gives four rooms the one thing the field's warm Asian rooms had: a crowd that already loved something, and a reason to return.",
              effect: {
                label: "CIQ",
                delta: 0.3,
                series: [0, 0.12, 0.22, 0.28, 0.3],
              },
              precedents: 6,
              reception: "a fandom in a room reads at 75 to 85",
              similar: [
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title: "Starbucks and POP MART Celebrate 20 Years of MOLLY",
                  pts: 58.5,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    'Louis Vuitton "Louis, The Boat" LV Café and "Visionary Journeys" Exhibition',
                  pts: 42.9,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Dior Gold House, Bangkok",
                  pts: 29.6,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on the field's measured plays of the same shape in the same region — a face on a home stage, a house's room in Europe, a fandom in an Asian room — scaled to the size of your record there. Each is at or under the advisor's smallest archive pick, so the slate's order stands.",
        },
        {
          kind: "impact",
          title: "What the Met steps carry",
          provenance: "projected",
          delta: 0.4,
          body: "Two faces on the Met steps with the Lock carry a projected lift on your published score over the following two windows — most of it in the first, as the home market reads a play of yours the way it reads the houses', the rest as the London room and the Asian menus follow. The three together are the first moves on the three units where each is weakest; none reaches the advisor's smallest archive pick, so the slate stands.",
        },
        {
          kind: "modelView",
          body: "Your reach is American and your relevance is Asian, and the two have never met. At home you are nearly half the sales and nearly three in four of the visitors, and the summer's plays were read less than half as often as the houses' — because you played them in your own rooms, as galas and exhibitions, in a city that answers a face on a public stage. When home did read you it was the warmest market on your shelf. In Hong Kong and Singapore you ran rooms, which is what Asia answers, and every room was read: the warmest play you have abroad and the one cold one are both cafés. Korea answers you through two faces who are the warmest thing you own and are not yours. Japan is your second market and read nothing; the mainland is a flagship weeks old; Europe had a window and a film.\n\nSo the moves are one per unit, each where it is weakest. Put the faces on the Met steps and let home read a play of yours as it read the Knicks' night. Give Europe the one room you know how to run, on the street where your silver is already priced. And give Asia's rooms the fandom's warmth, a season at a time, so the queue comes back. The shelf the whole world sees is already read at the field's rate; it is the markets that are not.",
        },
      ],
    },
  ],
};
